<template>
    <div class="contect">
        <!-- 头部导航公共组件 -->
        <!-- <Header :iseNavigat="isChildeNavigat" :isScroll="isScroll"></Header> -->
        <!-- <section class="contect-mian">
            <img src="../assets/images/contect_1.jpg" />
        </section>
        <section class="contect-mian">
            <img src="../assets/images/contect_2.jpg" />
        </section>
        <section class="contect-mian">
            <img src="../assets/images/contect_3.jpg" />
        </section> -->
        <div class="Image-Preview-box">
            <div style="position: fixed;z-index: 999;right: 20px;top: 20px;cursor: pointer;" >
                <img src="../assets/images/close-white.png" @click="handelImagePreviewClose" />
            </div>
            <el-carousel :interval="0" :initial-index="activeIndexInitial" arrow="always" :autoplay="false" :loop="false" class="Image-Preview-box" ref="carousel" v-model="activeIndex" @change="handleArrowClick">
                <!-- <button class="carousel-control prev"><img src="../assets/images/button-right.png" alt="Previous"></button> -->
                <el-carousel-item v-for="(item, index) in contectList" :key="index">
                    <section class="Image-Preview-box" v-if="index == 2">
                        <img :src="item" @contextmenu.prevent/>
                        <div class="silder-box-list">
                            <ul>
                                <li @click="handleFullImages(0)">
                                    <!-- <div class="trigger-model">
                                        <img class="black_circle" src="../assets/images/Black_circle.png" />
                                        <img class="black_hands" src="../assets/images/Black_hands.png" />
                                    </div> -->
                                    
                                </li>
                                <li @click="handleFullImages(1)">
                                    <!-- <div class="trigger-model" style="left: 52%;">
                                        <img class="black_circle" src="../assets/images/white_circle.png" />
                                        <img class="black_hands" src="../assets/images/white_hand.png" />
                                    </div> -->
                                </li>
                                <li @click="handleFullImages(2)">
                                    <!-- <div class="trigger-model" style="left: 52%;">
                                        <img class="black_circle" src="../assets/images/Black_circle.png" />
                                        <img class="black_hands mvoehands" src="../assets/images/Black_hands.png" />
                                    </div> -->
                                </li>
                            </ul>
                        </div>
                    </section>
                    <section class="Image-Preview-box" @click="handelImagesExitFullscreen" v-else>
                        <img :src="item" @contextmenu.prevent/>
                    </section>
                </el-carousel-item>
            </el-carousel>
        </div>

        <!-- 登录界面 -->
         <el-dialog
            title=""
            :visible.sync="LogindialogVisible"
            custom-class="LoginDialogModel"
            width="700px"
            :before-close="handleLoginClose">
            <div slot="title" class="dialog-header-login">
                <img v-if="fullIndex == 1" src="../assets/images/cover/logo-header_1.png" style="width: 290px;margin-top: 15px;"/>
                <img v-if="fullIndex == 2" src="../assets/images/cover/logo-header.png" style="width: 290px;margin-top: 15px;"/>
            </div>
            <div class="login-content">
                <div class="loginInput-model">
                    <el-input
                        placeholder="请输入邮箱 Please enter your email address"
                        type="text"
                        prefix-icon="el-icon-user-solid user-icon-size prefixIcon"
                        v-model="emailstr">
                    </el-input>
                </div>
                <div class="loginInput-model">
                    <el-input
                        placeholder="请输入密码 Enter password"
                        type="password"
                        prefix-icon="el-icon-lock prefixIcon"
                        v-model="emailstrpassword">
                    </el-input>
                </div>

                <div style="text-align: center;padding-top: 15px;">
                     <el-button type="primary" style="border: 1px solid #000;font-family: 'ahronbd';" @click="handelReceiptEmailInfo">Sign In <strong style="font-family: 'SourceHanSansBOLD'">专线登录</strong></el-button>

                     <el-button type="primary" style="background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;font-family: 'ahronbd';" @click="handleRegistApplicat" v-if="fullIndex == 2">Sign Up<strong style="font-family: 'SourceHanSansBOLD'">注册申请</strong></el-button>
                     <el-button type="primary" style="background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;font-family: 'ahronbd';" @click="handleRegistApplicat" v-if="fullIndex == 1">Registration <strong style="font-family: 'SourceHanSansBOLD'">信息备案</strong></el-button>
                </div>
            </div>
        </el-dialog>
        

        <div class="Image-Preview-full-box" v-if="isFullImags">
            <div style="position: fixed;z-index: 999;right: 20px;top: 20px;cursor: pointer;" >
                <img src="../assets/images/close-white.png" @click="handleCloseImges" />
            </div>
            <div style="position: relative;width: 100%;height: 100%;" v-if="fullIndex == 0">
                <img :src="contectListFull[fullIndex]" ref="image" style="width: 100%;height: 100%;object-fit: contain;" @contextmenu.prevent>
                <div style="width: 8%;height: 15%;position: absolute;right: 37%;bottom: 19%;"><a style="width: 100%;height: 100%;display: block" href='https://xhslink.com/m/3hYxExkFGmx' target="_blank"></a></div>
            </div>
            

            <div :class="[isScrollBox ? 'modelHeight' : '']" v-if="fullIndex == 1 || fullIndex == 2">
                <!-- <el-scrollbar style="height: 100%;"> -->
                <div class="transformFull"  :style="{ transform: `scale(${scaleRatio})` }">
                    <div v-if="fullIndex == 1">
                        <div class="project-commission-header">
                            <h1>Project Dedicated Line</h1>
                            <h2>项目委托专线</h2>
                        </div>
                        <div class="project-commission-text">
                            如果您们的项目需寻求合作且追求卓越，可以通过此表格，邮箱或微信来函提供项目基础信息，<br/>我们将尽快由相应的专人跟进及回应。
                        </div>
                        <div class="project-commission-en-text">
                            <p>If you are seeking collaboration for your project and pursue excellence,</p>
                            <p>please provide basic project information via this form, email, or WeChat.</p>
                            <p>We will have a dedicated specialist follow up and respond to you as soon as possible.</p>
                        </div>
                    </div>
                    <div v-if="fullIndex == 2">
                        <div class="project-commission-header">
                            <h1>Project Partner Line</h1>
                            <h2>项目合伙人专线</h2>
                        </div>
                        <div class="project-commission-text">
                            如果您有具体的项目资源和渠道，也有对项目高品质的社会使命感，可以相互合作<br/>共同为客户创造价值。请用此邮箱或微信来函商讨合作。
                        </div>
                        <div class="project-commission-en-text">
                            <p>If you have proven project resources and a shared commitment to excellence, </p>
                            <p>let's collaborate to deliver exceptional value for our clients.</p>
                            <p>Please reach out via the email or WeChat below to discuss a potential partnership.</p>
                        </div>
                    </div>
                    

                    <div class="wechat-modle">
                        <div class="wechat-mail-box">
                        
                            <div style="display: inline-block;text-align: center;padding-top: 45px;">
                                <div style="display: flex;flex-direction: row;justify-content: center;">
                                    <a href='https://www.facebook.com/people/CTG/61588263814671' target="_blank">
                                        <img style="width: 30px;margin-right: 30px;height: auto;" src='../assets/images/video/icon_1.png'/>
                                    </a>
                                    <a href='https://www.instagram.com/ctg_designcenter?utm_source=qr' target="_blank">
                                        <img style="width: 30px;margin-right: 30px;height: auto;" src='../assets/images/video/icon_2.png'/>
                                    </a>
                                    <a href='https://xhslink.com/m/3hYxExkFGmx' target="_blank">
                                        <img style="width: 30px;margin-right: 30px;height: auto;" src='../assets/images/video/icon_3.png'/>
                                    </a>
                                    <a href='https://weibo.com/u/4030830049' target="_blank">
                                        <img style="width: 34px;margin-right: 15px;height: auto;position: relative;top:-3px" src='../assets/images/video/icon_4.png'/>
                                    </a>
                                    
                                </div>
                                <h1 style="padding-top: 50px;">E-mail ：</h1>
                                <h2>PdA@citygroup.com.cn</h2>
                                <div class="wechat-box">
                                    <h1><strong>WeChat</strong><span>微 信</span></h1>
                                    <img src="../assets/images/wechat_img.png"/>
                                </div>
                                <div style="font-size: 17px;margin-top: 24px;"><span style="font-family: 'ahronbd';">Guangzhou</span> <span style="font-family: 'SourceHanSansBOLD'">广州</span> <span style="font-family: 'ahronbd';margin-left: 10px;">London</span> <span style="font-family: 'SourceHanSansBOLD'">伦敦</span></div>
                            </div>
                        </div>
                        <div class="commission-line-info">
                            <!-- projectContactTrac -->
                            <!-- , Pixel_one ? 'project-contact-info-Pixel_one' : Pixel_two ? 'projectContactTrac' : Pixel_tree ? 'projectContactTracTree' : Pixel_foure ? 'projectContactTracFoure' : Pixel_five ? 'projectContactTracFive' : Pixel_six ? 'projectContactTracSix' : Pixel_seve ? 'projectContactTracSven' : '' -->
                            <div class="project-contact-info" v-if="fullIndex == 1 || fullIndex == 2">
                                <!-- 语言切换按钮 -->
                                <div class="language-toggle">
                                    <button :class="['language-btn', infoIndex == 1 ? 'active' : '']" data-lang="en" @click="handleCahge(1)">
                                        <span style="font-family: 'ahronbd';font-size: 17px;">English</span> 
                                        <span style="font-family: 'SourceHanSans';font-size: 17px;padding-left: 3px;">英语区域</span>
                                    </button>
                                    <button :class="['language-btn', infoIndex == 2 ? 'active' : '']"  data-lang="zh" @click="handleCahge(2)" >
                                        <span style="font-family: 'ahronbd';font-size: 17px;">Chinese</span>
                                        <span style="font-family: 'SourceHanSans';font-size: 17px;padding-left: 3px;">中文区域</span>
                                    </button>
                                </div>

                                <!-- 英文表单 -->
                                <div class="form-container" id="english-form" v-if="infoIndex == 1">
                                    <div class="name-row">
                                        <div class="name-field">
                                            <div class="name-label">Name</div>
                                            <label>First Name<span class="required">(required)</span></label>
                                            <input type="text" v-model="enfname" required style="width: 92%;">
                                        </div>
                                        <div class="name-field">
                                            <div class="name-label"></div>
                                            <label>Last Name<span class="required">(required)</span></label>
                                            <input type="text" v-model="enlname" required style="width: 92%;">
                                        </div>
                                    </div>

                                    <div style="margin-bottom: 18px;">
                                        <label>Email Address<span class="required">(required)</span></label>
                                        <input type="email" v-model="enaddress" required>
                                    </div>

                                    <div class="name-row">
                                        <div class="name-field">
                                            <label>Contact number<span class="required">(required)</span></label>
                                            <input type="tel" v-model="ennumber" style="width: 92%;">
                                        </div>
                                        <div class="name-field">
                                            <label>Location</label>
                                            <input type="text" v-model="enlocation" required style="width: 92%;">
                                        </div>
                                    </div>

                                    <div style="margin-bottom: 18px;">
                                        <label>Subject<span class="required">(required)</span></label>
                                        <input type="text" v-model="ensubject" required>
                                    </div>

                                    <div style="margin-bottom: 18px;">
                                        <label>Enquiry<span class="required">(required)</span></label>
                                        <textarea style="height: 72px;resize: none;" v-model="enenquiry" required></textarea>
                                    </div>

                                    <div style="width: 130%;">
                                        <button class="submit-btn" style="width: 113px;" @click="handleSumbitInfo(2)">SEND</button>

                                        <!-- <button class="submit-btn" style="margin-left: 15px;background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;width: 40px;padding: 0;"><i class="el-icon-plus" style="font-weight: 700;" @click="handleReceiptEmail(2,'en')"></i></button> -->

                                        <span  v-if="fullIndex == 2" style="font-size: 18px;color: #525151;font-family: 'Arial';font-weight: 700;margin-left: 35px;padding: 11px 0;">* Cooperation Framework</span>
                                        <span v-if="fullIndex == 2" style="font-size: 18px;color: #525151;font-family: 'Arial';font-weight: 700;margin-left: 35px;padding: 11px 0;">* Project Registration</span>

                                        <span  v-if="fullIndex == 1" style="font-size: 18px;color: #525151;font-family: 'Arial';font-weight: 700;margin-left: 35px;padding: 11px 0;white-space: nowrap;">* Project Overview</span>
                                    </div>

                                    


                                    <!-- <button class="submit-btn" style="margin-left: 15px;background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;" v-if="fullIndex == 1" @click="handleProjectOverview(1,'en')">Project Overview</button> -->
                                    <!-- <button class="submit-btn" style="margin-left: 15px;background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;width: 200px;padding: 0;" v-if="fullIndex == 2" @click="handleFramework(1)">Cooperation Framework</button> -->
                                    <!-- <button class="submit-btn" style="margin-left: 15px;background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;width: 200px;padding: 0;" v-if="fullIndex == 2" @click="handleProjectOverview(2,'en')">Project Registration</button> -->
                                </div>

                                <!-- 中文表单 -->
                                <div class="form-container zh" id="chinese-form" v-if="infoIndex == 2">

                                    <div class="name-label"></div>
                                    <div class="name-row">
                                        <div class="name-field">
                                            <label style="font-family: 'SourceHanSans';">姓名<span class="required" style="font-family: 'SourceHanSans';">（必填）</span></label>
                                            <input type="text" v-model="cnname" required style="width: 92%;">
                                        </div>
                                        <div class="name-field">
                                            <label style="font-family: 'SourceHanSans';">所在地<span class="required" style="font-family: 'SourceHanSans';"></span></label>
                                            <input type="text" v-model="cnaddress" style="width: 92%;">
                                        </div>
                                    </div>

                                    <div style="margin-bottom: 18px;">
                                        <label style="font-family: 'SourceHanSans';">电子邮箱<span class="required" style="font-family: 'SourceHanSans';">（必填）</span></label>
                                        <input type="email" v-model="cnemail" required>
                                    </div>

                                    <div style="margin-bottom: 18px;">
                                        <label>联系电话<span class="required" style="font-family: 'SourceHanSans';">（必填）</span></label>
                                        <input type="tel" v-model="cnphone">
                                    </div>

                                    <div style="margin-bottom: 18px;">
                                        <label style="font-family: 'SourceHanSans';">主题<span class="required" style="font-family: 'SourceHanSans';">（必填）</span></label>
                                        <input type="text" required v-model="cnsubject">
                                    </div>

                                    <div style="margin-bottom: 18px;">
                                        <label style="font-family: 'SourceHanSans';">咨询内容<span class="required" style="font-family: 'SourceHanSans';">（必填）</span></label>
                                        <textarea style="height: 72px;resize: none;" required v-model="cnenquiry"></textarea>
                                    </div>

                                    <button class="submit-btn" style="width: 113px;" @click="handleSumbitInfo(1)">发送</button>
                                    <!-- <button class="submit-btn" style="margin-left: 15px;background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;width: 40px;padding: 0;" @click="handleReceiptEmail(1,'cn')"><i class="el-icon-plus" style="font-weight: 700;"></i></button> -->
                                    <!-- <button class="submit-btn" style="margin-left: 15px;background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;" v-if="fullIndex == 1" @click="handleProjectOverview(1,'cn')">项目概括</button> -->
                                    <span v-if="fullIndex == 1" style="font-size: 18px;color: #525151;font-family: 'SourceHanSans';font-weight: 700;margin-left: 35px;padding: 11px 0;">* 项目概括</span>

                                    <span  v-if="fullIndex == 2" style="font-size: 18px;color: #525151;font-family: 'SourceHanSans';font-weight: 700;margin-left: 35px;padding: 11px 0;">* 合作框架</span>
                                    <span v-if="fullIndex == 2" style="font-size: 18px;color: #525151;font-family: 'SourceHanSans';font-weight: 700;margin-left: 35px;padding: 11px 0;">* 项目备案</span>
                                    <!-- <button class="submit-btn" style="margin-left: 15px;background-color: #fff;color: #333;border: 1px solid #fff;" v-if="fullIndex == 2">* 合作框架</button>
                                    <button class="submit-btn" style="margin-left: 15px;background-color: #fff;color: #333;border: 1px solid #fff;" v-if="fullIndex == 2">* 项目备案</button> -->
                                </div>
                                <!-- 提示语弹窗提示 -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- </el-scrollbar> -->
            </div>
        </div>

        <!-- 输入登录回执码 弹窗 -->
        <!-- <el-dialog
            title=""
            :visible.sync="ReceiptEmaildialogVisible"
            :show-close="false"
            width="847px"
            :before-close="handleClose">
            <div style="font-size: 18px;font-family: 'ahronbd';padding-bottom: 15px;" v-if="this.language == 'en'">Please enter your registration receipt code to continue supplementing or updating your information.</div>
            <div style="font-size: 18px;font-family: 'SourceHanSans';padding-bottom: 15px;" v-if="this.language == 'cn'">请输入登记回执码，继续补充或完善信息。</div>
            <el-input v-model="emailstr" placeholder=""></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="handelReceiptEmailClose" v-if="this.language == 'cn'">关闭</el-button>
                <el-button type="danger" @click="handelReceiptEmailClose" v-if="this.language == 'en'">Close</el-button>
                <el-button type="primary" style="background-color: #409eff;border-color: #409eff;" @click="handelReceiptEmailInfo(2)" v-if="this.language == 'en'">Submit</el-button>
                <el-button type="primary" style="background-color: #409eff;border-color: #409eff;" @click="handelReceiptEmailInfo(1)" v-if="this.language == 'cn'">提交</el-button>
            </span>
        </el-dialog> -->


        <!-- 输入登录回执码提示 -->
        <el-dialog
            title=""
            :visible.sync="codePromptdialogVisible"
            custom-class="promptBox"
            width="847px"
            :show-close="false"
            :before-close="handleClose">
            <div style="font-size: 17px;font-family: 'Arial';text-align: center;" v-if="language == 'en'">
                <p style="padding-bottom: 15px;word-break: keep-all;">Sorry, we couldn't find your submitted information at the moment.</p>
                <p style="word-break: keep-all;">If you've recently submitted it, please wait for our review. A dedicated staff member will contact you shortly.</p>
            </div>
            <div style="font-size: 17px;font-family: 'SourceHanSans';text-align: center;" v-if="language == 'cn'">
                <p style="padding-bottom: 15px;">很抱歉，当前未查询到您的录入信息。</p>
                <p>若为近期提交，请等待我们的审核，稍后将有专人和您联系。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'Arial';font-weight: 700;width: 113px;padding: 8px 15px;" @click="handelCodePromptInfo" v-if="language == 'en'">Confirm</el-button>
                <el-button type="primary" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;" @click="handelCodePromptInfo" v-if="language == 'cn'">确 定</el-button>
            </span>
        </el-dialog>


        <div class="Image-Preview-full-box Image-Preview-framework" v-if="isCooperat">
            
            <div class="fullScreenImg" :style="{height: fullScreenHeight + 'px'}" v-if="CoopIndex == 1 || CoopIndex == 0">
                <!-- 不可编辑协议内容 -->
                 <el-scrollbar style="height: 100%;" v-if="!modifyStatus">
                    <div class="agreement-model" style="padding: 0;width: 850px;position: relative;padding: 0px 0px 70px 0px;background: #fff;" v-if="CoopIndex == 1">
                        <div style="cursor: pointer;text-align: right;" @click="handleCloseCooperat">
                            <i class="el-icon-close" style="font-size: 25px;position: absolute;right: 10px;top: 10px;"></i>
                        </div>
                        <img src='../assets/images/video/Cooperation_1.jpg' />

                        <div style="position: absolute;bottom: 25px;width: 100%;">
                           <el-button type="primary" size="small" style="border: 1px solid #4F81BD;background-color: #4F81BD;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;" @click="handleProjectOverview(2,'cn',2)" v-if="fullIndex == 2 && infoIndex == 2">修改</el-button>
                            <el-button type="primary" size="small" style="border: 1px solid #e0e0e0;font-size: 18px;font-family: SourceHanSans;width: 113px;padding: 8px 15px;background-color: #e0e0e0;color: #000;" v-if="fullIndex == 2 && infoIndex == 2" @click="handleProjectOverview(2,'cn',1)">确认</el-button> 
                        </div>
                    </div>

                    <div class="agreement-model" style="padding: 0px 0px 70px 0px;width: 850px;position: relative;background: #fff;" v-if="CoopIndex == 0">
                        <div style="cursor: pointer;text-align: right;" @click="handleCloseCooperat">
                            <i class="el-icon-close" style="font-size: 25px;position: absolute;right: 10px;top: 10px;"></i>
                        </div>
                        <img src='../assets/images/video/Cooperation_2.jpg' />

                        <div style="position: absolute;bottom: 25px;width: 100%;">
                           <el-button type="primary" size="small" style="margin-top: 10px;border: 1px solid #4F81BD;background-color: #4F81BD;font-size: 18px;font-family: 'Arial';width: 113px;padding: 8px 15px;" @click="handleProjectOverview(2,'en',2)" v-if="fullIndex == 2 && infoIndex == 1">Edit</el-button>

                            <!-- <el-button type="primary" style="border: 1px solid #000;margin-top: 10px;" v-if="fullIndex == 2 && infoIndex == 2" @click="handleProjectOverview(2,'cn',1)">认同</el-button> -->

                            <el-button type="primary" size="small" style="border: 1px solid #e0e0e0;margin-top: 10px;font-size: 18px;font-family: 'Arial';width: 113px;padding: 8px 15px;background-color: #e0e0e0;color: #000;" v-if="fullIndex == 2 && infoIndex == 1" @click="handleProjectOverview(2,'en',1)">Confirm</el-button> 
                        </div>
                    </div>

                 </el-scrollbar>
                <!-- 可编辑协议内容 -->
                <el-scrollbar style="height: 100%;" v-if="modifyStatus">
                    <div class="agreement-model" v-if="CoopIndex == 1">
                        <div style="cursor: pointer;position: absolute;right: 10px;top: 10px;" @click="handleCloseCooperat">
                            <i class="el-icon-close" style="font-size: 25px;"></i>
                        </div>
                        <h1 style="font-size: 26px;font-family: 'huawen';margin-top: -10px;">项目拓展及协作协议</h1>
                        <h2 style="font-size: 17px;font-family: '微软雅黑';font-weight: 700;">（项目合伙人）</h2>
                        <div style="font-size: 18px;font-family: '微软雅黑';text-align: left;width: 721px;margin: auto;color: #000;margin-bottom: 35px;margin-top: 39px;line-height: 25px;">甲方以设计质量享有高层建筑及公共建筑室内设计的较高的一线市场地位，基于乙方的客户资源及项目拓展能力，为设计方与业主搭建设计资源的沟通桥梁，为客户提供高品质设计服务，拟进行项目工作协作，协作框架如下：</div>
                        <table class="agreement-table">
                            <tbody>
                                <tr>
                                    <td style="font-family: 'huawen';font-size: 20px;">模式</td>
                                    <td style="font-family: 'huawen';font-size: 20px;">协作深度</td>
                                    <td style="font-family: 'huawen';font-size: 20px;">工作深度</td>
                                    <td style="font-family: 'huawen';font-size: 20px;">合作比例</td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td rowspan="3" style="width: 100px;font-family: 'lanting';font-size: 16px;width: 95px;">A: 推荐对接</td>
                                    <td rowspan="3" style="text-align: left;font-family: 'lanting';font-size: 16px;width: 244px;height: 113px">
                                        <div style="width: 208px;margin: auto;line-height: 22px;">乙方向甲方推荐及对接该项目的相关负责人。</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="text-align: left;font-family: 'lanting';font-size: 16px;height: 48px;">1、项目基层执行负责人。</td>
                                    <td style="width: 110px;">
                                        <div style="display: flex;height: 32px;align-items: center;justify-content: center;">
                                            <span style="font-family: 'lanting';font-size: 16px;">2</span>
                                            <el-input v-model="modify_1.value" size="small" oninput="this.value = this.value.replace(/\D/g, '')" @input="validateInput(1)" :readonly="!modify_1.state" :class="[modify_1.state ? 'modifyInputColor' : 'modifyInput']" style="width: 53px;margin-left: 5px;" v-if='modify_1.state'></el-input><span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;margin-left: 5px;" v-if="modifyStatus" @click="handleModifyEdit(1)"></span>
                                        </div>
                                        
                                    </td> 
                                </tr>
                                <tr>
                                    <td style="text-align: left;font-family: 'lanting';font-size: 16px;height: 48px;">2、项目高层决策负责人。</td>
                                    <td>
                                        <div style="display: flex;height: 32px;align-items: center;justify-content: center;">
                                            <span style="font-family: 'lanting';font-size: 16px;">5</span>
                                            <el-input v-model="modify_2.value" size="small" oninput="this.value = this.value.replace(/\D/g, '')" @input="validateInput(2)" :readonly="!modify_2.state" :class="[modify_2.state ? 'modifyInputColor' : 'modifyInput']" style="width: 53px;margin-left: 5px;" v-if="modify_2.state"></el-input><span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;margin-left: 5px;" v-if="modifyStatus" @click="handleModifyEdit(2)"></span>
                                        </div>
                                    </td> 
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td rowspan="3" style="font-family: 'lanting';font-size: 16px;">B: 项目协作</td>
                                    <td rowspan="3" style="width: 200px;text-align: left;font-family: 'lanting';font-size: 16px;height: 113px">
                                        <div style="width: 208px;margin: auto;line-height: 22px;">乙方向甲方推荐及对接该项目的相关负责人。并作为项目合伙人配合甲方全过程跟业主方进行各个阶段的沟通协作。</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="text-align: left;font-family: 'lanting';font-size: 16px;height: 48px;">3、方案及商务投标方式。</td>
                                    <td>
                                        <div style="display: flex;height: 32px;align-items: center;justify-content: center;">
                                            <span style="font-family: 'lanting';font-size: 16px;">6</span>
                                            <el-input v-model="modify_3.value" size="small" oninput="this.value = this.value.replace(/\D/g, '')" @input="validateInput(3)" :readonly="!modify_3.state" :class="[modify_3.state ? 'modifyInputColor' : 'modifyInput']" style="width: 53px;margin-left: 5px;" v-if="modify_3.state"></el-input><span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;margin-left: 5px;" v-if="modifyStatus" @click="handleModifyEdit(3)"></span>
                                        </div>
                                    </td> 
                                </tr>
                                <tr>
                                    <td style="text-align: left;font-family: 'lanting';font-size: 16px;height: 48px;">4、商务洽谈项目委托方式。</td>
                                    <td>
                                        <div style="display: flex;height: 32px;align-items: center;justify-content: center;">
                                            <span style="font-family: 'lanting';font-size: 16px;">10</span>
                                            <el-input v-model="modify_4.value" size="small" oninput="this.value = this.value.replace(/\D/g, '')" @input="validateInput(4)" :readonly="!modify_4.state" :class="[modify_4.state ? 'modifyInputColor' : 'modifyInput']" style="width: 53px;margin-left: 5px;" v-if="modify_4.state"></el-input><span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;margin-left: 5px;" v-if="modifyStatus" @click="handleModifyEdit(4)"></span>
                                        </div>
                                    </td> 
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td style="font-family: 'lanting';font-size: 16px;">协议说明</td>
                                    <td colspan="3" style="text-align: left;padding: 8px 21px">
                                        <div style="display: flex;line-height: 24px;font-family: 'lanting';font-size: 16px;padding-top: 27px;">
                                            <i style="font-style: normal;display: inline-block;width: 30px;">1&nbsp;）&nbsp;</i>
                                            <span>乙方必需根据国家法律或当地政策规定合法合规进行业务拓展，并遵从甲方的项目管理及报备制度。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(5)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_5.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_5.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 24px;font-family: 'lanting';font-size: 16px;padding: 5px 0;">
                                            <i style="font-style: normal;display: inline-block;width: 25px;">2&nbsp;）&nbsp;</i>
                                            <span>甲方有权根据项目具体情况判断决定是否承接项目或参与项目方案投标等。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;"  @click="handleModifyEdit(6)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_6.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_6.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="line-height: 24px;">
                                            <dl style="font-family: 'lanting';font-size: 16px;">
                                                <dt style="display: flex;padding-bottom: 5px;">
                                                    <i style="font-style: normal;display: inline-block;width: 25px;">3&nbsp;）&nbsp;</i><span>乙方给甲方介绍项目，按如下步骤进行：</span></dt>
                                                <dd style="margin-left: 22px;">第一步，乙方发甲方的公司简介给业主方，让业主方对甲方有初步了解；<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(7)" v-if="modifyStatus"></span></dd>
                                                <dd v-if="modify_7.state">
                                                    <el-input class="autosizeText" type="textarea" v-model="modify_7.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                                </dd>
                                                <dd style="margin-left: 22px;">第二步，乙方协助实现甲方公对公层面正式拜访业主方，形成专业对话局面；<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(8)" v-if="modifyStatus"></span></dd>
                                                <dd v-if="modify_8.state">
                                                    <el-input class="autosizeText" type="textarea" v-model="modify_8.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                                </dd>
                                                <dd style="margin-left: 22px;">第三步，甲方根据客户及项目的具体情况，决策后续的跟进深度和参与深度。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(9)" v-if="modifyStatus"></span></dd>
                                                <dd v-if="modify_9.state">
                                                    <el-input class="autosizeText" type="textarea" v-model="modify_9.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                                </dd>
                                                <dd style="margin-left: 22px;">完成以上步骤后，基于项目合作的需要：</dd>
                                                
                                            </dl>
                                            <dl style="font-family: 'lanting';font-size: 16px;">
                                                <dd  style="margin-left: 22px;display: flex;"><span>A、</span><span>甲方认为有必要的接待，由甲方按公司接待标准及流程执行，乙方参与；甲方认为非必要的接待，甲方不参与、不承担费用。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(10)" v-if="modifyStatus"></span></span></dd>
                                                <dd v-if="modify_10.state">
                                                    <el-input class="autosizeText" type="textarea" v-model="modify_10.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                                </dd>
                                                <dd style="margin-left: 22px;display: flex;"><span>B、</span><span>甲方认为必要的差旅，由甲方按公司差旅标准及流程执行；甲方认为非必要性的差旅，甲方不参与、不承担费用。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(11)" v-if="modifyStatus"></span></span></dd>
                                                <dd v-if="modify_11.state">
                                                    <el-input class="autosizeText" type="textarea" v-model="modify_11.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                                </dd>
                                            </dl>
                                        </div>
                                        <div style="display: flex;line-height: 24px;font-family: 'lanting';font-size: 16px;padding-top: 5px;">
                                            <i style="font-style: normal;display: inline-block;width: 22px;">4&nbsp;）&nbsp;</i>
                                            <span>没有完成上述步骤的接待和差旅，甲方不参与、不承担费用。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(12)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_12.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_12.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 24px;font-family: 'lanting';font-size: 16px;padding-top:5px">
                                            <i style="font-style: normal;display: inline-block;width: 22px;">5 &nbsp;）&nbsp;</i>
                                            <span>乙方承诺甲方是乙方向业主方推荐的同一项目室内专业的唯一公司。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(13)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_13.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_13.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 24px;font-family: 'lanting';font-size: 16px;display: flex;padding-top:5px">
                                            <i style="font-style: normal;display: inline-block;width: 30px;">6&nbsp;）&nbsp;</i>
                                            <span>乙方介绍给甲方的客户，在甲乙双方合作期内，甲方与该名客户产生的任何其他项目的合作，都属于甲乙双方合作的项目。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(14)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_14.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_14.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 24px;font-family: 'lanting';font-size: 16px;padding-top: 5px;display: flex;">
                                            <i style="font-style: normal;display: inline-block;width: 45px;">7&nbsp;）&nbsp;</i>
                                            <span>甲方将根据每个阶段所收到的项目设计款项后2周内按同阶段同比例支付给乙方；双方各付各税，甲方向乙方支付费用前，乙方应向甲方提供合法的含税 完税等额增值税普通服务类发票。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(15)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_15.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_15.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 24px;font-family: 'lanting';font-size: 16px;display: flex;padding-top: 5px;">
                                            <i style="font-style: normal;display: inline-block;width: 24px;">8&nbsp;）&nbsp;</i>
                                            <span>本协议在合作比例以包含了各自运营的成本，除协议说明第3所描述之外不在存在其他任何费用和支出。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(16)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_16.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_16.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 24px;font-family: 'lanting';font-size: 16px;display: flex;padding-top: 5px;">
                                            <i style="font-style: normal;display: inline-block;width: 30px;">9&nbsp;）&nbsp;</i>
                                            <span>公司不参加没有标底费的方案投标活动，如果符合甲方标准并参加投标，所得标底费   部分的10%作为酬劳支付给乙方。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(17)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_17.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_17.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 24px;font-family: 'lanting';font-size: 16px;padding-top: 5px;">
                                            <i style="font-style: normal;display: inline-block;width: 55px;">10&nbsp;）&nbsp;</i>
                                            <span>乙方应全过程协助甲方进行客户关系维护，保证项目能顺利进行至完成项目合同；如乙方中途退出合作，拒绝协助甲方维护客户关系，视为主动终止合作。<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(18)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_18.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_18.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="padding-top: 10px;color:#000;font-weight: 700;font-family: 'lanting';font-size: 17px;" v-if="modifyStatus"><span>增加条款</span><span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(19)"></span></div>

                                        <div v-if="modify_19.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_19.value" resize="none" :autosize="{minRows:5,maxRows:20}"></el-input>
                                        </div>

                                        <div style="padding-top: 16px;font-family: 'lanting';font-size: 16px;padding-bottom: 16px;">以上内容双方将在具体项目合作合同里约定。</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                       
                        <div v-if="modifyStatus">

                            <el-button type="primary" size="small" style="border: 1px solid #4F81BD;background-color: #4F81BD;margin-top: 10px;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;" @click="handleTrueModify" v-if="fullIndex == 2 && infoIndex == 2">返回</el-button>
                            <el-button type="primary" size="small" style="border: 1px solid #e0e0e0;background: #e0e0e0;margin-top: 10px;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;color: #000" @click="handleModifyAgreement" v-if="fullIndex == 2 && infoIndex == 2">提交</el-button>

                        </div>
                        <div v-else>
                            <el-button type="primary" size="small" style="margin-top: 10px;border: 1px solid #4F81BD;background-color: #4F81BD;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;" @click="handleProjectOverview(2,'cn',2)" v-if="fullIndex == 2 && infoIndex == 2">修改</el-button>
                            <!-- <el-button type="danger" style="margin-top: 10px;" @click="handleProjectOverview(2,'en',2)" v-if="fullIndex == 2 && infoIndex == 1">Disagree</el-button> -->

                            <el-button type="primary" size="small" style="border: 1px solid #000;margin-top: 10px;font-size: 18px;font-family: SourceHanSans;width: 113px;padding: 8px 15px;" v-if="fullIndex == 2 && infoIndex == 2" @click="handleProjectOverview(2,'cn',1)">确认</el-button>

                            <!-- <el-button type="primary" style="border: 1px solid #000;margin-top: 10px;" v-if="fullIndex == 2 && infoIndex == 1" @click="handleProjectOverview(2,'en',1)">Agree</el-button> -->
                        </div>
                        
                    </div>

                    <div class="agreement-model agreement-en-model" v-if="CoopIndex == 0">
                        <div style="cursor: pointer;text-align: right;position: absolute;top:10px;right: 10px;" @click="handleCloseCooperat">
                            <i class="el-icon-close" style="font-size: 25px;"></i>
                        </div>
                        <h1 style="font-size: 26px;font-family: 'Arial';margin-top: -10px;">Project Development and Collaboration Agreement</h1>
                        <h2 style="font-size: 17px;font-family: 'Arial';">(Project Partners)</h2>
                        <div style="font-size: 17px;font-family: 'Arial';text-align: left;margin: auto;margin-top: 50px;margin-bottom: 24px;width: 745px;">Party A, with a leading market position in interior design for high-rise buildings and public buildings based on its design quality, and Party B, with strong client resources and project development capabilities, aim to establish a communication bridge between designers and owners, providing high-quality design services to clients. The proposed collaboration framework is as follows:</div>
                        <table class="agreement-table">
                            <tbody>
                                <tr>
                                    <td style="font-family: 'Arial';font-size: 18px;font-weight: 700;">Mode of Cooperation</td>
                                    <td style="font-family: 'Arial';font-size: 18px;font-weight: 700;">Collaboration Depth</td>
                                    <td style="font-family: 'Arial';font-size: 18px;font-weight: 700;">Work Depth</td>
                                    <td style="font-family: 'Arial';font-size: 18px;font-weight: 700;">Cooperation Ratio</td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td rowspan="3" style="width: 100px;font-family: 'Arial';font-size: 16px;text-align: left;font-weight: 700;padding: 8px 8px 8px 10px">I. Project Referral & Introduction</td>
                                    <td rowspan="3" style="text-align: left;font-family: 'Arial';font-size: 16px;width: 300px;padding: 8px 10px 8px 20px;">Party B is responsible for recommending the relevant project principal to connect with the project to Party A.</td>
                                </tr>
                                <tr>
                                    <td style="text-align: left;font-family: 'Arial';font-size: 16px;padding: 8px 10px 8px 20px;height: 60px;">1.Project Primary Execution Leader</td>

                                    <td>
                                        <div style="display: flex;height: 32px;align-items: center;justify-content: center;">
                                            <span style="font-size: 18px">2</span>
                                            <el-input v-model="modify_1.value" size="small" oninput="this.value = this.value.replace(/\D/g, '')" @input="validateInput(1)" :readonly="!modify_1.state" :class="[modify_1.state ? 'modifyInputColor' : 'modifyInput']" style="width: 53px;border: none;margin-left: 5px;" v-if="modify_1.state"></el-input><span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;margin-left: 5px"  v-if="modifyStatus" @click="handleModifyEdit(1)"></span>
                                        </div>
                                        
                                        
                                    </td> 
                                </tr>
                                <tr>
                                    <td style="text-align: left;font-family: 'Arial';font-size: 16px;padding: 8px 10px 8px 20px;width: 175px;height: 60px;">2.Project Senior Executive in Charge of Decision-Making</td>
                                    <td>
                                        <div style="display: flex;height: 32px;align-items: center;justify-content: center;">
                                            <span style="font-size: 18px">5</span>
                                            <el-input v-model="modify_2.value" size="small" oninput="this.value = this.value.replace(/\D/g, '')" @input="validateInput(2)" :readonly="!modify_2.state" :class="[modify_2.state ? 'modifyInputColor' : 'modifyInput']" style="width: 53px;border: none;margin-left: 5px;" v-if="modify_2.state"></el-input><span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;margin-left: 5px;" v-if="modifyStatus" @click="handleModifyEdit(2)"></span>
                                        </div>
                                        
                                    </td> 
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td rowspan="3" style="width: 100px;font-family: 'Arial';font-size: 16px;text-align: left;font-weight: 700;padding: 8px 8px 8px 10px">II. Project Collaboration</td>
                                    <td rowspan="3" style="text-align: left;font-family: 'Arial';font-size: 16px;width: 300px;padding: 8px 10px 8px 20px;">Party B shall recommend and coordinate the relevant personnel responsible for the project to Party A. Additionally, as a project partner, Party B shall collaborate with Party A throughout the entire process, engaging in communication and coordination with the owner at various stages.</td>
                                </tr>
                                <tr>
                                    <td style="text-align: left;font-family: 'Arial';font-size: 16px;padding: 8px 10px 8px 20px;width: 175px;height: 60px;">3.Requiring a commercial bid and a design proposal bid</td>
                                    <td>
                                        <div style="display: flex;height: 32px;align-items: center;justify-content: center;">
                                            <span style="font-size: 18px">6</span>
                                            <el-input v-model="modify_3.value" oninput="this.value = this.value.replace(/\D/g, '')" size="small" @input="validateInput(3)" :readonly="!modify_3.state" :class="[modify_3.state ? 'modifyInputColor' : 'modifyInput']" style="width: 53px;border: none;margin-left: 5px;" v-if="modify_3.state"></el-input><span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;margin-left: 5px;" v-if="modifyStatus" @click="handleModifyEdit(3)"></span>
                                        </div>
                                    </td> 
                                </tr>
                                <tr>
                                    <td style="text-align: left;font-family: 'Arial';font-size: 16px;padding: 8px 10px 8px 20px;width: 175px;height: 60px;">4.Carrying out business negotiations and direct entrustment</td>
                                    <td>
                                        <div style="display: flex;height: 32px;align-items: center;justify-content: center;">
                                            <span style="font-size: 18px">10</span>
                                            <el-input v-model="modify_4.value" size="small" oninput="this.value = this.value.replace(/\D/g, '')" @input="validateInput(4)" :readonly="!modify_4.state" :class="[modify_4.state ? 'modifyInputColor' : 'modifyInput']" style="width: 53px;border: none;margin-left: 5px;" v-if="modify_4.state"></el-input><span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;margin-left: 5px;" v-if="modifyStatus" @click="handleModifyEdit(4)"></span>
                                        </div>
                                    </td> 
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td style="width: 100px;font-family: 'Arial';font-size: 16px;text-align: left;font-weight: 700;vertical-align: top;padding: 20px 8px 8px 10px">Agreement Instructions</td>
                                    <td colspan="3" style="text-align: left;font-family: 'Arial';padding: 8px 20px 8px 20px;">
                                        <div style="display: flex;line-height: 20px;font-size: 14px;padding-bottom: 10px;padding-top: 10px;">
                                            <i style="font-style: normal;display: inline-block;width: 21px;">1.</i>
                                            <span style="display: inline-block;width: calc(100% - 21px);">Party B must conduct project business development in full compliance with national laws or local policies and regulations, and shall adhere to Party A's project management and reporting systems.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(5)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_5.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_5.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 20px;font-size: 14px;padding-bottom: 10px;">
                                            <i style="font-style: normal;display: inline-block;width: 21px;">2.</i>
                                            <span style="display: inline-block;width: calc(100% - 21px);">Party A reserves the right to decide whether to undertake the project or participate in the project proposal bidding based on the specific circumstances of the project.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;"  @click="handleModifyEdit(6)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_6.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_6.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="line-height: 20px;font-size: 14px;">
                                            <dl>
                                                <dt style="display: flex;padding-bottom: 10px;">
                                                    <i style="font-style: normal;display: inline-block;width: 21px;">3.</i><span style="display: inline-block;width: calc(100% - 21px);">When introducing a project to Party A, Party B shall proceed according to the following steps:</span></dt>
                                                <dd style="margin-left: 22px;padding-bottom: 10px;">Step1: Party B shall provide Party A's company profile to the project owner, allowing the client to have a preliminary understanding of Party A.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(7)" v-if="modifyStatus"></span></dd>
                                                <dd v-if="modify_7.state">
                                                    <el-input class="autosizeText" type="textarea" v-model="modify_7.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                                </dd>
                                                <dd style="margin-left: 22px;padding-bottom: 10px;">Step2: Party B shall assist in arranging a formal visit between Party A and the project owner at an institutional level, establishing a professional dialogue.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(8)" v-if="modifyStatus"></span></dd>
                                                <dd v-if="modify_8.state">
                                                    <el-input class="autosizeText" type="textarea" v-model="modify_8.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                                </dd>
                                                <dd style="margin-left: 22px;padding-bottom: 10px;">Step3: Based on the specific circumstances of the client and the project, Party A will decide on the follow-up depth and participation level.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(9)" v-if="modifyStatus"></span></dd>
                                                <dd v-if="modify_9.state">
                                                    <el-input class="autosizeText" type="textarea" v-model="modify_9.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                                </dd>
                                                <dd style="margin-left: 22px;padding-bottom: 10px;">After completing the above steps, based on project needs:</dd>
                                                
                                            </dl>
                                            <dl style="line-height: 20px;font-size: 14px;">
                                                <dd  style="margin-left: 22px;padding-bottom: 10px;">1）For receptions deemed necessary by Party A, Party A shall execute them in accordance with its corporate reception standards and procedures, with Party B participating. For receptions deemed unnecessary by Party A, Party A shall not participate or bear any costs.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(10)" v-if="modifyStatus"></span></dd>
                                                <dd v-if="modify_10.state">
                                                    <el-input class="autosizeText" type="textarea" v-model="modify_10.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                                </dd>
                                                <dd style="margin-left: 22px;padding-bottom: 10px;">2）For business travel deemed necessary by Party A, Party A shall execute it in accordance with its corporate travel standards and procedures. For business travel deemed unnecessary by Party A, Party A shall not participate or bear any costs.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(11)" v-if="modifyStatus"></span></dd>
                                                <dd v-if="modify_11.state">
                                                    <el-input class="autosizeText" type="textarea" v-model="modify_11.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                                </dd>
                                            </dl>
                                        </div>
                                        <div style="display: flex;line-height: 20px;font-size: 14px;padding-bottom: 10px;">
                                            <i style="font-style: normal;display: inline-block;width: 21px;">4.</i>
                                            <span style="display: inline-block;width: calc(100% - 21px);">For any receptions or business travel conducted without completing the above steps, Party A shall not participate or bear any costs.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(12)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_12.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_12.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 20px;font-size: 14px;padding-bottom: 10px;">
                                            <i style="font-style: normal;display: inline-block;width: 21px;">5.</i>
                                            <span style="display: inline-block;width: calc(100% - 21px);">Party B undertakes that Party A is the only company in the interior design field recommended by Party B to the project owner for the same project.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(13)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_13.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_13.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 20px;font-size: 14px;padding-bottom: 10px;">
                                            <i style="font-style: normal;display: inline-block;width: 21px;">6.</i>
                                            <span style="display: inline-block;width: calc(100% - 21px);">During the term of cooperation between Party A and Party B, any cooperation between Party A and a client introduced by Party B on other projects shall be regarded as part of the cooperative projects between both parties.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(14)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_14.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_14.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 20px;font-size: 14px;padding-bottom: 10px;">
                                            <i style="font-style: normal;display: inline-block;width: 21px;">7.</i>
                                            <span style="display: inline-block;width: calc(100% - 21px);">Party A shall pay Party B the corresponding proportion of the project design fee within 2 weeks after receiving the project design fee at each stage in accordance with the cooperation ratio. Both parties shall pay their own taxes. Before Party A makes payment to Party B, Party B shall provide Party A with a legal VAT-compliant general service invoice including tax, reflecting full tax payment.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(15)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_15.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_15.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 20px;font-size: 14px;padding-bottom: 10px;">
                                            <i style="font-style: normal;display: inline-block;width: 21px;">8.</i>
                                            <span style="display: inline-block;width: calc(100% - 21px);">This cooperation ratio in this agreement includes all self-operated costs, and there are no other costs and expenses except those described in Article 3 of the Agreement Instructions.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(16)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_16.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_16.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 20px;font-size: 14px;padding-bottom: 10px;">
                                            <i style="font-style: normal;display: inline-block;width: 21px;">9.</i>
                                            <span style="display: inline-block;width: calc(100% - 21px);">Party A will not participate in bidding activities for schemes without bidding fees. If it participates in bidding with Party A's approval and obtains the bidding fee, 10% of the bidding fee shall be paid to Party B as labor remuneration.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(17)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_17.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_17.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>
                                        <div style="display: flex;line-height: 20px;font-size: 14px;padding-bottom: 10px;">
                                            <i style="font-style: normal;display: inline-block;width: 21px;">10.</i>
                                            <span style="display: inline-block;width: calc(100% - 21px);">Party B shall fully assist Party A in maintaining client relations throughout the process to ensure the smooth progress of the project and the completion of the project contract. If Party B withdraws from the cooperation or refuses to assist Party A in maintaining client relations, it shall be regarded as voluntary termination of cooperation.<span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(18)" v-if="modifyStatus"></span></span>
                                        </div>
                                        <div v-if="modify_18.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_18.value" resize="none" :autosize="{minRows:2,maxRows:8}"></el-input>
                                        </div>

                                        <div style="padding-top: 10px;color:#000;font-weight: 700;padding-left: 21px;" v-if="modifyStatus"><span>Add Clauses</span><span class="el-icon-edit" style="color: #4F81BD;font-weight: 700;cursor: pointer;" @click="handleModifyEdit(19)"></span></div>

                                        <div v-if="modify_19.state">
                                            <el-input class="autosizeText" type="textarea" v-model="modify_19.value" resize="none" :autosize="{minRows:5,maxRows:20}"></el-input>
                                        </div>

                                        <div style="padding-top: 15px;line-height: 22px;font-size: 16px;padding-bottom: 20px;padding-left: 21px;">The above terms shall be specified in the specific project cooperation contract between the two parties.</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                       
                        <div v-if="modifyStatus">
                            <!-- <el-button type="primary" style="border: 1px solid #000;margin-top: 10px;" @click="handleModifyAgreement">提交</el-button> -->
                             <el-button type="primary" size="small" style="border: 1px solid #4F81BD;background-color: #4F81BD;margin-top: 10px;font-size: 18px;font-family: 'Arial';width: 113px;padding: 8px 15px;" @click="handleTrueModify" v-if="fullIndex == 2 && infoIndex == 1">Return</el-button>
                            <el-button type="primary" size="small" style="border: 1px solid #e0e0e0;background: #e0e0e0;margin-top: 10px;font-size: 18px;font-family: 'Arial';width: 113px;padding: 8px 15px;color:#000" @click="handleModifyAgreement" v-if="fullIndex == 2 && infoIndex == 1">Submit</el-button>
                        </div>
                        <div v-else>
                            <!-- <el-button type="danger" style="margin-top: 10px;" @click="handleProjectOverview(2,'cn',2)" v-if="fullIndex == 2 && infoIndex == 2">不认同</el-button> -->
                            <el-button type="primary" size="small" style="margin-top: 10px;border: 1px solid #4F81BD;background-color: #4F81BD;font-size: 18px;font-family: 'Arial';width: 113px;padding: 8px 15px;" @click="handleProjectOverview(2,'en',2)" v-if="fullIndex == 2 && infoIndex == 1">Edit</el-button>

                            <!-- <el-button type="primary" style="border: 1px solid #000;margin-top: 10px;" v-if="fullIndex == 2 && infoIndex == 2" @click="handleProjectOverview(2,'cn',1)">认同</el-button> -->

                            <el-button type="primary" size="small" style="border: 1px solid #000;margin-top: 10px;font-size: 18px;font-family: 'Arial';width: 113px;padding: 8px 15px;" v-if="fullIndex == 2 && infoIndex == 1" @click="handleProjectOverview(2,'en',1)">Confirm</el-button>
                        </div>
                        
                    </div>
                </el-scrollbar>
            </div>
        </div>


        <!-- 项目列表数据 -->
         <el-dialog
            title="提示"
            :visible.sync="projectListInfodialogVisible"
            custom-class="customerDialogModel customerprojectLisDialogModel"
            top="10px"
            :lock-scroll="false"
            :close-on-click-modal="false"
            :before-close="handleprojectListInfoClose"
            width="900px">
            <div slot="title" class="dialog-header-en" style="display: flex;justify-content: space-between;">
                <div style="font-size: 18px;"><span style="font-size: 24px;font-family: 'SourceHanSansBOLD';">{{ userName }}</span> - ID: {{ numstr }}</div>
                <el-button type="primary" size="mini" style="border: 1px solid #595959;background: #595959;margin-right: 58px;width: 79px;font-size: 14px;font-family: 'SourceHanSansMEDIUM';padding: 6px 5px;height: 28px;" @click="handleLogOut" v-if="language == 'cn'">退出登录</el-button>
                <el-button type="primary" size="mini" style="border: 1px solid #595959;background: #595959;margin-right: 58px;width: 79px;font-size: 14px;font-family: 'Arial';font-weight: 700;padding: 6px 5px;height: 28px;" @click="handleLogOut" v-if="language == 'en'">Login Out</el-button>
            </div>

            <div class="customer-main-content" :style="{height: dialogHeight+'px',position:'relative'}">
                <el-button type="primary" size="mini" style="border: 1px solid #595959;background: #595959;margin-right: 45px;width: 79px;font-size: 14px;position: absolute;right: 0;z-index: 99;font-family: 'SourceHanSansMEDIUM';padding: 6px 5px;" @click="handleAddProjectInfo(0)" v-if="language == 'cn'">添加项目</el-button>
                <el-button type="primary" size="mini" style="border: 1px solid #595959;background: #595959;margin-right: 45px;width: 79px;font-size: 14px;position: absolute;right: 0;z-index: 99;font-family: 'Arial';font-weight: 700;padding: 6px 5px;" @click="handleAddProjectInfo(0)" v-if="language == 'en'">Add</el-button>

                <el-tabs v-model="activeProjectName" class="tabsCnModel" v-if="language == 'cn'">
                    <el-tab-pane name="first" >
                        <span slot="label">
                            <div v-if="fullIndex == 1" style="margin-left: 10px;">项目概括</div>
                            <div v-if="fullIndex == 2" style="margin-left: 10px;">项目备案</div>
                        </span>
                        <el-scrollbar style="height: 100%;">
                            <div style="padding: 0px 0px 15px 0px;">
                                <el-table
                                    :data="projectListData"
                                    style="width: 100%;">
                                    <el-table-column
                                    label="项目名称">
                                    <template slot-scope="scope">
                                        <div>{{ scope.row.projectname }}</div>
                                    </template>
                                    
                                    </el-table-column>
                                    <el-table-column
                                    label="状态">
                                    <template slot-scope="scope">
                                        <div>
                                            <span v-if="scope.row.atype == 1">待提交</span>
                                            <span v-if="scope.row.atype == 2">已提交</span>
                                        </div>
                                    </template>
                                    </el-table-column>
                                    <el-table-column
                                    label="录入日期">
                                    <template slot-scope="scope">
                                        <div>{{scope.row.ctime.split("T")[0]}}</div>
                                    </template>
                                    </el-table-column>
                                    <el-table-column
                                    label="操作"
                                    width="100px">
                                    <template slot-scope="scope">
                                        <el-button type="primary" size="mini" icon="el-icon-edit" style="border: 1px solid #000;font-weight: 700;" v-if="scope.row.atype == 1" @click="handleEditDetailsInfo(scope.row.projectid,1)"></el-button>
                                        <el-button type="primary" size="mini" icon="el-icon-view" style="border: 1px solid #67c23a;background-color: #67c23a;font-weight: 700;" v-if="scope.row.atype == 2" @click="handleEditDetailsInfo(scope.row.projectid,2)"></el-button>
                                    </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-scrollbar>
                    </el-tab-pane>
                    <el-tab-pane label="项目合约" name="second">项目合约</el-tab-pane>
                    <el-tab-pane label="项目进度" name="third">项目进度</el-tab-pane>
                    <el-tab-pane label="个人信息" name="fourth">
                        <el-descriptions class="margin-top" :column="1" :size="size" border>
                            <el-descriptions-item :labelStyle="{'width': '150px','font-weight': '700','color': '#333','font-size': '16px'}">
                                <template slot="label" >姓名</template>
                                <div style="font-size: 16px;color:#000;font-family: 'SourceHanSans';">{{ userInfo.cnname }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item :labelStyle="{'width': '150px','font-weight': '700','color': '#333','font-size': '16px'}">
                                <template slot="label">电子邮箱</template>
                                <div style="font-size: 16px;color:#000;font-family: 'SourceHanSans';">{{ userInfo.cnemail }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item :labelStyle="{'width': '150px','font-weight': '700','color': '#333','font-size': '16px'}">
                                <template slot="label">联系电话</template>
                                <div style="font-size: 16px;color:#000;font-family: 'SourceHanSans';">{{ userInfo.cnphone }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item :labelStyle="{'width': '150px','font-weight': '700','color': '#333','font-size': '16px'}" v-if="fullIndex == 2">
                                <template slot="label">合作框架</template>
                                <el-button type="primary" size="small" style="border:1px solid #000" @click="handleViewFramework(userInfo.files)">查看</el-button>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-tab-pane>
                </el-tabs>

                <el-tabs v-model="activeProjectName" class="tabsmodel" v-if="language == 'en'">
                    <el-tab-pane name="first">
                        <span slot="label">
                            <div v-if="fullIndex == 1" style="padding-left: 10px;">Project Overview</div>
                            <div v-if="fullIndex == 2" style="padding-left: 10px;">Project Filing</div>
                        </span>
                        <el-scrollbar style="height: 100%;">
                            <div style="padding: 0px 0px 15px 0px;">
                                <el-table
                                    :data="projectListData"
                                    empty-text="No Data"
                                    style="width: 100%;font-family: 'Arial';">
                                    <el-table-column
                                    label="Project Name">
                                    <template slot-scope="scope">
                                        <div>{{ scope.row.projectname }}</div>
                                    </template>
                                    
                                    </el-table-column>
                                    <el-table-column
                                    label="State">
                                    <template slot-scope="scope">
                                        <div>
                                            <span v-if="scope.row.atype == 1">Pending</span>
                                            <span v-if="scope.row.atype == 2">Submitted</span>
                                        </div>
                                    </template>
                                    </el-table-column>
                                    <el-table-column
                                    label="Entry Date">
                                    <template slot-scope="scope">
                                        <div>{{scope.row.ctime.split("T")[0]}}</div>
                                    </template>
                                    </el-table-column>
                                    <el-table-column
                                    label="Operation"
                                    width="100px">
                                    <template slot-scope="scope">
                                        <el-button type="primary" size="mini" icon="el-icon-edit" style="border: 1px solid #000;font-weight: 700;" v-if="scope.row.atype == 1" @click="handleEditDetailsInfo(scope.row.projectid,1)"></el-button>
                                        <el-button type="primary" size="mini" icon="el-icon-view" style="border: 1px solid #67c23a;background-color: #67c23a;font-weight: 700;" v-if="scope.row.atype == 2" @click="handleEditDetailsInfo(scope.row.projectid,2)"></el-button>
                                    </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-scrollbar>
                    </el-tab-pane>
                    <el-tab-pane label="Project Contract" name="second">项目合约</el-tab-pane>
                    <el-tab-pane label="Project Progress" name="third">项目进度</el-tab-pane>
                    <el-tab-pane label="Personal Information" name="fourth">
                        <el-descriptions class="margin-top" :column="1" :size="size" border>
                            <el-descriptions-item :labelStyle="{'width': '210px','font-weight': '700','color': '#333','font-size': '16px','font-family': 'Arial'}">
                                <template slot="label" >First Name</template>
                                <div style="font-size: 16px;color:#000;font-family: 'Arial';">{{ userInfo.enfname }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item :labelStyle="{'width': '210px','font-weight': '700','color': '#333','font-size': '16px','font-family': 'Arial'}">
                                <template slot="label" >Last Name</template>
                                <div style="font-size: 16px;color:#000;font-family: 'Arial';">{{ userInfo.enlname }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item :labelStyle="{'width': '210px','font-weight': '700','color': '#333','font-size': '16px','font-family': 'Arial'}">
                                <template slot="label">Email Address</template>
                                <div style="font-size: 16px;color:#000;font-family: 'Arial';">{{ userInfo.enaddress }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item :labelStyle="{'width': '210px','font-weight': '700','color': '#333','font-size': '16px','font-family': 'Arial'}">
                                <template slot="label">Contact Number</template>
                                <div style="font-size: 16px;color:#000;font-family: 'Arial';">{{ userInfo.ennumber }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item :labelStyle="{'width': '210px','font-weight': '700','color': '#333','font-size': '16px','font-family': 'Arial'}" v-if="fullIndex == 2">
                                <template slot="label">Cooperation Framework</template>
                                <el-button type="primary" size="small" style="border:1px solid #000;font-family: 'Arial';" @click="handleViewFramework(userInfo.files)">View</el-button>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-tab-pane>
                </el-tabs>
                
            </div>
            <!-- <div slot="title" class="dialog-header" v-if="language == 'cn'">{{ title }}</div> -->
            <!-- <div slot="title" class="dialog-header-en" v-if="language == 'en'">{{ title }}</div> -->


        </el-dialog>


        <!-- 项目委托信息（项目概况） -->
        <el-dialog
            title="提示"
            :visible.sync="InfomatdialogVisible"
            :custom-class="['customerDialogModel InfomatCustomerDialogModel', language == 'en' ? 'customerEnDialogModel' : '']"
            top="10px"
            :lock-scroll="false"
            :close-on-click-modal="false"
            :before-close="handleClose"
            width="1100px">
            <div slot="title" class="dialog-header" v-if="language == 'cn'">{{ title }}</div>
            <div slot="title" class="dialog-header-en" v-if="language == 'en'" style="margin-left: 14px;">{{ title }}</div>
            
            <!-- :style="{height: dialogHeight+'px'}" -->
            <div class="customer-main-content" :style="{height: dialogHeight+'px'}">
               <el-scrollbar style="height: 100%;">
                    <div style="padding: 0 15px;">
                        <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                            <el-descriptions :column="1" border size="small" class="descriptions-box">
                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">项目名称</span>
                                            <span v-if="language == 'en'">Project Name</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="projectname" 
                                    :rules="[{ required: true, message: '请输入项目名称', trigger: 'blur' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 240px;">
                                        <el-input v-model="ruleForm.projectname" :placeholder="language == 'cn' ? '请输入项目名称': 'Enter the project name'" :disabled="isEdit"></el-input>
                                    </el-form-item>
                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">项目类别</span>
                                            <span v-if="language == 'en'">Project Category</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="projecttype" 
                                    :rules="[{ required: true, message: '请选择项目类别', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 240px;">
                                    <!-- @change="handelProjectFormat" -->
                                        <el-select v-model="ruleForm.projecttype" placeholder="请选择项目类别" style="width: 100%;" v-if="language == 'cn'" :disabled="isEdit">
                                            <el-option label="规划" value="规划"></el-option>
                                            <el-option label="建筑" value="建筑"></el-option>
                                            <el-option label="室内" value="室内"></el-option>
                                            <el-option label="景观" value="景观"></el-option>
                                            <el-option label="机电" value="机电"></el-option>
                                            <el-option label="展陈" value="展陈"></el-option>
                                            <el-option label="灯光" value="灯光"></el-option>
                                            <el-option label="艺术设计" value="艺术设计"></el-option>
                                            <el-option label="顾问" value="顾问"></el-option>
                                            <el-option label="监理" value="监理"></el-option>
                                        </el-select>
                                        <el-select v-model="ruleForm.projecttype" placeholder="Select" style="width: 100%;" v-if="language == 'en'" :disabled="isEdit">
                                            <el-option label="Planning" value="Planning"></el-option>
                                            <el-option label="Architecture" value="Architecture"></el-option>
                                            <el-option label="Interior Design" value="Interior Design"></el-option>
                                            <el-option label="Landscape Design" value="Landscape Design"></el-option>
                                            <el-option label="MEP" value="MEP"></el-option>
                                            <el-option label="Exhibition Design" value="Exhibition Design"></el-option>
                                            <el-option label="Lighting Design" value="Lighting Design"></el-option>
                                            <el-option label="Art Design" value="Art Design"></el-option>
                                            <el-option label="Consultant" value="Consultant"></el-option>
                                            <el-option label="Supervision" value="Supervision"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-descriptions-item>

                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">项目类型</span>
                                            <span v-if="language == 'en'">Project Type</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="projectplace" 
                                    :rules="[{required: true, message: '请选择项目类型', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 240px;" v-if="language == 'cn'">
                                    <!-- @change="handelProjectFormat" -->
                                        <el-select v-model="ruleForm.projectplace" placeholder="请选择项目类型" style="width: 100%;" :disabled="isEdit">
                                            <el-option label="综合体" value="综合体"></el-option>
                                            <el-option label="总部办公" value="总部办公"></el-option>
                                            <el-option label="酒店公寓" value="酒店公寓"></el-option>
                                            <el-option label="商业设计" value="商业设计"></el-option>
                                            <el-option label="公共建筑" value="公共建筑"></el-option>
                                            <el-option label="地产设计" value="地产设计"></el-option>
                                            <el-option label="住宅设计" value="住宅设计"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item 
                                    prop="projectplace" 
                                    :rules="[{required: true, message: '请选择项目类型', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 240px;" v-if="language == 'en'">
                                    <!-- @change="handelProjectFormat" -->
                                        <el-select v-model="ruleForm.projectplace" placeholder="Select" style="width: 100%;" :disabled="isEdit">
                                            <el-option label="Complex" value="Complex"></el-option>
                                            <el-option label="Headquarters Office" value="Headquarters Office"></el-option>
                                            <el-option label="Hotel & Serviced Apartment" value="Hotel & Serviced Apartment"></el-option>
                                            <el-option label="Commercial Design" value="Commercial Design"></el-option>
                                            <el-option label="Public Architecture" value="Public Architecture"></el-option>
                                            <el-option label="Real Estate Design" value="Real Estate Design"></el-option>
                                            <el-option label="Residential Design" value="Residential Design"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">交付成果</span>
                                            <span v-if="language == 'en'">Deliverables</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="projectstage" 
                                    :rules="[{required: true, message: '请选择成果交付阶段', trigger: 'change' }]"  
                                    :show-message="false" 
                                    style="margin-bottom: 0;width: 240px;">
                                    <!-- -->
                                        <el-select v-model="ruleForm.projectstage" placeholder="请选择成果交付阶段" style="width: 100%;"  @change="handelDeliveryPhase" :disabled="isEdit" v-if="language == 'cn'">
                                            <el-option label="全过程" value="1"></el-option>
                                            <el-option label="节点阶段" value="2"></el-option>
                                        </el-select>
                                        <el-select v-model="ruleForm.projectstage" placeholder="Select " style="width: 100%;"  @change="handelDeliveryPhase" :disabled="isEdit" v-if="language == 'en'">
                                            <el-option label="Full Process" value="1"></el-option>
                                            <el-option label="Key Milestone Stage" value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label" v-if="isNodePhase">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">节点阶段</span>
                                            <span v-if="language == 'en'"> Key Milestone Stage</span>
                                        </div>
                                    </template>
                                    <!-- @change="handleChangeNodePhase" -->
                                    <el-form-item 
                                    style="margin-bottom: 0;width: 240px;" v-if="language == 'cn'">
                                        <el-select v-model="ruleForm.projectnode" placeholder="请选择节点阶段" style="width: 100%;" :disabled="isEdit">
                                            <el-option value="建筑优化阶段">建筑优化阶段</el-option>
                                            <el-option value="概念阶段">概念阶段</el-option>
                                            <el-option value="方案阶段">方案阶段</el-option>
                                            <el-option value="扩初阶段">扩初阶段</el-option>
                                            <el-option value="招标图阶段">招标图阶段</el-option>
                                            <el-option value="施工图阶段">施工图阶段</el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item 
                                    style="margin-bottom: 0;width: 240px;" v-if="language == 'en'">
                                        <el-select v-model="ruleForm.projectnode" placeholder="Select" style="width: 100%;" :disabled="isEdit">
                                            <el-option value="Architectural Optimization Stage">Architectural Optimization Stage</el-option>
                                            <el-option value="Conceptual Stage">Conceptual Stage</el-option>
                                            <el-option value="Schematic Design Stage">Schematic Design Stage</el-option>
                                            <el-option value="Design Development Stage">Design Development Stage</el-option>
                                            <el-option value="Tender Drawing Stage">Tender Drawing Stage</el-option>
                                            <el-option value="Construction Documents Stage">Construction Documents Stage</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-descriptions-item>

                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">项目规模</span>
                                            <span v-if="language == 'en'">Project Scale</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    size="small" 
                                    style="margin-bottom: 0;">
                                    <div style="display: flex;align-items: center;">

                                        <div style="display: flex;align-items: center;"  v-if="language == 'cn'">
                                            <div style="display: flex;align-items: center;">
                                                <div style="font-size:18px;margin-right: 5px;">
                                                    设计费估计
                                                </div>
                                                <el-form-item 
                                                prop="projectscale.projectscaleFee" 
                                                :rules="[{required: true, message: '请选择设项目规模', trigger: 'change' }]"  
                                                :show-message="false" 
                                                style="margin-bottom: 0;width: 165px;background: #fff;">
                                                   <el-input type="number" v-model="ruleForm.projectscale.projectscaleFee" placeholder="请输入" :disabled="isEdit"></el-input>
                                                    <!-- <el-select v-model="ruleForm.projectscale.projectscaleFee" placeholder="请选择设项目规模"  style="margin: 0 5px">
                                                    
                                                        <el-option label="100" value="100"></el-option>
                                                        <el-option label="100-200" value="100-200"></el-option>
                                                        <el-option label="300-400" value="300-400"></el-option>
                                                        <el-option label="500-900" value="500-900"></el-option>
                                                        <el-option label="1000" value="1000"></el-option>
                                                        <el-option label="1000+" value="1000+"></el-option>
                                                    </el-select> -->
                                                </el-form-item>
                                                
                                                <div style="font-size:18px;margin-left: 5px;" v-if="language == 'cn'">万元</div>
                                                
                                            </div>
                                            <div style="display: flex;align-items: center;;margin-left: 5px;">
                                                <div style="font-size:18px;margin-right: 10px;">
                                                    信息来源
                                                </div>
                                                <el-form-item 
                                                    :show-message="false" 
                                                    style="margin-bottom: 0;">
                                                    
                                                    <el-select v-model="ruleForm.projectscale.projectscaleInfo" placeholder="请选择信息来源"  style="margin: 0 5px" v-if="language == 'cn'" :disabled="isEdit">
                                                    
                                                        <el-option label="业主" value="业主"></el-option>
                                                        <el-option label="网络" value="网络"></el-option>
                                                        <el-option label="朋友" value="朋友"></el-option>
                                                    </el-select>
                                                        <!-- <el-radio-group v-model="ruleForm.projectscale.projectscaleInfo" v-if="language == 'cn'" :disabled="isEdit">
                                                            <el-radio label="业主"></el-radio>
                                                            <el-radio label="网络"></el-radio>
                                                            <el-radio label="朋友"></el-radio>
                                                        </el-radio-group> -->

                                                        <!-- <el-radio-group v-model="ruleForm.projectscale.projectscaleInfo" v-if="language == 'en'" :disabled="isEdit">
                                                            <el-radio label="业主"></el-radio>
                                                            <el-radio label="网络"></el-radio>
                                                            <el-radio label="朋友"></el-radio>
                                                         
                                                        </el-radio-group> -->
                                                        <!-- <el-select v-model="ruleForm.projectscale.projectscaleInfo" placeholder="Select"  style="margin: 0 5px" v-if="language == 'en'" :disabled="isEdit">
                                                    
                                                            <el-option label="Landlord" value="Landlord"></el-option>
                                                            <el-option label="Network" value="Network"></el-option>
                                                            <el-option label="Friend" value="Friend"></el-option>
                                                        </el-select> -->
                                                    </el-form-item>
                                            </div>
                                            <!-- <el-form-item style="margin-bottom: 0;margin-left: 10px;width: 170px;">
                                                <el-input v-model="ruleForm.projectscale.projectscaleInfo" placeholder="请输入信息来源" :disabled="isEdit"></el-input>
                                            </el-form-item> -->
                                        </div>

                                        <div style="display: flex;flex-direction: column;"  v-if="language == 'en'">
                                            <div style="display: flex;align-items: center;">
                                                <div style="font-size:18px;margin-right: 5px;font-family: 'Arial';">
                                                    <i style="color:red;margin-right: 5px;font-style: normal;">*</i>Estimated Design Fee
                                                </div>
                                                <el-form-item 
                                                prop="projectscale.projectscaleFee" 
                                                :rules="[{required: true, message: '请选择设项目规模', trigger: 'change' }]"  
                                                :show-message="false" 
                                                style="margin-bottom: 0;width: 165px;background: #fff;">
                                                    <!-- <el-select v-model="ruleForm.projectscale.projectscaleFee" :placeholder="language == 'cn' ? '请选择设项目规模' : 'Select'"  style="margin: 0 5px">
                                                    
                                                        <el-option label="100" value="100"></el-option>
                                                        <el-option label="100-200" value="100-200"></el-option>
                                                        <el-option label="300-400" value="300-400"></el-option>
                                                        <el-option label="500-900" value="500-900"></el-option>
                                                        <el-option label="1000" value="1000"></el-option>
                                                        <el-option label="1000+" value="1000+"></el-option>
                                                    </el-select> -->
                                                    <el-input type="number" v-model="ruleForm.projectscale.projectscaleFee" placeholder="Enter" :disabled="isEdit"></el-input>
                                                </el-form-item>
                                                
                                                <div style="font-size:18px;margin-left: 5px;" v-if="language == 'cn'">万元</div>
                                                <div style="font-size:18px;margin-left: 5px;font-family: 'Arial';" v-if="language == 'en'">Ten Thousand USD</div>
                                            </div>
                                            <div style="display: flex;align-items: center;margin-top: 10px;">
                                                <div style="font-size:18px;font-family: 'Arial';">
                                                    <i style="color:red;margin-right: 10px;">*</i>Information Provider
                                                </div>
                                                <el-form-item style="margin-bottom: 0;margin-left: 10px;width: 165px;">
                                                    <!-- <el-input v-model="ruleForm.projectscale.projectscaleInfo" placeholder="Enter" :disabled="isEdit"></el-input> -->
                                                     <el-select v-model="ruleForm.projectscale.projectscaleInfo" placeholder="Select"  style="margin: 0 5px" v-if="language == 'en'" :disabled="isEdit">
                                                    
                                                            <el-option label="Landlord" value="Landlord"></el-option>
                                                            <el-option label="Network" value="Network"></el-option>
                                                            <el-option label="Friend" value="Friend"></el-option>
                                                        </el-select>
                                                </el-form-item>
                                            </div>
                                            
                                        </div>
                                        

                                    </div>
                                    </el-form-item>
                                </el-descriptions-item>

                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">项目地点</span>
                                            <span v-if="language == 'en'">Project Location</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="projectsite" 
                                    :rules="[{required: true, message: '请选择项目地点', trigger: 'blur' }]"  
                                    :show-message="false" 
                                    style="margin-bottom: 0;width: 240px;" v-if="language == 'cn'">
                                        <el-cascader :options="pcaTextArr" placeholder="请选择" v-model="ruleForm.projectsite" style="width: 100%;" :disabled="isEdit"></el-cascader>
                                    </el-form-item>

                                    <el-form-item 
                                    prop="projectsite" 
                                    :rules="[{required: true, message: '请选择项目地点', trigger: 'blur' }]"  
                                    :show-message="false" 
                                    style="margin-bottom: 0;width: 240px;" v-if="language == 'en'">
                                      <el-select
                                            v-model="ruleForm.projectsite"
                                            placeholder="Select"
                                            filterable
                                            clearable
                                            :disabled="isEdit"
                                        >
                                            <el-option v-for="(item, index) in coutry" :key="index" :label="item.name" :value="item.name"></el-option>
                                            
                                        </el-select>
                                        <!-- <el-cascader :options="pcaTextArr" placeholder="请选择" v-model="ruleForm.projectsite" style="width: 100%;"></el-cascader> -->
                                    </el-form-item>

                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label" v-if="fullIndex == 2">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">履约规范</span>
                                            <span v-if="language == 'en'">Performance Record</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="projecthetonOne" 
                                    :rules="[{required: true, message: '请选择合同账期', trigger: 'change' }]"  
                                    :show-message="false" 
                                    style="margin-bottom: 0;">
                                        <el-radio-group v-model="ruleForm.projecthetonOne" v-if="language == 'cn'" :disabled="isEdit">
                                            <el-radio label="优秀"></el-radio>
                                            <el-radio label="正常"></el-radio>
                                            <el-radio label="不稳定"></el-radio>
                                            <el-radio label="较差"></el-radio>
                                            <!-- <el-radio label="公开方案标（体制）"></el-radio> -->
                                        </el-radio-group>

                                        <el-radio-group v-model="ruleForm.projecthetonOne" v-if="language == 'en'" :disabled="isEdit">
                                            <el-radio label="Excellent"></el-radio>
                                            <el-radio label="Normal"></el-radio>
                                            <el-radio label="Unstable"></el-radio>
                                            <el-radio label="Poor"></el-radio>
                                            <!-- <el-radio label="公开方案标（体制）"></el-radio> -->
                                        </el-radio-group>
                                    </el-form-item>
                                   
                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">业主名称</span>
                                            <span v-if="language == 'en'">Client Name</span>
                                        </div>
                                    </template>
                                    <div style="display: flex;align-items: center;">
                                        <el-form-item 
                                        prop="companynames.companynameInfo" 
                                        :rules="[{required: true, message: '请输入总部公司', trigger: 'blur' }]"  
                                        :show-message="false" 
                                        style="margin-bottom: 0; 
                                        width: 240px;">
                                            <el-input v-model="ruleForm.companynames.companynameInfo" :placeholder="language == 'cn' ? '请输入总部公司(必填)' : 'Headquarters'" :disabled="isEdit"></el-input>
                                        </el-form-item>
                                        <el-form-item 
                                        prop="companynames.companynameProjectInfo"
                                        :rules="[{required: true, message: '请输入项目公司', trigger: 'blur' }]"
                                        :show-message="false" 
                                        style="margin-bottom: 0;width: 240px;margin-left: 10px;">
                                            <el-input v-model="ruleForm.companynames.companynameProjectInfo" :placeholder="language == 'cn' ? '请输入项目公司' : 'Project Company'" :disabled="isEdit"></el-input>
                                        </el-form-item>
                                    </div>
                                </el-descriptions-item>

                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">招标形式</span>
                                            <span v-if="language == 'en'">Bidding Method</span>
                                        </div>
                                    </template>

                                    <div style="display: flex;">
                                        <el-form-item 
                                        prop="projectnote" 
                                        :rules="[{required: true, message: '请选择招标形式', trigger: 'change' }]"  
                                        :show-message="false" 
                                        style="margin-bottom: 0;">
                                            <el-radio-group v-model="ruleForm.projectnote" v-if="language == 'cn'" :disabled="isEdit">
                                                <el-radio label="商务标"></el-radio>
                                                <!-- <el-radio label="方案标（无偿）"></el-radio> -->
                                                <el-radio label="方案标"></el-radio>
                                            </el-radio-group>
                                            <el-radio-group v-model="ruleForm.projectnote" v-if="language == 'en'" :disabled="isEdit">
                                                <el-radio label="Commercial Bid"></el-radio>
                                                <!-- <el-radio label="方案标（无偿）"></el-radio> -->
                                                <el-radio label="Schematic Design Bid"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>

                                        <el-form-item 
                                        prop="zmoney"
                                        v-if="ruleForm.projectnote == '方案标' || ruleForm.projectnote == 'Schematic Design Bid'"
                                        :rules="[{required: true, message: '请输入招标费用', trigger: 'blur' }]"  
                                        :show-message="false" 
                                        style="margin-bottom: 0;width: 200px;margin-left: 10px;">
                                            <el-input v-model="ruleForm.zmoney" :placeholder="language == 'cn' ? '招标费用(必填)' : 'Tender Cost (Required)'" :disabled="isEdit"></el-input>
                                        </el-form-item>
                                    </div>
                                    
                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">招标时间</span>
                                            <span v-if="language == 'en'">Bidding Date</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="bidTime" 
                                    :rules="[{required: true, message: '请选择建设进度', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 318px;">
                                         <el-date-picker
                                            v-model="ruleForm.bidTime"
                                            v-if="language == 'cn'"
                                            type="daterange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            style="width: 100%"
                                            :disabled="isEdit"
                                            value-format="yyyy-MM-dd"
                                            end-placeholder="结束日期">
                                        </el-date-picker>
                                        <el-date-picker
                                            v-model="ruleForm.bidTime"
                                            v-if="language == 'en'"
                                            type="daterange"
                                            range-separator="And"
                                            start-placeholder="Start Date"
                                            style="width: 100%"
                                            :disabled="isEdit"
                                            value-format="yyyy-MM-dd"
                                            end-placeholder="End Date">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-descriptions-item>

                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">建设进度</span>
                                            <span v-if="language == 'en'">Construction Progress</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="projectpace" 
                                    :rules="[{required: true, message: '请选择建设进度', trigger: 'change' }]"  
                                    :show-message="false" 
                                    style="margin-bottom: 0;width: 240px;" v-if="language == 'cn'">
                                        <el-select v-model="ruleForm.projectpace" placeholder="请选择建设进度" style="width: 100%;" :disabled="isEdit">
                                            <el-option label="立项" value="立项"></el-option>
                                            <el-option label="规划" value="规划"></el-option>
                                            <el-option label="已确定建筑设计单位" value="已确定建筑设计单位"></el-option>
                                            <el-option label="已定建筑方案" value="已定建筑方案"></el-option>
                                            <el-option label="建筑扩初" value="建筑扩初"></el-option>
                                            <el-option label="施工图设计" value="施工图设计"></el-option>
                                            <el-option label="地下室完成" value="地下室完成"></el-option>
                                            <el-option label="建筑封顶" value="建筑封顶"></el-option>
                                            <el-option label="原有旧楼" value="原有旧楼"></el-option>
                                        </el-select>
                                        <el-select v-model="ruleForm.projectpace" placeholder="Select" style="width: 100%;" v-if="language == 'en'" :disabled="isEdit">
                                            <el-option label="Project Approval " value="Project Approval "></el-option>
                                            <el-option label="Planning" value="Planning"></el-option>
                                            <el-option label="Architectural Design Firm Confirmed" value="Architectural Design Firm Confirmed"></el-option>
                                            <el-option label="Architectural Scheme Finalized" value="Architectural Scheme Finalized"></el-option>
                                            <el-option label="Architectural Design Development" value="Architectural Design Development"></el-option>
                                            <el-option label="Construction Document Design" value="Construction Document Design"></el-option>
                                            <el-option label="Basement Completed" value="Basement Completed"></el-option>
                                            <el-option label="Building Topped Out" value="Building Topped Out"></el-option>
                                            <el-option label="Existing Old Building" value="Existing Old Building"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item 
                                    prop="projectpace" 
                                    :rules="[{required: true, message: '请选择建设进度', trigger: 'change' }]"  
                                    :show-message="false" 
                                    style="margin-bottom: 0;width: 318px;" v-if="language == 'en'">
                                        <el-select v-model="ruleForm.projectpace" placeholder="Select" style="width: 100%;" :disabled="isEdit">
                                            <el-option label="Project Approval " value="Project Approval "></el-option>
                                            <el-option label="Planning" value="Planning"></el-option>
                                            <el-option label="Architectural Design Firm Confirmed" value="Architectural Design Firm Confirmed"></el-option>
                                            <el-option label="Architectural Scheme Finalized" value="Architectural Scheme Finalized"></el-option>
                                            <el-option label="Architectural Design Development" value="Architectural Design Development"></el-option>
                                            <el-option label="Construction Document Design" value="Construction Document Design"></el-option>
                                            <el-option label="Basement Completed" value="Basement Completed"></el-option>
                                            <el-option label="Building Topped Out" value="Building Topped Out"></el-option>
                                            <el-option label="Existing Old Building" value="Existing Old Building"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">业主性质</span>
                                            <span v-if="language == 'en'">Owner/Client Nature</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="companytype" 
                                    :rules="[{required: true, message: '请选择业主性质', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 240px;" v-if="language == 'cn'">
                                        <el-select v-model="ruleForm.companytype" placeholder="请选择业主性质" style="width: 100%;" :disabled="isEdit">
                                            <el-option label="实业央企" value="实业央企"></el-option>
                                            <el-option label="房企央企" value="房企央企"></el-option>
                                            <el-option label="地方国企" value="地方国企"></el-option>
                                            <el-option label="境外公司" value="境外公司"></el-option>
                                            <el-option label="地产民企" value="地产民企"></el-option>
                                            <el-option label="大型民企" value="大型民企"></el-option>
                                            <el-option label="中小民企" value="中小民企"></el-option>
                                            <el-option label="建筑设计院" value="建筑设计院"></el-option>
                                            <el-option label="工程公司" value="工程公司"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item 
                                    prop="companytype" 
                                    :rules="[{required: true, message: '请选择业主性质', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 318px;" v-if="language == 'en'">
                                        <el-select v-model="ruleForm.companytype" placeholder="Select" style="width: 100%;" :disabled="isEdit">
                                            <el-option label="State-owned Industrial Enterprises" value="State-owned Industrial Enterprises"></el-option>
                                            <el-option label="Central State-owned Real Estate Enterprises" value="Central State-owned Real Estate Enterprises"></el-option>
                                            <el-option label="Local State-Owned Enterprise" value="Local State-Owned Enterprise"></el-option>
                                            <el-option label="Overseas Company" value="Overseas Company"></el-option>
                                            <el-option label="Private Real Estate Enterprise" value="Private Real Estate Enterprise"></el-option>
                                            <el-option label="Large Private Enterprise" value="Large Private Enterprise"></el-option>
                                            <el-option label="Small And Medium Private Enterprise" value="Small And Medium Private Enterprise"></el-option>
                                            <el-option label="Architectural Design Institute" value="Architectural Design Institute"></el-option>
                                            <el-option label="Engineering Company" value="Engineering Company"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">合作记录</span>
                                            <span v-if="language == 'en'">Cooperation Record</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="projectaware" 
                                    :rules="[{required: true, message: '请选择合作记录', trigger: 'blur' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;">
                                        <el-radio-group v-model="ruleForm.projectaware" v-if="language == 'cn'" :disabled="isEdit">
                                            <el-radio label="新客户"></el-radio>
                                            <el-radio label="旧客户"></el-radio>
                                            <el-radio label="长期客户"></el-radio>
                                        </el-radio-group>
                                        <el-radio-group v-model="ruleForm.projectaware" v-if="language == 'en'" :disabled="isEdit">
                                            <el-radio label="New Client"></el-radio>
                                            <el-radio label="Existing Client"></el-radio>
                                            <el-radio label="Long-term Client"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">定标流程</span>
                                            <span v-if="language == 'en'">Bid Award Process</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="markprocess" 
                                    :rules="[{required: true, message: '请选择定标流程', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 259px;" v-if="language == 'cn'">
                                        <el-select v-model="ruleForm.markprocess" placeholder="请选择招标形式" style="width: 100%;" :disabled="isEdit">
                                            <el-option label="标书提交待通知" value="标书提交待通知"></el-option>
                                            <el-option label="方案述标待通知" value="方案述标待通知"></el-option>
                                            <el-option label="方案述标现场定标" value="方案述标现场定标"></el-option>
                                        </el-select>
                                        <!-- <el-select v-model="ruleForm.markprocess" placeholder="Select" style="width: 100%;" v-if="language == 'en'">
                                            <el-option label="Tender Submission Pending Notification " value="Tender Submission Pending Notification "></el-option>
                                            <el-option label="Scheme Presentation Pending Notification" value="Scheme Presentation Pending Notification"></el-option>
                                            <el-option label="On-Site Scheme Presentation & Final Decision" value="On-Site Scheme Presentation & Final Decision"></el-option>
                                        </el-select> -->
                                       
                                    </el-form-item>

                                    <el-form-item 
                                    prop="markprocess" 
                                    :rules="[{required: true, message: '请选择定标流程', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 318px;" v-if="language == 'en'">
                                        
                                        <el-select v-model="ruleForm.markprocess" placeholder="Select" style="width: 100%;" :disabled="isEdit">
                                            <el-option label="Tender Submission Pending Notification " value="Tender Submission Pending Notification "></el-option>
                                            <el-option label="Scheme Presentation Pending Notification" value="Scheme Presentation Pending Notification"></el-option>
                                            <el-option label="On-Site Scheme Presentation & Final Decision" value="On-Site Scheme Presentation & Final Decision"></el-option>
                                        </el-select>
                                       
                                    </el-form-item>
                                </el-descriptions-item>

                                <el-descriptions-item label-class-name="descript-label" v-if="fullIndex == 2">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">竞标企业</span>
                                            <span v-if="language == 'en'">Bidding Companies</span>
                                        </div>
                                    </template>
                                    <div style="display: flex;align-items: center;" v-if="language == 'cn'">
                                        <el-form-item 
                                        prop="markrival.markrivalName" 
                                        :rules="[{required: true, message: '请输入竞标企业', trigger: 'blur' }]"  
                                        :show-message="false"
                                        style="margin-bottom: 0; 
                                        width: 259px;">
                                            <el-input v-model="ruleForm.markrival.markrivalName" :placeholder="language == 'cn' ? '请输入竞标企业(必填)' : 'Enter the bidding companies'" :disabled="isEdit"></el-input>
                                        </el-form-item>
                                        <!-- <el-form-item style="margin-bottom: 0;width: 180px;margin-left: 10px;">
                                            <el-input v-model="ruleForm.markrival.markrivalInfo" placeholder="请输入与业主关系"></el-input>
                                        </el-form-item> -->
                                    </div>

                                    <div style="display: flex;align-items: center;" v-if="language == 'en'">
                                        <el-form-item 
                                        prop="markrival.markrivalName" 
                                        :rules="[{required: true, message: '请输入竞标企业', trigger: 'blur' }]"  
                                        :show-message="false"
                                        style="margin-bottom: 0; 
                                        width: 318px;">
                                            <el-input v-model="ruleForm.markrival.markrivalName" :placeholder="language == 'cn' ? '请输入竞标企业(必填)' : 'Enter the bidding companies'" :disabled="isEdit"></el-input>
                                        </el-form-item>
                                        <!-- <el-form-item style="margin-bottom: 0;width: 180px;margin-left: 10px;">
                                            <el-input v-model="ruleForm.markrival.markrivalInfo" placeholder="请输入与业主关系"></el-input>
                                        </el-form-item> -->
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">决策流程</span>
                                            <span v-if="language == 'en'">Decision-Making Process</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="reportprocess" 
                                    :rules="[{required: true, message: '请选择决策流程', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 259px;" v-if="language == 'cn'">
                                        <el-select v-model="ruleForm.reportprocess" placeholder="请选择决策流程" style="width: 100%;" :disabled="isEdit">
                                            <el-option label="合约/执行总/项目总/集团决策" value="1"></el-option>
                                            <el-option label="合约 + /执行总 + /项目总 + /集团决策 +" value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item 
                                    prop="reportprocess" 
                                    :rules="[{required: true, message: '请选择决策流程', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;" v-if="language == 'en'">
                                        <el-select v-model="ruleForm.reportprocess" placeholder="Select" style="width: 100%;" :disabled="isEdit">
                                            <el-option label="Contract Director/Executive Director/Project Director/Group Decision-Maker" value="1"></el-option>
                                            <el-option label="Contract Director + /Executive Director + /Project Director + /Group Decision-Maker +" value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-descriptions-item>

                                <el-descriptions-item label-class-name="descript-label" v-if="fullIndex == 2">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">信息来源</span>
                                            <span v-if="language == 'en'">Information Source</span>
                                        </div>
                                    </template>
                                    <el-form-item 
                                    prop="projectsource" 
                                    :rules="[{required: true, message: '请选择竞标对手', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 259px;" v-if="language == 'cn'">
                                        <el-select v-model="ruleForm.projectsource" placeholder="请选择信息来源" style="width: 100%;" :disabled="isEdit">
                                            <el-option label="市场合伙人" value="市场合伙人"></el-option>
                                            <el-option label="公司客户" value="公司客户"></el-option>
                                            <el-option label="电话拜访" value="电话拜访"></el-option>
                                            <el-option label="同事公司品牌" value="同事公司品牌"></el-option>
                                            <el-option label="公司电话" value="公司电话"></el-option>
                                            <el-option label="公司资源方" value="公司资源方"></el-option>
                                            <el-option label="旧同事" value="旧同事"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item 
                                    prop="projectsource" 
                                    :rules="[{required: true, message: '请选择竞标对手', trigger: 'change' }]"  
                                    :show-message="false"
                                    style="margin-bottom: 0;width: 260px;" v-if="language == 'en'">
                                        <el-select v-model="ruleForm.projectsource" placeholder="Select" style="width: 100%;" v-if="language == 'en'" :disabled="isEdit">
                                            <el-option label="Marketing Partner" value="Marketing Partner"></el-option>
                                            <el-option label="Corporate Client" value="Corporate Client"></el-option>
                                            <el-option label="Phone Call" value="Phone Call"></el-option>
                                            <el-option label="Colleague’s Corporate Brand" value="Colleague’s Corporate Brand"></el-option>
                                            <el-option label="Office Line" value="Office Line"></el-option>
                                            <el-option label="Corporate Resource Provider" value="Corporate Resource Provider"></el-option>
                                            <el-option label="Former Colleague" value="Former Colleague"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-descriptions-item>

                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">项目联系人</span>
                                            <span v-if="language == 'en'">Project Contact Person</span>
                                        </div>
                                    </template>
                                    <div style="display: flex;align-items: center;" v-for="(item, index) in ruleForm.proexecutor" :key="index">
                                        <el-form-item 
                                        :prop="'proexecutor.' + index + '.name'"
                                        :rules="{required: true, message: '请输入内容', trigger: 'blur'}"
                                        :show-message="false"
                                        style="margin-bottom: 0; 
                                        width: 120px;
                                        margin-right: 10px;">
                                            <el-input v-model="item.name" :placeholder="language == 'cn' ? '姓名' : 'Name'" :disabled="isEdit"></el-input>
                                        </el-form-item>
                                        <el-form-item style="margin-bottom: 0;width: 130px;margin-right: 10px;">
                                            <el-input v-model="item.posit" :placeholder="language == 'cn' ? '职位' : 'Position'" :disabled="isEdit"></el-input>
                                        </el-form-item>
                                        <el-form-item style="margin-bottom: 0;width: 150px;margin-right: 10px;">
                                            <el-input v-model="item.iphone" minlength="8" maxlength="13" :placeholder="language == 'cn' ? '电话' : 'Phone'" :disabled="isEdit"></el-input>
                                        </el-form-item>
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">项目负责人</span>
                                            <span v-if="language == 'en'">Project Leader</span>
                                        </div>
                                    </template>
                                    <div style="display: flex;align-items: center;" v-for="(item, index) in ruleForm.procurator" :key="index">
                                        <el-form-item 
                                        :prop="'procurator.' + index + '.name'"
                                        :rules="{required: true, message: '请输入内容', trigger: 'blur'}"
                                        :show-message="false"
                                        style="margin-bottom: 0; 
                                        width: 120px;
                                        margin-right: 10px;">
                                            <el-input v-model="item.name" :placeholder="language == 'cn' ? '姓名' : 'Name'" :disabled="isEdit"></el-input>
                                        </el-form-item>
                                        <el-form-item style="margin-bottom: 0;width: 130px;">
                                            <el-input v-model="item.posit" :placeholder="language == 'cn' ? '职位' : 'Position'" :disabled="isEdit"></el-input>
                                        </el-form-item>
                                        <!-- <i class="el-icon-circle-plus" style="font-size: 22px;cursor: pointer;"></i> -->
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">项目决策人</span>
                                            <span v-if="language == 'en'">Project Decision-Maker</span>
                                        </div>
                                    </template>
                                    <div style="display: flex;align-items: center;" v-for="(item, index) in ruleForm.promaker" :key="index">
                                        <el-form-item 
                                        :prop="'promaker.' + index + '.name'"
                                        :rules="{required: true, message: '请输入内容', trigger: 'blur'}"
                                        :show-message="false"
                                        style="margin-bottom: 0; 
                                        width: 120px;
                                        margin-right: 10px;">
                                            <el-input v-model="item.name" :placeholder="language == 'cn' ? '姓名' : 'Name'" :disabled="isEdit"></el-input>
                                        </el-form-item>
                                        <el-form-item style="margin-bottom: 0;width: 130px;">
                                            <el-input v-model="item.posit" :placeholder="language == 'cn' ? '职位' : 'Position'" :disabled="isEdit"></el-input>
                                        </el-form-item>

                                        <!-- <i class="el-icon-circle-plus" style="font-size: 22px;cursor: pointer;"></i> -->
                                    </div>
                                </el-descriptions-item>

                                <el-descriptions-item label-class-name="descript-label">
                                    <template slot="label">
                                        <div class="must-lable">
                                            <span v-if="language == 'cn'">项目资料</span>
                                            <span v-if="language == 'en'">Submit Project Information</span>
                                        </div>
                                    </template>
                                    <div v-if="language == 'cn'">
                                        <el-button type="primary" size="small" style="line-height: 1;padding: 9px 15px 6px 15px;position: relative;font-size: 16px;border: #000;" v-for="(item, index) in projectDataFile" :key="index">
                                        {{ item.filename }}
                                            <i class="el-icon-check" v-if="item.fileurl != ''"></i>
                                            <input type="file" :ref="'clearFile_'+index" class="uploadCustomer" accept=".pdf" @change="handleStudioUploadFile($event,index)" :disabled="isEdit">
                                        </el-button>
                                    </div>
                                    <div v-if="language == 'en'">
                                        <el-button type="primary" size="small" style="line-height: 1;padding: 9px 15px 6px 15px;position: relative;font-size: 16px;border: #000;font-family: 'Arial';" v-for="(item, index) in projectDataEnFile" :key="index" >
                                        {{ item.filename }}
                                            <i class="el-icon-check" v-if="item.fileurl != ''"></i>
                                            <input type="file" :ref="'clearFile_'+index" class="uploadCustomer" accept=".pdf" @change="handleStudioUploadFile($event,index)" :disabled="isEdit">
                                        </el-button>
                     
                                    </div>
                                    
                                </el-descriptions-item>
                            </el-descriptions>
                        </el-form>
                    </div>
                    
                </el-scrollbar>
            </div>
            <span slot="footer" class="dialog-footer" v-if="!isEdit">
                <!-- modifyNtype -->
                <!-- <div style="font-size: 15px;padding-bottom: 15px;" v-if="modifyNtype == 5">
                    <el-checkbox v-model="ischecked"></el-checkbox>
                    <span style="padding-left: 5px;" v-if="language == 'cn'">勾选确认<a href="javascript:;" style="color: #0066cc;" @click="handleFrameworkInfo">《合作框架修订版》</a></span>
                    <span style="padding-left: 5px;" v-if="language == 'en'">Check the confirmation box for<a href="javascript:;" style="color: #0066cc;" @click="handleFrameworkInfo">《Revised Version of Cooperation Framework》</a></span>
                </div> -->
                
                <el-button type="danger" size="small" @click="handleClose" style="font-size: 16px;background-color: rgb(224, 224, 224);border: 1px solid rgb(217, 217, 217);color: rgb(51, 51, 51);" v-if="language == 'cn'">关闭</el-button>
                <el-button type="danger" size="small" @click="handleClose" style="font-size: 16px;background-color: rgb(224, 224, 224);border: 1px solid rgb(217, 217, 217);color: rgb(51, 51, 51);font-family: 'Arial';font-weight: 700;" v-if="language == 'en'">Close</el-button>
                <el-button type="primary" size="small" @click="submitFormSave(1)" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 16px;" v-if="language == 'cn'">保存</el-button>
                <el-button type="primary" size="small" @click="submitFormSave(1)" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 16px;font-family: 'Arial';font-weight: 700;" v-if="language == 'en'">Save</el-button>
                <el-button type="primary" size="small" @click="submitFormSave(2)" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 16px;" v-if="language == 'cn'">提交</el-button>
                

                <el-button type="primary" size="small" @click="submitFormSave(2)" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 16px;font-family: 'Arial';font-weight: 700;" v-if="language == 'en'">Submit</el-button>

            </span>
        </el-dialog>
        <!-- end -->

        <!-- 不认同内容 -->

        <!-- <el-dialog
            :title="this.language == 'en' ? 'Submit a dispute or question, and a specialist will contact you.': '如有争议或疑问，请在此提交，将有专人与您联系。'"
            :visible.sync="AcceptdialogVisible"
            width="600px"
            :before-close="handleClose">
            <el-input
            type="textarea"
            :rows="5"
            resize="none"
            v-model="disReason">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" style="background-color: #4F81BD;border-color: #4F81BD;" @click="handelAcceptInfo" v-if="this.language == 'en'">Submit</el-button>
                <el-button type="primary" style="background-color: #4F81BD;border-color: #4F81BD;" @click="handelAcceptInfo" v-if="this.language == 'cn'">提交</el-button>
            </span>
        </el-dialog> -->


        <el-dialog
            title=""
            :visible.sync="tispdialogVisible"
            custom-class="promptBox"
            width="420px"
            :show-close="false"
            :before-close="handleClose">
            <div style="font-size: 17px;font-family: 'Arial';text-align: center;" v-if="this.language == 'en'">
                Information submitted successfully. <br/>Thank you!
            </div>
            <div style="font-size: 17px;font-family: 'SourceHanSans';text-align: center;" v-if="this.language == 'cn'">
                信息提交成功
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'Arial';font-weight: 700;width: 113px;padding: 8px 15px;" @click="handelSureTips" v-if="this.language == 'en'">Confirm</el-button>
                <el-button type="primary" size="small" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;" @click="handelSureTips" v-if="this.language == 'cn'">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 保存信息提示 -->
        <el-dialog
            title=""
            :visible.sync="SaveInfodialogVisible"
            custom-class="promptBox"
            width="847px"
            :show-close="false"
            :before-close="handleClose">
            <div style="font-size: 17px;font-family: 'Arial';text-align: center;" v-if="this.language == 'en'">
                <div style="padding-bottom: 20px;">
                    <p style="padding-bottom: 5px;word-break: keep-all;">We have successfully saved the information you entered. </p>
                    <p>Thank you very much for your trust and support.</p>
                </div>

                <div style="padding-bottom: 20px;">
                    <p style="padding-bottom: 5px;word-break: keep-all;">If you need to supplement or update any information, please use this receipt code. </p>
                    <p style="padding-bottom: 5px;word-break: keep-all;font-weight: 700;color:#000">Your Exclusive Login Code</p>
                    <p style="padding-bottom: 5px;word-break: keep-all;">
                        <span style="display: inline-block;width: 50%;text-align: right;">Registration Receipt Code：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receiptemail }}</strong>
                    </p>
                    <p style="word-break: keep-all;">
                        <span style="display: inline-block;width: 50%;text-align: right;">Password：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receippassword }}</strong>
                    </p>
                </div>

                <p>Thank you again!</p>
            </div>
            <div style="font-size: 17px;font-family: 'SourceHanSans';text-align: center;" v-if="this.language == 'cn'">
                <div style="padding-bottom: 20px;">
                    <p>我们已经成功保存了您的录入信息，非常感谢您的信任与支持.</p>
                </div>

                <div style="padding-bottom: 20px;">
                    <p style="padding-bottom: 5px;">如需补充或完善任何信息，请您凭专属登记回执码进行操作.</p>
                    <p style="padding-bottom: 5px;font-weight: 700;color:#000">您的专属登录码</p>
                    <p style="padding-bottom: 5px;">
                        <span style="display: inline-block;width: 50%;text-align: right;">登记回执码：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receiptemail }}</strong>
                    </p>
                    <p><span style="display: inline-block;width: 50%;text-align: right;">密码：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receippassword }}</strong>
                    </p>
                </div>
                
                <p>再次感谢！</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'Arial';font-weight: 700;width: 113px;padding: 8px 15px;" @click="handelSureSaveInfo" v-if="this.language == 'en'">Confirm</el-button>
                <el-button type="primary" size="small" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;" @click="handelSureSaveInfo" v-if="this.language == 'cn'">确 定</el-button>
            </span>
        </el-dialog>




        <el-dialog
            title=""
            :visible.sync="InfoboxdialogVisible"
            custom-class="promptBox"
            width="847px"
            :show-close="false">
            <div style="font-size: 17px;font-family: 'Arial';text-align: center;" v-if="infoIndex == 1">
                <div style="padding-bottom: 20px;">
                    <p style="word-break: keep-all;">We have successfully received your registration information. </p>
                    <p>Thank you very much for your trust and support. </p>
                    <p style="word-break: keep-all;">We will contact and communicate with you as soon as possible.</p>
                </div>

                <div style="padding-bottom: 20px;">
                    <p style="padding-bottom: 5px;word-break: keep-all;">To ensure more efficient communication, please fill in the required communication items and content according to the Project Overview.</p>
                    <p style="padding-bottom: 5px;word-break: keep-all;font-weight: 700;color: #000;">Your Exclusive Login Code</p>
                    <p style="padding-bottom: 5px;word-break: keep-all;">
                        <span style="display: inline-block;width: 50%;text-align: right;">Registration Receipt Code：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receiptemail }}</strong>
                    </p>
                    <p style="word-break: keep-all;">
                        <span style="display: inline-block;width: 50%;text-align: right;">Password：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receippassword }}</strong>
                    </p>
                </div>

                <div>
                    <p style="padding-bottom: 5px;word-break: keep-all;">If you need to supplement or update any information, please use this receipt code.</p>
                    <p style="word-break: keep-all;">Thank you once again!</p>
                </div>
            </div>
            <!--  -->
            <div style="font-size: 17px;font-family: 'SourceHanSans';text-align: center;" v-if="infoIndex == 2">
                <div style="padding-bottom: 20px;">
                     <p style="padding-bottom: 5px;">我们已经成功收到您的登记信息，非常感谢您的信任与支持.</p>
                     <p>我们尽快和您联系及沟通.</p>
                </div>

                <div style="padding-bottom: 20px;">
                    <p style="padding-bottom: 5px;">为了我们的沟通更有效率，请根据［项目概括］填写所需的沟通事项及内容.</p>
                    <p style="padding-bottom: 5px;font-weight: 700;color: #000;">您的专属登录码</p>
                    <p style="padding-bottom: 5px;">
                        <span style="display: inline-block;width: 50%;text-align: right;">登记回执码：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receiptemail }}</strong></p>
                    <p>
                        <span style="display: inline-block;width: 50%;text-align: right;">密码：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receippassword }}</strong>
                    </p>
                </div>
                <div>
                    <p style="padding-bottom: 5px;">如需补充或完善任何信息，请您凭此回执码进行操作.</p>
                    <p>再次感谢!</p>
                </div>
                <!-- 信息提交成功 -->
            </div>
            <span slot="footer" class="dialog-footer">
                <!--  -->
                <button type="primary" class="submit-btn" style="background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;"  @click="handleProjectOverview(1,'cn')" v-if="fullIndex == 1 && infoIndex == 2">项目概括</button>

                <button type="primary" class="submit-btn" size="small" style="background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;" v-if="fullIndex == 1 && infoIndex == 1" @click="handleProjectOverview(1,'en')">Project Overview</button>

                <!-- <button type="primary" class="submit-btn" style="margin-right: 15px;background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;" v-if="fullIndex == 2 && infoIndex == 2" @click="handleFramework(0)">合作框架</button>

                <button class="submit-btn" style="margin-right: 15px;background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;width: 200px;padding: 0;" v-if="fullIndex == 2 && infoIndex == 1" @click="handleFramework(1)">Cooperation Framework</button> -->

                <button class="submit-btn" style="background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;" v-if="fullIndex == 2 && infoIndex == 2" @click="handleProjectOverview(2,'cn',1,3)">项目备案</button>

                <button class="submit-btn" style="background-color: #e0e0e0;color: #333;border: 1px solid #d9d9d9;padding: 0;" v-if="fullIndex == 2 && infoIndex == 1" @click="handleProjectOverview(2,'en',1,3)">Project Registration</button>

                <!-- <el-button type="primary" style="background-color: #409eff;border-color: #409eff;" @click="handelSureInfobox" v-if="infoIndex == 2">确 定</el-button>
                <el-button type="primary" style="background-color: #409eff;border-color: #409eff;" @click="handelSureInfobox" v-if="infoIndex == 1">Confirm</el-button> -->
            </span>
        </el-dialog>

        <!-- 不认同提示 -->
        <el-dialog
            title=""
            :visible.sync="disagreeInfodialogVisible"
            custom-class="promptBox"
            width="847px"
            :before-close="handleDisagreeInfoClose">
            <div style="font-size: 17px;font-family: 'Arial';text-align: center;" v-if="language == 'en'">
                <p style="padding-bottom: 5px;word-break: keep-all;">Thank you for carefully reviewing the standard version of the </p>
                <p style="padding-bottom: 15px;word-break: keep-all;"><strong style="color:#000;font-weight: 500;">Project Development and Collaboration Agreement</strong>.</p>
                <p style="padding-bottom: 15px;word-break: keep-all;">We sincerely welcome your valuable suggestions on the agreement.To facilitate efficient and accurate revisions, please click the <strong style="color:#000;font-weight: 500;">"Edit"</strong> button below.</p>
                <p style="padding-bottom: 15px;word-break: keep-all;">Please submit your specific revision suggestions at the designated markings in the agreement, so that we can clearly understand your comments and requirements.</p>
            </div>
            <div style="font-size: 17px;font-family: 'SourceHanSans';text-align: center;" v-if="language == 'cn'">
                <p style="padding-bottom: 15px;">感谢您仔细阅读平台标准版本的<strong style="color:#000;font-weight: 500;">《项目拓展及协作协议》</strong></p>
                <p style="padding-bottom: 15px;">也非常欢迎您提出协议的宝贵建议</p>
                <p style="padding-bottom: 15px;">为高效、准确地推进修改工作，请您点击下方的<strong style="color:#000;font-weight: 500;">“修改”</strong>按钮。</p>
                <p>在协议指定的标记上提交具体的修改建议，以更清晰地理解您的建议及需求。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="primary" style="background-color: #409eff;border-color: #409eff;" @click="handelSureSaveInfo" v-if="this.language == 'en'">Confirm</el-button> -->
                 <!-- <el-button type="danger">关闭</el-button> -->
                  <el-button type="primary" size="small" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'Arial';font-weight: 700;width: 113px;padding: 8px 15px;" @click="handleEditAgreementInfo" v-if="language == 'en'">Edit</el-button>
                <el-button type="primary" size="small" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;" @click="handleEditAgreementInfo" v-if="language == 'cn'">修 改</el-button>
            </span>
        </el-dialog>

        <!-- 提交修改协议意见提示 -->
        <el-dialog
            title=""
            :visible.sync="modifyOpiniondialogVisible"
            custom-class="promptBox"
            width="847px"
            :show-close="false"
            :before-close="handleClose">
            <div style="font-size: 17px;font-family: 'Arial';text-align: center;" v-if="this.language == 'en'">
                <div style="padding-bottom: 20px;">
                    <p style="padding-bottom: 5px;word-break: keep-all;">We highly appreciate your proposed revisions.</p>
                    <p style="word-break: keep-all;">We shall promptly examine the revised terms and kindly ask for your patience.</p>
                    
                </div>

                <div>
                    <p style="padding-bottom: 5px;word-break: keep-all;">We will contact you again at the earliest opportunity to further discuss the agreement, with a view to concluding a mutually satisfactory cooperation arrangement.</p>
                    <p style="padding-bottom: 5px;word-break: keep-all;font-weight: 700;color: #000">Your Exclusive Login Code</p>
                    <p style="padding-bottom: 5px;word-break: keep-all;">
                        <span style="display: inline-block;width: 50%;text-align: right;">Registration Receipt Code：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receiptemail }}</strong></p>
                    <p>
                        <span style="display: inline-block;width: 50%;text-align: right;">Password：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receippassword }}</strong>
                    </p>
                </div>
                
                
            </div>
            <div style="font-size: 17px;font-family: 'SourceHanSans';text-align: center;" v-if="this.language == 'cn'">
                <div style="padding-bottom: 20px;">
                    <p style="padding-bottom: 5px;">非常感谢您的修改建议.</p>
                    <p>我们会尽快就您的修改条款进行研究，也敬请您耐心等候.</p>
                </div>

                <div>
                    <p style="padding-bottom: 5px;">我们会尽快联系您再次商讨协议，以期达成双方满意的合作协议.</p>
                    <p style="padding-bottom: 5px;font-weight: 700;color:#000">您的专属登录码</p>
                    <p style="padding-bottom: 5px;">
                        <span style="display: inline-block;width: 50%;text-align: right;">登记回执码：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receiptemail }}</strong></p>
                    <p>
                        <span style="display: inline-block;width: 50%;text-align: right;">密码：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receippassword }}</strong>
                    </p>
                </div>
                
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'Arial';font-weight: 700;width: 113px;padding: 8px 15px;" @click="handelmodifyOpinionInfo" v-if="this.language == 'en'">Confirm</el-button>
                <el-button type="primary" size="small" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;" @click="handelmodifyOpinionInfo" v-if="this.language == 'cn'">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 第二次修改意见提示 -->
         <el-dialog
            title=""
            :visible.sync="modifyOpinionTwodialogVisible"
            width="847px"
            custom-class="promptBox"
            :show-close="false"
            :before-close="handleClose">
            <div style="font-size: 17px;font-family: 'Arial';text-align: center;" v-if="this.language == 'en'">
                <div style="margin-bottom: 20px;">
                    <p style="padding-bottom: 5px;word-break: keep-all;">We highly appreciate your suggestions.</p>
                    <p style="word-break: keep-all;">We will promptly review and study your proposed revision terms, and kindly ask for your patience.</p>
                    
                </div>

                <div>
                    <p style="padding-bottom: 5px;word-break: keep-all;">We will contact you as soon as possible to further discuss the agreement, with a view to reaching a mutually satisfactory cooperation agreement. </p>
                    <p style="padding-bottom: 5px;word-break: keep-all;font-weight: 700;color:#000">Your Exclusive Login Code</p>
                    <p style="padding-bottom: 5px;word-break: keep-all;">
                        <span style="display: inline-block;width: 50%;text-align: right;">Registration Receipt Code：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receiptemail }}</strong></p>
                    <p>
                        <span style="display: inline-block;width: 50%;text-align: right;">Password：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receippassword }}</strong></p>
                </div>
                
                
            </div>
            <div style="font-size: 17px;font-family: 'SourceHanSans';text-align: center;" v-if="this.language == 'cn'">
                <div style="margin-bottom: 20px;">
                    <p style="padding-bottom: 5px;">非常感谢您的建议.</p>
                    <p>我们会尽快就您的修改条款进行研究，也敬请您耐心等候.</p>
                   
                </div>

                <div>
                    <p style="padding-bottom: 5px;">我们会尽快联系您再次商讨协议，以期达成双方满意的合作协议.</p>
                    <p style="padding-bottom: 5px;font-weight: 700px;color:#000">您的专属登录码</p>
                    <p style="padding-bottom: 5px;">
                        <span style="display: inline-block;width: 50%;text-align: right;">登记回执码：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receiptemail }}</strong></p>
                    <p>
                        <span style="display: inline-block;width: 50%;text-align: right;">密码：</span>
                        <strong style="color: #000;display: inline-block;width: 50%;text-align: left;">{{ Receippassword }}</strong>
                    </p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'Arial';font-weight: 700;width: 113px;padding: 8px 15px;" @click="handelmodifyOpinionInfo" v-if="this.language == 'en'">Confirm</el-button>
                <el-button type="primary" size="small" style="background-color: #4F81BD;border-color: #4F81BD;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;" @click="handelmodifyOpinionInfo" v-if="this.language == 'cn'">确 定</el-button>
            </span>
        </el-dialog>






        <!-- 协议修改预览文件 -->
        <el-dialog
            title="提示"
            :visible.sync="ViewProjectCasesDialogModel"
            custom-class="EditProjectDialogModel"
            :lock-scroll="true"
            :close-on-click-modal="false"
            :before-close="handleViewProjectCasesClose"
            top="10px"
            width="900px">
            <div slot="title" class="dialog-header" style="font-size: 18px;" v-if="language == 'en'">Project Development and Collaboration Agreement</div>
            <div slot="title" class="dialog-header" style="font-size: 18px;" v-if="language == 'cn'">项目拓展及协作协议</div>
            <div>
                <div style="padding-bottom: 15px;">
                    <p v-if="language == 'cn'">感谢您仔细阅读平台标准版本的(项目拓展及协作协议),以下 V<span style="font-size: 18px;">{{ProjectCasesFile.length}}</span> 版本为最新商讨版本。如无疑议，请点击“确定”按钮。</p>
                     <p v-if="language == 'en'">Thank you for carefully reviewing the standard version of the Project Development and Collaboration Agreement. The Version V <span style="font-size: 18px;">{{ProjectCasesFile.length}}</span> below is the latest negotiated draft. Please click the "Confirm" button if you have no objections.</p>
                </div>
                <el-tabs v-model="activeName" type="card" >
                    <el-tab-pane :label="'V' + ((ProjectCasesFile.length - index))" :name="(index)+''" v-for="(item, index) in ProjectCasesFile" :key="index">
                        <div class="customer-main-content" :style="{height: dialogHeight+'px'}">
                            <vue-office-pdf
                                :src="item.nfileurl"
                                :style="{height: dialogHeight+'px'}"
                                @rendered="renderedHandler"
                            />
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="danger" @click="handleViewProjectCasesClose" v-if="modifyNtype != 5">关闭</el-button> -->
                <el-button type="primary" size="small" @click="handleConfirmatObjectInfo" style="border: 1px solid #4F81BD;background-color: #4F81BD;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;" v-if="language == 'cn'">修改</el-button>
                <el-button type="primary" size="small" @click="handleConfirmatiAgreementInfo" style="border: 1px solid #e0e0e0;font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;background-color: #e0e0e0;color: #000;" v-if="language == 'cn'">确认</el-button>

                <el-button type="primary" size="small" @click="handleConfirmatObjectInfo" style="border: 1px solid #4F81BD;background-color: #4F81BD;font-size: 18px;font-family: 'Arial';font-weight: 700;width: 113px;padding: 8px 15px;" v-if="language == 'en'">Edit</el-button>
                <el-button type="primary" size="small" @click="handleConfirmatiAgreementInfo" style="border: 1px solid #e0e0e0;font-size: 18px;font-family: 'Arial';font-weight: 700;width: 113px;padding: 8px 15px;background-color: #e0e0e0;color: #000;" v-if="language == 'en'">Confirm</el-button>
            </span>
        </el-dialog>
        <!-- end -->

        <!-- 预览合作框架协议文件 -->
        <el-dialog
            title="提示"
            :visible.sync="FrameworkAgreementDialogModel"
            custom-class="EditProjectDialogModel"
            :lock-scroll="true"
            :close-on-click-modal="false"
            :before-close="handleFrameworkAgreementClose"
            top="10px"
            width="900px">
            <div slot="title" class="dialog-header" style="font-size: 18px;" v-if="language == 'cn'">合作框架</div>
            <div slot="title" class="dialog-header" style="font-size: 18px;" v-if="language == 'en'">Cooperation Framework</div>
                <vue-office-pdf
                    :src="frameworkUrl"
                    :style="{height: dialogHeight+'px'}"
                    @rendered="renderedHandler"
                />
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" size="small" style="font-size: 18px;font-family: 'SourceHanSans';width: 113px;padding: 8px 15px;" @click="handleFrameworkAgreementClose" v-if="language == 'cn'">关闭</el-button>
                <el-button type="danger" size="small" style="font-size: 18px;font-family: 'Arial';font-weight: 700;width: 113px;padding: 8px 15px;" @click="handleFrameworkAgreementClose" v-if="language == 'en'">Close</el-button>
            </span>
        </el-dialog>
        <!-- end -->




        

        
        <!-- 尾部导航公共组件 -->
        <!-- <Footer></Footer> -->
        <!-- end -->
    </div>
</template>

<script>
// import Header from '@/components/Header.vue'
// import Footer from '@/components/Footer.vue'
import VueFullscreen from 'vue-fullscreen'
import {pcaTextArr} from "element-china-area-data"

import VueOfficePdf from '@vue-office/pdf'
import '@vue/composition-api'
// import { worldData,CodeToText} from 'qing-element-world-area'
// 
// setProjectPartnerDisagreeInfo
// // 
// 
// 
import {setUserInfomation,SetEditorUploadImage,setAddDataInfo,getRelateProjectList,getParterRelateProjectList,setPartnerAddDataInfo,setEditUpdatePartnerAddDataInfo,setDisputeContractInfo,setConfirmModificatAgreementInfo,setEntrustEditDataInfo,setProjectPartnerInfo} from '@/api/axios-api'

export default {
    name: 'Home',
    components: {
        VueOfficePdf
        // Header,
        // Footer,
        // HelloWorld,
        // loading
    },
    data () {
        return {
            // worldData,
            selectedCountry: '',
            pcaTextArr,
            // CodeToText,
            VueFullscreen,
            isScroll: 4,
            videoHeight: 0,
            isChildeNavigat: true,
            isFullImags: false,
            isCooperat: false,
            InfomatdialogVisible: false,
            tispdialogVisible: false,
            InfoboxdialogVisible: false,
            AcceptdialogVisible: false,
            SaveInfodialogVisible: false,
            ReceiptEmaildialogVisible: false,
            disagreeInfodialogVisible: false,
            modifyOpiniondialogVisible: false,
            ViewProjectCasesDialogModel: false,
            codePromptdialogVisible: false,
            projectListInfodialogVisible: false,
            LogindialogVisible: false,
            modifyOpinionTwodialogVisible: false,
            FrameworkAgreementDialogModel: false,
            lastScrollTime: 0, // 上次滚动的毫秒时间戳
            scrollSpeed: 500, // 滚动速度（毫秒）
            contectList: [
                require('@/assets/images/contect_1.jpg'),
                require('@/assets/images/contect_2.jpg'),
                require('@/assets/images/contect_3.jpg'),
                // require('@/assets/images/contect_4.jpg'),
                // require('@/assets/images/contect_5.jpg'),
                // require('@/assets/images/contect_6.jpg'),
            ],
            isRollerSpeed: true,
            escCount: 0,
            activeIndex: 0,
            activeIndexInitial: 0,
            activeName: '0',
            contectListFull: [
                require('@/assets/images/contect_4.jpg'),
                require('@/assets/images/contect_5.jpg'),
                require('@/assets/images/contect_6.jpg'),
            ],
            isCooperatListFull: [
                require('@/assets/images/video/Cooperation_1.jpg'),
                require('@/assets/images/video/Cooperation_2.jpg'),
            ],
            CoopIndex: 0,
            fullIndex: 0,
            isFullNumber: 0,
            infoIndex: 1,
            dpi: 0,
            enfname: '',
            enlname: '',
            enaddress: '',
            ennumber: '',
            enlocation: '',
            ensubject: '',
            enenquiry: '',
            cnname: '', //姓名
            cnaddress: '', //所在地
            cnemail: '', //邮箱
            Receiptemail: '', //回执邮箱
            Receippassword: '', //回执密码
            cnphone: '', //电话
            cnsubject: '', //主题
            cnenquiry: '', //内容
            dialogHeight: 0,
            ruleForm: {
                projectname: '', // 项目名称
                projecttype: '', // 项目类别
                projectplace: '', // 项目类型
                projectstage: '', // 成果交付阶段

                projectnode: '',  // 节点阶段

                projectscale: {projectscaleFee: '', projectscaleInfo: ''}, //项目规模

                projectsite: '', // 项目地点
                projecthetonOne: '',
                // projectheton: {projecthetonOne: [], projecthetonTwo: []}, // 到账合同

                companynames: {companynameInfo: '', companynameProjectInfo: ''}, // 业主名称

                markrival: {markrivalName: '', markrivalInfo: ''}, // 竞标对手

                projectaware: '', // 合作记录

                markprocess: '', // 定标流程

                reportprocess: '', // 汇报流程

                projectsource:'', // 信息来源

                companytype: '', // 业主性质

                projectnote: '', // 招标形式

                projectpace: '', // 建设进度
                zmoney: '', // 招标费用

                bidTime: [], // 招标时间

                proexecutor: [{name: '', posit: '', iphone: ''}], // 项目执行人
                procurator: [{name: '', posit: ''}], // 项目负责人
                promaker: [{name: '', posit: ''}], // 项目决策人

                
            },
             projectDataFile: [
                {
                    fileid: '',
                    filename: '业主企业简介',
                    fileurl: '',
                },
                {
                    fileid: '',
                    filename: '设计任务书',
                    fileurl: '',
                },
                {
                    fileid: '',
                    filename: '项目基础资料',
                    fileurl: '',
                },
                {
                    fileid: '',
                    filename: '其它',
                    fileurl: '',
                },
            ],
            projectDataEnFile: [
                {
                    fileid: '',
                    filename: 'Client Company Profile',
                    fileurl: '',
                },
                {
                    fileid: '',
                    filename: 'Design Brief',
                    fileurl: '',
                },
                {
                    fileid: '',
                    filename: 'Basic Project Information',
                    fileurl: '',
                },
                {
                    fileid: '',
                    filename: 'Other',
                    fileurl: '',
                },
            ],
            
            isNodePhase: false,
            title: '',
            categoryType: '',
            Pixel_one: false,
            Pixel_two: false,
            Pixel_tree: false,
            Pixel_foure: false,
            Pixel_five: false,
            Pixel_six: false,
            Pixel_seve: false,
            language: '', // 语言
            isExitFullscreen: 0,
            coutry: [
                { name: 'Afghanistan', code: 'AF' },
                { name: 'Albania', code: 'AL' },
                { name: 'Algeria', code: 'DZ' },
                { name: 'Andorra', code: 'AD' },
                { name: 'Angola', code: 'AO' },
                { name: 'Antigua and Barbuda', code: 'AG' },
                { name: 'Argentina', code: 'AR' },
                { name: 'Armenia', code: 'AM' },
                { name: 'Australia', code: 'AU' },
                { name: 'Austria', code: 'AT' },
                { name: 'Azerbaijan', code: 'AZ' },
                { name: 'Bahamas', code: 'BS' },
                { name: 'Bahrain', code: 'BH' },
                { name: 'Bangladesh', code: 'BD' },
                { name: 'Barbados', code: 'BB' },
                { name: 'Belarus', code: 'BY' },
                { name: 'Belgium', code: 'BE' },
                { name: 'Belize', code: 'BZ' },
                { name: 'Benin', code: 'BJ' },
                { name: 'Bhutan', code: 'BT' },
                { name: 'Bolivia', code: 'BO' },
                { name: 'Bosnia and Herzegovina', code: 'BA' },
                { name: 'Botswana', code: 'BW' },
                { name: 'Brazil', code: 'BR' },
                { name: 'Brunei', code: 'BN' },
                { name: 'Bulgaria', code: 'BG' },
                { name: 'Burkina Faso', code: 'BF' },
                { name: 'Burundi', code: 'BI' },
                { name: 'Cabo Verde', code: 'CV' },
                { name: 'Cambodia', code: 'KH' },
                { name: 'Cameroon', code: 'CM' },
                { name: 'Canada', code: 'CA' },
                { name: 'Central African Republic', code: 'CF' },
                { name: 'Chad', code: 'TD' },
                { name: 'Chile', code: 'CL' },
                { name: 'China', code: 'CN' },
                { name: 'Colombia', code: 'CO' },
                { name: 'Comoros', code: 'KM' },
                { name: 'Congo (Congo-Brazzaville)', code: 'CG' },
                { name: 'Costa Rica', code: 'CR' },
                { name: 'Croatia', code: 'HR' },
                { name: 'Cuba', code: 'CU' },
                { name: 'Cyprus', code: 'CY' },
                { name: 'Czech Republic (Czechia)', code: 'CZ' },
                { name: 'Denmark', code: 'DK' },
                { name: 'Djibouti', code: 'DJ' },
                { name: 'Dominica', code: 'DM' },
                { name: 'Dominican Republic', code: 'DO' },
                { name: 'East Timor (Timor-Leste)', code: 'TL' },
                { name: 'Ecuador', code: 'EC' },
                { name: 'Egypt', code: 'EG' },
                { name: 'El Salvador', code: 'SV' },
                { name: 'Equatorial Guinea', code: 'GQ' },
                { name: 'Eritrea', code: 'ER' },
                { name: 'Estonia', code: 'EE' },
                { name: 'Eswatini (fmr. Swaziland)', code: 'SZ' },
                { name: 'Ethiopia', code: 'ET' },
                { name: 'Fiji', code: 'FJ' },
                { name: 'Finland', code: 'FI' },
                { name: 'France', code: 'FR' },
                { name: 'Gabon', code: 'GA' },
                { name: 'Gambia', code: 'GM' },
                { name: 'Georgia', code: 'GE' },
                { name: 'Germany', code: 'DE' },
                { name: 'Ghana', code: 'GH' },
                { name: 'Greece', code: 'GR' },
                { name: 'Grenada', code: 'GD' },
                { name: 'Guatemala', code: 'GT' },
                { name: 'Guinea', code: 'GN' },
                { name: 'Guinea-Bissau', code: 'GW' },
                { name: 'Guyana', code: 'GY' },
                { name: 'Haiti', code: 'HT' },
                { name: 'Honduras', code: 'HN' },
                { name: 'Hungary', code: 'HU' },
                { name: 'Iceland', code: 'IS' },
                { name: 'India', code: 'IN' },
                { name: 'Indonesia', code: 'ID' },
                { name: 'Iran', code: 'IR' },
                { name: 'Iraq', code: 'IQ' },
                { name: 'Ireland', code: 'IE' },
                { name: 'Israel', code: 'IL' },
                { name: 'Italy', code: 'IT' },
                { name: 'Ivory Coast', code: 'CI' },
                { name: 'Jamaica', code: 'JM' },
                { name: 'Japan', code: 'JP' },
                { name: 'Jordan', code: 'JO' },
                { name: 'Kazakhstan', code: 'KZ' },
                { name: 'Kenya', code: 'KE' },
                { name: 'Kiribati', code: 'KI' },
                { name: 'Kosovo', code: 'XK' },
                { name: 'Kuwait', code: 'KW' },
                { name: 'Kyrgyzstan', code: 'KG' },
                { name: 'Laos', code: 'LA' },
                { name: 'Latvia', code: 'LV' },
                { name: 'Lebanon', code: 'LB' },
                { name: 'Lesotho', code: 'LS' },
                { name: 'Liberia', code: 'LR' },
                { name: 'Libya', code: 'LY' },
                { name: 'Liechtenstein', code: 'LI' },
                { name: 'Lithuania', code: 'LT' },
                { name: 'Luxembourg', code: 'LU' },
                { name: 'Madagascar', code: 'MG' },
                { name: 'Malawi', code: 'MW' },
                { name: 'Malaysia', code: 'MY' },
                { name: 'Maldives', code: 'MV' },
                { name: 'Mali', code: 'ML' },
                { name: 'Malta', code: 'MT' },
                { name: 'Marshall Islands', code: 'MH' },
                { name: 'Mauritania', code: 'MR' },
                { name: 'Mauritius', code: 'MU' },
                { name: 'Mexico', code: 'MX' },
                { name: 'Micronesia', code: 'FM' },
                { name: 'Moldova', code: 'MD' },
                { name: 'Monaco', code: 'MC' },
                { name: 'Mongolia', code: 'MN' },
                { name: 'Montenegro', code: 'ME' },
                { name: 'Morocco', code: 'MA' },
                { name: 'Mozambique', code: 'MZ' },
                { name: 'Myanmar (formerly Burma)', code: 'MM' },
                { name: 'Namibia', code: 'NA' },
                { name: 'Nauru', code: 'NR' },
                { name: 'Nepal', code: 'NP' },
                { name: 'Netherlands', code: 'NL' },
                { name: 'New Zealand', code: 'NZ' },
                { name: 'Nicaragua', code: 'NI' },
                { name: 'Niger', code: 'NE' },
                { name: 'Nigeria', code: 'NG' },
                { name: 'North Korea', code: 'KP' },
                { name: 'North Macedonia', code: 'MK' },
                { name: 'Norway', code: 'NO' },
                { name: 'Oman', code: 'OM' },
                { name: 'Pakistan', code: 'PK' },
                { name: 'Palau', code: 'PW' },
                { name: 'Palestine', code: 'PS' },
                { name: 'Panama', code: 'PA' },
                { name: 'Papua New Guinea', code: 'PG' },
                { name: 'Paraguay', code: 'PY' },
                { name: 'Peru', code: 'PE' },
                { name: 'Philippines', code: 'PH' },
                { name: 'Poland', code: 'PL' },
                { name: 'Portugal', code: 'PT' },
                { name: 'Qatar', code: 'QA' },
                { name: 'Romania', code: 'RO' },
                { name: 'Russia', code: 'RU' },
                { name: 'Rwanda', code: 'RW' },
                { name: 'Saint Kitts and Nevis', code: 'KN' },
                { name: 'Saint Lucia', code: 'LC' },
                { name: 'Saint Vincent and the Grenadines', code: 'VC' },
                { name: 'Samoa', code: 'WS' },
                { name: 'San Marino', code: 'SM' },
                { name: 'Sao Tome and Principe', code: 'ST' },
                { name: 'Saudi Arabia', code: 'SA' },
                { name: 'Senegal', code: 'SN' },
                { name: 'Serbia', code: 'RS' },
                { name: 'Seychelles', code: 'SC' },
                { name: 'Sierra Leone', code: 'SL' },
                { name: 'Singapore', code: 'SG' },
                { name: 'Slovakia', code: 'SK' },
                { name: 'Slovenia', code: 'SI' },
                { name: 'Solomon Islands', code: 'SB' },
                { name: 'Somalia', code: 'SO' },
                { name: 'South Africa', code: 'ZA' },
                { name: 'South Korea', code: 'KR' },
                { name: 'South Sudan', code: 'SS' },
                { name: 'Spain', code: 'ES' },
                { name: 'Sri Lanka', code: 'LK' },
                { name: 'Sudan', code: 'SD' },
                { name: 'Suriname', code: 'SR' },
                { name: 'Sweden', code: 'SE' },
                { name: 'Switzerland', code: 'CH' },
                { name: 'Syria', code: 'SY' },
                { name: 'Tajikistan', code: 'TJ' },
                { name: 'Tanzania', code: 'TZ' },
                { name: 'Thailand', code: 'TH' },
                { name: 'Togo', code: 'TG' },
                { name: 'Tonga', code: 'TO' },
                { name: 'Trinidad and Tobago', code: 'TT' },
                { name: 'Tunisia', code: 'TN' },
                { name: 'Turkey', code: 'TR' },
                { name: 'Turkmenistan', code: 'TM' },
                { name: 'Tuvalu', code: 'TV' },
                { name: 'Uganda', code: 'UG' },
                { name: 'Ukraine', code: 'UA' },
                { name: 'United Arab Emirates', code: 'AE' },
                { name: 'United Kingdom', code: 'GB' },
                { name: 'United States', code: 'US' },
                { name: 'Uruguay', code: 'UY' },
                { name: 'Uzbekistan', code: 'UZ' },
                { name: 'Vanuatu', code: 'VU' },
                { name: 'Vatican City', code: 'VA' },
                { name: 'Venezuela', code: 'VE' },
                { name: 'Vietnam', code: 'VN' },
                { name: 'Yemen', code: 'YE' },
                { name: 'Zambia', code: 'ZM' },
                { name: 'Zimbabwe', code: 'ZW' }
                ],

            fullScreenHeight: 0,

            cnrelateid: '', // 项目委托中文id
            enrelateid: '', // 项目委托英文id
            relateid: '', // 项目委托（项目概况提交资料）
            cnmateid: '', // 项目合伙人中文id
            enmateid: '', // 项目合伙人英文id
            mateid: '', // 项目合伙人项目备案（项目项目备案提交资料）
            disReason: '',
            emailstr: '',
            desc: '',
            etypeLanguage: '',
            // 项目委托（项目概况提交资料）
            modifyStatus: false,
            modify_1: {value: '', state: false},
            modify_2: {value: '', state: false},
            modify_3: {value: '', state: false},
            modify_4: {value: '', state: false},
            modify_5: {value: '', state: false},
            modify_6: {value: '', state: false},
            modify_7: {value: '', state: false},
            modify_8: {value: '', state: false},
            modify_9: {value: '', state: false},
            modify_10: {value: '', state: false},
            modify_11: {value: '', state: false},
            modify_12: {value: '', state: false},
            modify_13: {value: '', state: false},
            modify_14: {value: '', state: false},
            modify_15: {value: '', state: false},
            modify_16: {value: '', state: false},
            modify_17: {value: '', state: false},
            modify_18: {value: '', state: false},
            modify_19: {value: '', state: false},
            ischecked: false,
            modifyNtype: '',
            ProjectCasesFile: [],
            projectListData: [],
            etype: '',
            operatStatus: 0,
            projectid: '',
            isEdit: false,
            userName: '',
            emailstrpassword: '',
            metepassword: '',
            activeProjectName: 'first',
            userInfo: {},
            frameworkUrl: '',
            numstr: '',
            scaleRatio: 1,
            baseWidth: 1920,
            isScrollBox: false
        }
    },

    created () {
        // alert(this.$route.query.index)
        if (this.$route.query.index != undefined && this.$route.query.role != undefined) {
            this.activeIndexInitial = this.$route.query.index

            if (this.$route.query.login == 1) {
                if (this.$route.query.role == 1) {
                    this.fullIndex = this.$route.query.role
                    this.LogindialogVisible = true
                } else if (this.$route.query.role == 2) {
                    this.isFullImags = true
                    this.isCooperat = true
                    this.fullIndex = this.$route.query.role
                    this.infoIndex = this.$route.query.infoIndex

                    // this.etypeLanguage = 

                    if (this.$route.query.infoIndex == 2) {
                        // this.fullIndex = this.$route.query.role
                        // this.infoIndex = this.$route.query.infoIndex
                        this.cnname = this.$route.query.cnname
                        this.cnaddress = this.$route.query.cnaddress
                        this.cnemail = this.$route.query.cnemail
                        this.cnphone = this.$route.query.cnphone
                        this.cnsubject = this.$route.query.cnsubject
                        this.cnenquiry = this.$route.query.cnenquiry
                        this.CoopIndex = 1
                        this.etypeLanguage = 1
                    } else if (this.$route.query.infoIndex == 1) {
                        
                        this.enfname = this.$route.query.enfname
                        this.enlname = this.$route.query.enlname
                        this.enaddress = this.$route.query.enaddress
                        this.ennumber = this.$route.query.ennumber
                        this.enlocation = this.$route.query.enlocation
                        this.ensubject = this.$route.query.ensubject
                        this.enenquiry = this.$route.query.enenquiry
                        this.CoopIndex = 0
                        this.etypeLanguage = 2
                    }
                }
            } else if (this.$route.query.login == 2) {
                this.fullIndex = this.$route.query.role
                this.LogindialogVisible = true
            }
            
        }
    },

    mounted () {

        // alert(window.innerHeight)
        // alert(window.navigator.platform)
        document.body.style.overflow = 'auto'

        document.body.style.overflow = 'auto'

        const userAgent = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|Macintosh|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
         if (userAgent) {
            if (window.innerWidth <= 1024) {
                this.scaleRatio = window.innerWidth / 1620
            } else if (window.innerWidth > 1024 && window.innerWidth <= 1470) {
                this.scaleRatio = window.innerWidth / (this.baseWidth - 100)
            } else if (window.innerWidth > 1470 && window.innerWidth <= 1920) {
                this.scaleRatio = window.innerWidth / (this.baseWidth + 200)
            } else {
                this.scaleRatio = window.innerWidth / 1700
            }
            // alert(this.scaleRatio)
         } else {
            if (window.innerWidth <= 1920) {
                if (window.devicePixelRatio < 2) {
                    this.scaleRatio = window.innerWidth / (this.baseWidth + 200)
                } else {
                    this.scaleRatio = window.innerWidth / (this.baseWidth - 100)
                }
                
            } else if (window.innerWidth > 1920 && window.innerWidth <= 2048) {
                this.scaleRatio = window.innerWidth / 2048
            } else if (window.innerWidth > 2048){
                this.scaleRatio = window.innerWidth / 2560
            }
         }

        
        
        // if (window.innerWidth > 1050) {
            
            
        // } else {
        //     this.isScrollBox = true
        // }
        
        // console.log(scaleRatio)
        // alert(scaleRatio)
        // alert(window.innerWidth)

        this.dpi = window.devicePixelRatio

        // console.log('------------')
        // console.log(window.devicePixelRatio)
        // console.log('------------')

        // if (window.devicePixelRatio > 1 && window.devicePixelRatio < 1.3 && window.innerWidth > 1920) {
        //     this.Pixel_one = true
        // } else if (window.devicePixelRatio == 1 && window.innerWidth > 1920) {
        //     this.Pixel_foure = true
            
        // } else if (window.devicePixelRatio > 1 && window.devicePixelRatio < 1.3 && window.innerWidth < 1920) {
        //     this.Pixel_two = true
            
        // } else if (window.devicePixelRatio > 1.3 && window.devicePixelRatio < 1.7 && window.innerWidth < 1920) {
        //     this.Pixel_tree = true
            
        // } else if (window.devicePixelRatio > 1.7 && window.devicePixelRatio < 1.9 && window.innerWidth < 1920) {
        //     this.Pixel_five = true
            
        // } else if (window.devicePixelRatio > 1.9 && window.innerWidth > 1715) {
        //     this.Pixel_six = true
            
        // } else if (window.devicePixelRatio > 1.9 && window.innerWidth < 1715) {
        //     this.Pixel_seve = true
            
        // }
        // this.screenWidth = window.innerWidth;
        // this.screenHeight = window.innerHeight;
        // console.log(window.innerWidth)
        // console.log(window.innerHeight)
        // alert(this.dpi)
            // alert(dpi)
            
        this.dialogHeight = window.innerHeight - 250

        this.fullScreenHeight = window.innerHeight
        window.onresize = () => {
            // if (this.isExitFullscreen != 1) {
            //     if (!document.fullscreenElement) {
            //         this.$router.push({
            //             path: '/projectList',
            //         })
            //         // console.log('1212')
            //     }
            // }
            const userAgent = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|Macintosh|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            if (userAgent) {
                if (window.innerWidth <= 1024) {
                    this.scaleRatio = window.innerWidth / 1620
                } else if (window.innerWidth > 1024 && window.innerWidth <= 1470) {
                    this.scaleRatio = window.innerWidth / (this.baseWidth - 100)
                } else if (window.innerWidth > 1470 && window.innerWidth <= 1920) {
                    this.scaleRatio = window.innerWidth / (this.baseWidth + 200)
                } else {
                    this.scaleRatio = window.innerWidth / 1700
                }
                
            } else {
                if (window.innerWidth <= 1920) {
                    if (window.devicePixelRatio < 2) {
                        this.scaleRatio = window.innerWidth / (this.baseWidth + 200)
                    } else {
                        this.scaleRatio = window.innerWidth / (this.baseWidth - 100)
                    }
                }  else if (window.innerWidth > 1920 && window.innerWidth <= 2048) {
                    this.scaleRatio = window.innerWidth / 2048
                } else if (window.innerWidth > 2048){
                        this.scaleRatio = window.innerWidth / 2560
                    this.isScrollBox = true
                }
            }

            
            

            this.fullScreenHeight = window.innerHeight
           
            this.dialogHeight = window.innerHeight - 250
            // this.projectColHeight = ((this.$refs.projectCol[0].offsetWidth + 40) * 1) / 2
        }   

        // this.toggleFullScreen(document.documentElement)
        this.addMouseWheelListener();

         window.addEventListener('keydown', this.globalKeyDown)

        // const handleFullscreenChange = () => {
        //     // alert('1212')
        //     if (!document.fullscreenElement) {
        //     // 当前不在全屏状态，执行你的自定义逻辑
        //     console.log('已退出全屏');
        //     // 例如：显示侧边栏、恢复头部、更新 UI 状态等
        //     this.isFullScreen = false;
        //     // 你的其他业务逻辑...
        //     } else {
        //     // 进入了全屏状态
        //     this.isFullScreen = true;
        //     }
        // };
        // document.addEventListener('fullscreenchange', handleFullscreenChange);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.globalKeyDown)
    },
    methods: {

        handleViewFramework (fielUrl) {
            this.frameworkUrl = fielUrl[0].nfileurl
            this.FrameworkAgreementDialogModel = true
        },
        handleFrameworkAgreementClose () {
            this.FrameworkAgreementDialogModel = false
        },

        // 添加项目
        handleAddProjectInfo (status) {
            // alert('121')
            if (this.fullIndex == 1) {
                if (this.language == 'cn') {
                    this.title = '项目概括'
                } else {
                    this.title = 'Project Overview'
                }
            } else if (this.fullIndex == 2) {
                if (this.language == 'cn') {
                    this.title = '项目备案'
                } else {
                    this.title = 'Project Registration'
                }
            }
            this.operatStatus = status
            this.isEdit = false
            this.ruleForm.projectname = ''
            this.ruleForm.projecttype = ''
            this.ruleForm.projectplace = ''
            this.ruleForm.projectstage = ''
            this.ruleForm.projectnode = ''
            this.ruleForm.projectscale.projectscaleFee = ''
            this.ruleForm.projectscale.projectscaleInfo = ''
            this.ruleForm.projectsite = ''
            this.ruleForm.projecthetonOne = ''
            this.ruleForm.companynames.companynameInfo = ''
            this.ruleForm.companynames.companynameProjectInfo = ''
            this.ruleForm.markrival.markrivalName = ''
            this.ruleForm.markrival.markrivalInfo = ''
            this.ruleForm.projectaware = ''
            this.ruleForm.markprocess = ''
            this.ruleForm.reportprocess = ''
            this.ruleForm.projectsource = ''
            this.ruleForm.companytype = ''
            this.ruleForm.projectnote = ''
            this.ruleForm.projectpace = ''
            this.ruleForm.zmoney = ''
            this.ruleForm.bidTime = []

            this.ruleForm.proexecutor[0].name = ''
            this.ruleForm.proexecutor[0].posit = ''
            this.ruleForm.proexecutor[0].iphone = ''

            this.ruleForm.procurator[0].name = ''
            this.ruleForm.procurator[0].posit = ''

            this.ruleForm.promaker[0].name = ''
            this.ruleForm.promaker[0].posit = ''

            // this.ruleForm.proexecutor.name = ''
            // this.ruleForm.proexecutor.posit = ''
            // this.ruleForm.proexecutor.iphone = ''

            // this.ruleForm.procurator.name = ''
            // this.ruleForm.procurator.posit = ''

            // this.ruleForm.promaker.name = ''
            // this.ruleForm.promaker.posit = ''

            for (let i = 0; i < this.projectDataFile.length; i++) {
                this.projectDataFile[i].fileurl = ''
            }

            for (let i = 0; i < this.projectDataEnFile.length; i++) {
                this.projectDataEnFile[i].fileurl = ''
            }
            this.$nextTick(() => {
                this.$refs.ruleForm.clearValidate()
            })
            this.InfomatdialogVisible = true
        },

        handleprojectListInfoClose () {
            this.projectListInfodialogVisible = false
        },
        // 编辑更新数据
        handleEditDetailsInfo (projectid,status) {
            if (status == 2) {
                this.isEdit = true
            } else {
                this.isEdit = false
            }
            this.operatStatus = status
            this.projectid = projectid
            for (let i = 0; i < this.projectListData.length; i++) {
                if (this.projectListData[i].projectid == projectid) {
                    this.ruleForm.projectname = this.projectListData[i].projectname
                    this.ruleForm.projecttype = this.projectListData[i].projecttype
                    this.ruleForm.projectplace = this.projectListData[i].projectplace
                    this.ruleForm.projectstage = this.projectListData[i].projectstage
                    this.ruleForm.projectnode = this.projectListData[i].projectnode

                    if (this.projectListData[i].projectscale != null) {
                        this.ruleForm.projectscale = JSON.parse(this.projectListData[i].projectscale)
                    }

                    this.ruleForm.projecthetonOne = this.projectListData[i].projectheton
                    if (this.projectListData[i].projectsite != null) {
                        this.ruleForm.projectsite = this.projectListData[i].projectsite.split('/')
                    }
                    if (this.projectListData[i].companyname != null) {
                        this.ruleForm.companynames = JSON.parse(this.projectListData[i].companyname)
                    }

                    if (this.projectListData[i].markrival != null) {
                        this.ruleForm.markrival = JSON.parse(this.projectListData[i].markrival)
                    }
                    
                    
                    this.ruleForm.projectaware = this.projectListData[i].projectaware
                    this.ruleForm.markprocess = this.projectListData[i].markprocess
                    this.ruleForm.reportprocess = JSON.parse(this.projectListData[i].reportprocess)
                    this.ruleForm.projectsource = this.projectListData[i].projectsource
                    this.ruleForm.companytype = this.projectListData[i].companytype
                    this.ruleForm.projectnote = this.projectListData[i].projectnote
                    this.ruleForm.projectpace = this.projectListData[i].projectpace
                    this.ruleForm.zmoney = this.projectListData[i].zmoney

                    if (this.projectListData[i].proexecutor != null) {
                        this.ruleForm.proexecutor = JSON.parse(this.projectListData[i].proexecutor)
                    }

                    if (this.projectListData[i].procurator != null) {
                        this.ruleForm.procurator = JSON.parse(this.projectListData[i].procurator)
                    }

                    if (this.projectListData[i].promaker != null) {
                        this.ruleForm.promaker = JSON.parse(this.projectListData[i].promaker)
                    }
                    
                    const timeArray = []

                    if (this.projectListData[i].stime != null) {
                        timeArray.push(this.projectListData[i].stime.split("T")[0])
                        timeArray.push(this.projectListData[i].etime.split("T")[0])
                    }
                    this.ruleForm.bidTime = timeArray

                    if (this.etype == 1) {
                        if (this.projectListData[i].files != null) {
                            this.projectDataFile = JSON.parse(this.projectListData[i].files)
                        }
                        
                    } else if (this.etype == 2) {
                        if (this.projectListData[i].files != null) {
                            this.projectDataEnFile = JSON.parse(this.projectListData[i].files)
                        }
                        
                    }
                }
            }
            this.InfomatdialogVisible = true
        },

        // 确认修改协议
        handleConfirmatiAgreementInfo () {
            const parseInfo = {}
            parseInfo.mateid = this.mateid

            setConfirmModificatAgreementInfo(parseInfo).then(res => {
                if (res.code == 0) {
                    // console.log(res)
                    const parseInfo = {}
                    parseInfo.emailstr = this.Receiptemail
                    parseInfo.pwdstr = this.metepassword

                    // console.log(parseInfo)
                    // return false
                    // parseInfo.emailstr = this.emailstr
                    // parseInfo.etype = this.etype
                    getParterRelateProjectList(parseInfo).then(res => {
                        if (res.code == 0) {
                            
                            this.userInfo = res.map.mate
                            this.userName = res.map.mate.cnname
                            // this.Receiptemail = res.map.mate.cnemail
                            this.etype = res.map.mate.etype
                            this.mateid = res.map.mate.mateid
                            this.projectListData = res.map.mate.projects

                            this.numstr = res.map.mate.numstr

                            if (res.map.mate.etype == 1) {
                                this.language = 'cn'
                                this.Receiptemail = res.map.mate.cnemail
                                this.Receippassword = res.map.mate.cnphone
                                this.metepassword = res.map.mate.cnphone
                                sessionStorage.setItem('Receiptemail',res.map.mate.cnemail)
                                sessionStorage.setItem('metepassword',res.map.mate.cnphone)

                            } else if (res.map.mate.etype == 2) {
                                this.language = 'en'
                                this.userName = res.map.mate.enfname + ' '+ res.map.mate.enlname
                                this.Receiptemail = res.map.mate.enaddress
                                this.Receippassword = res.map.mate.ennumber
                                this.metepassword = res.map.mate.ennumber

                                sessionStorage.setItem('Receiptemail',res.map.mate.enaddress)
                                sessionStorage.setItem('metepassword',res.map.mate.ennumber)
                            }
                            
                            // this.isFullImags = true
                            this.LogindialogVisible = false
                            this.projectListInfodialogVisible = true
                        }
                    })
                    this.ViewProjectCasesDialogModel = false

                } else {
                    this.$message({
                        message: res.message,
                        type: 'error',
                        offset: 80,
                        duration: 2000
                    }) 
                }
            })
        },

        // 有异议
        handleConfirmatObjectInfo () {
            const parseInfo = {}
            parseInfo.mateid = this.mateid
            setDisputeContractInfo(parseInfo).then(res => {
                if (res.code == 0) {

                    this.modifyOpinionTwodialogVisible = true
                    this.ViewProjectCasesDialogModel = false

                } else {
                    this.$message({
                        message: res.message,
                        type: 'error',
                        offset: 80,
                        duration: 2000
                    }) 
                }

            })
            // console.log(parseInfo)
        },




        validateInput(type) {
            if (type == 1) {
                if (this.modify_1.value > 100) {
                    this.modify_1.value = 100; // 或者设置为空字符串，根据需要调整
                } 
            } else if (type == 2) {
                if (this.modify_2.value > 100) {
                    this.modify_2.value = 100; // 或者设置为空字符串，根据需要调整
                } 
            } else if (type == 3) {
                if (this.modify_3.value > 100) {
                    this.modify_3.value = 100; // 或者设置为空字符串，根据需要调整
                } 
            } else if (type == 4) {
                if (this.modify_4.value > 100) {
                    this.modify_4.value = 100; // 或者设置为空字符串，根据需要调整
                } 
            }
            
        },
        handleFrameworkInfo () {
            this.ViewProjectCasesDialogModel = true
        },
        handleViewProjectCasesClose () {
            this.ViewProjectCasesDialogModel = false
        },
        renderedHandler(){
             console.log("渲染完成")
        },
        handleTrueModify () {
            this.modify_1.value = ''
            this.modify_1.state = false
            this.modify_2.value = ''
            this.modify_2.state = false
            this.modify_3.value = ''
            this.modify_3.state = false
            this.modify_4.value = ''
            this.modify_4.state = false
            this.modify_5.value = ''
            this.modify_5.state = false
            this.modify_6.value = ''
            this.modify_6.state = false
            this.modify_7.value = ''
            this.modify_7.state = false
            this.modify_8.value = ''
            this.modify_8.state = false
            this.modify_9.value = ''
            this.modify_9.state = false
            this.modify_10.value = ''
            this.modify_10.state = false
            this.modify_11.value = ''
            this.modify_11.state = false
            this.modify_12.value = ''
            this.modify_12.state = false
            this.modify_13.value = ''
            this.modify_13.state = false
            this.modify_14.value = ''
            this.modify_14.state = false
            this.modify_15.value = ''
            this.modify_15.state = false
            this.modify_16.value = ''
            this.modify_16.state = false
            this.modify_17.value = ''
            this.modify_17.state = false
            this.modify_18.value = ''
            this.modify_18.state = false
            this.modify_19.value = ''
            this.modify_19.state = false
            this.modifyStatus = false
        },

        handleModifyEdit (type) {
            if (type == 1) {
                this.modify_1.state = !this.modify_1.state
            } else if (type == 2) {
                this.modify_2.state = !this.modify_2.state
            } else if (type == 3) {
                this.modify_3.state = !this.modify_3.state
            } else if (type == 4) {
                this.modify_4.state = !this.modify_4.state
            } else if (type == 5) {
                this.modify_5.state = !this.modify_5.state
            } else if (type == 6) {
                this.modify_6.state = !this.modify_6.state
            } else if (type == 7) {
                this.modify_7.state = !this.modify_7.state
            } else if (type == 8) {
                this.modify_8.state = !this.modify_8.state
            } else if (type == 9) {
                this.modify_9.state = !this.modify_9.state
            } else if (type == 10) {
                this.modify_10.state = !this.modify_10.state
            } else if (type == 11) {
                this.modify_11.state = !this.modify_11.state
            } else if (type == 12) {
                this.modify_12.state = !this.modify_12.state
            } else if (type == 13) {
                this.modify_13.state = !this.modify_13.state
            } else if (type == 14) {
                this.modify_14.state = !this.modify_14.state
            } else if (type == 15) {
                this.modify_15.state = !this.modify_15.state
            } else if (type == 16) {
                this.modify_16.state = !this.modify_16.state
            } else if (type == 17) {
                this.modify_17.state = !this.modify_17.state
            } else if (type == 18) {
                this.modify_18.state = !this.modify_18.state
            } else if (type == 19) {
                this.modify_19.state = !this.modify_19.state
            }
        },

        handleReceiptEmail (type,language) {
            this.language = language
            // if (type == 1) {
                
            // } else if (type == 2) {
            //     this.language = 'en'
            // }

            this.emailstr = ''

            // console.log(this.ruleForm.proexecutor)

            this.ruleForm.proexecutor[0].name = ''
            this.ruleForm.proexecutor[0].posit = ''
            this.ruleForm.proexecutor[0].iphone = ''

            this.ruleForm.procurator[0].name = ''
            this.ruleForm.procurator[0].posit = ''

            this.ruleForm.promaker[0].name = ''
            this.ruleForm.promaker[0].posit = ''

            this.categoryType = this.fullIndex
            // alert(this.categoryType)
            
            this.ReceiptEmaildialogVisible = true
        },

        

        handelReceiptEmailInfo () {
            const parseInfo = {}
            parseInfo.emailstr = this.emailstr
            parseInfo.pwdstr = this.emailstrpassword
            // parseInfo.etype = etype
            // alert('1212')

            if (this.fullIndex == 1) {
                if (this.language == 'cn') {
                    this.title = '项目概括'
                } else {
                    this.title = 'Project Overview'
                }
                getRelateProjectList(parseInfo).then(res => {
                    if (res.code == 0) {
                        
                        this.relateid = res.map.relate.relateid

                        this.userInfo = res.map.relate
                        this.numstr = res.map.relate.numstr
                        if (res.map.relate.etype == 1) {
                            this.userName = res.map.relate.cnname
                            this.language = 'cn'
                            this.Receiptemail = res.map.relate.cnemail
                            sessionStorage.setItem('entrustEmail',res.map.relate.cnemail)
                            sessionStorage.setItem('entrustPassword',res.map.relate.cnphone)
                        } else if (res.map.relate.etype == 2) {
                            this.userName = res.map.relate.enfname + ' ' + res.map.relate.enlname
                            this.language = 'en'
                            sessionStorage.setItem('entrustEmail',res.map.relate.enaddress)
                            sessionStorage.setItem('entrustPassword',res.map.relate.ennumber)
                        }
                        

                        this.projectListData = res.map.relate.projects

                        this.emailstr = ''
                        this.emailstrpassword = ''
                        // this.relateid = res.map.relate.relateid
                        this.LogindialogVisible = false


                        // this.isFullImags = true
                        this.projectListInfodialogVisible = true

                        // this.ruleForm.projectname = res.map.relate.projectname
                        // this.ruleForm.projecttype = res.map.relate.projecttype
                        // this.ruleForm.projectplace = res.map.relate.projectplace
                        // this.ruleForm.projectstage = res.map.relate.projectstage
                        // this.ruleForm.projectnode = res.map.relate.projectnode

                        // if (res.map.relate.projectscale != null) {
                        //     this.ruleForm.projectscale = JSON.parse(res.map.relate.projectscale)
                        // }
                        // // this.ruleForm.projectsite = res.map.relate.projectsite
                        // if (res.map.relate.projectsite != null) {
                        //     this.ruleForm.projectsite = res.map.relate.projectsite.split('/')
                        // }

                        // if (res.map.relate.companyname != null) {
                        //     this.ruleForm.companynames = JSON.parse(res.map.relate.companyname)
                        // }

                        // if (res.map.relate.markrival != null) {
                        //     this.ruleForm.markrival = JSON.parse(res.map.relate.markrival)
                        // }
                        
                        
                        // this.ruleForm.projectaware = res.map.relate.projectaware
                        // this.ruleForm.markprocess = res.map.relate.markprocess
                        // this.ruleForm.reportprocess = JSON.parse(res.map.relate.reportprocess)
                        // this.ruleForm.projectsource = res.map.relate.projectsource
                        // this.ruleForm.companytype = res.map.relate.companytype
                        // this.ruleForm.projectnote = res.map.relate.projectnote
                        // this.ruleForm.projectpace = res.map.relate.projectpace
                        // this.ruleForm.zmoney = res.map.relate.zmoney

                        // if (res.map.relate.proexecutor != null) {
                        //     this.ruleForm.proexecutor = JSON.parse(res.map.relate.proexecutor)
                        // }

                        // if (res.map.relate.procurator != null) {
                        //     this.ruleForm.procurator = JSON.parse(res.map.relate.procurator)
                        // }

                        // if (res.map.relate.promaker != null) {
                        //     this.ruleForm.promaker = JSON.parse(res.map.relate.promaker)
                        // }
                        
                        
                        

                        // const timeArray = []

                        // if (res.map.relate.stime != null) {
                        //     timeArray.push(res.map.relate.stime.split("T")[0])
                        //     timeArray.push(res.map.relate.etime.split("T")[0])
                        // }
                        // this.ruleForm.bidTime = timeArray

                        // if (etype == 1) {
                        //     if (res.map.relate.files != null) {
                        //         this.projectDataFile = JSON.parse(res.map.relate.files)
                        //     }
                            
                        // } else if (etype == 2) {
                        //     if (res.map.relate.files != null) {
                        //         this.projectDataEnFile = JSON.parse(res.map.relate.files)
                        //     }
                            
                        // }

                        // this.InfomatdialogVisible = true
                        // this.ReceiptEmaildialogVisible = false
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error',
                            offset: 80,
                            duration: 2000
                        }) 
                    }
                })
            } else if (this.fullIndex == 2){
                
                if (this.language == 'cn') {
                    this.title = '项目备案'
                } else {
                    this.title = 'Project Registration'
                }

                getParterRelateProjectList(parseInfo).then(res => {
                    if (res.code == 0) {
                        // this.userName = res.map.mate.cnname
                        // alert(res.map.mate.cnphone)
                        
                        
                        this.etype = res.map.mate.etype
                        
                        if (res.map.mate.etype == 1) {
                            this.userName = res.map.mate.cnname
                            this.language = 'cn'
                            this.Receiptemail = res.map.mate.cnemail
                            this.Receippassword = res.map.mate.cnphone
                            this.metepassword = res.map.mate.cnphone
                        } else {
                            this.userName = res.map.mate.enfname + ' ' + res.map.mate.enlname
                            this.language = 'en'
                            this.Receiptemail = res.map.mate.enaddress
                            this.Receippassword = res.map.mate.ennumber
                            this.metepassword = res.map.mate.ennumber
                        }

                        this.emailstr = ''
                        this.emailstrpassword = ''
                        this.mateid = res.map.mate.mateid
                        this.LogindialogVisible = false
                        // this.isFullImags = true

                        if (res.map.mate.ntype == 2 || res.map.mate.ntype == 3 || res.map.mate.ntype == 7 || res.map.mate.ntype == 8) {

                            this.ReceiptEmaildialogVisible = false
                            this.codePromptdialogVisible = true

                        } else if (res.map.mate.ntype == 5) {
                            // 确认协议
                            // this.modifyNtype = res.map.mate.ntype
                            this.ProjectCasesFile = res.map.mate.files
                            // console.log(this.ProjectCasesFile)
                            // this.ProjectCasesFile = res.map.mate.nfileurl
                            this.ViewProjectCasesDialogModel = true

                        } else if (res.map.mate.ntype == 1 || res.map.mate.ntype == 6) {
                            // console.log('1212')
                            // alert('1212')
                            this.userInfo = res.map.mate
                            this.numstr = res.map.mate.numstr
                            if (res.map.mate.etype == 1) {
                                sessionStorage.setItem('Receiptemail',res.map.mate.cnemail)
                                sessionStorage.setItem('metepassword',res.map.mate.cnphone)
                            } else if (res.map.mate.etype == 2) {
                                sessionStorage.setItem('Receiptemail',res.map.mate.enaddress)
                                sessionStorage.setItem('metepassword',res.map.mate.ennumber)
                            }

                            this.projectListData = res.map.mate.projects


                            // this.isFullImags = true
                            this.projectListInfodialogVisible = true
                        }
                        // this.modifyNtype = res.map.mate.ntype
                        // this.ProjectCasesFile = res.map.mate.nfileurl

                        // this.ruleForm.projectname = res.map.mate.projectname
                        // this.ruleForm.projecttype = res.map.mate.projecttype
                        // this.ruleForm.projectplace = res.map.mate.projectplace
                        // this.ruleForm.projectstage = res.map.mate.projectstage
                        // this.ruleForm.projectnode = res.map.mate.projectnode

                        // if (res.map.mate.projectscale != null) {
                        //     this.ruleForm.projectscale = JSON.parse(res.map.mate.projectscale)
                        // }

                        // this.ruleForm.projecthetonOne = res.map.mate.projectheton
                        // if (res.map.mate.projectsite != null) {
                        //     this.ruleForm.projectsite = res.map.mate.projectsite.split('/')
                        // }
                        // if (res.map.mate.companyname != null) {
                        //     this.ruleForm.companynames = JSON.parse(res.map.mate.companyname)
                        // }

                        // if (res.map.mate.markrival != null) {
                        //     this.ruleForm.markrival = JSON.parse(res.map.mate.markrival)
                        // }
                        
                        
                        // this.ruleForm.projectaware = res.map.mate.projectaware
                        // this.ruleForm.markprocess = res.map.mate.markprocess
                        // this.ruleForm.reportprocess = JSON.parse(res.map.mate.reportprocess)
                        // this.ruleForm.projectsource = res.map.mate.projectsource
                        // this.ruleForm.companytype = res.map.mate.companytype
                        // this.ruleForm.projectnote = res.map.mate.projectnote
                        // this.ruleForm.projectpace = res.map.mate.projectpace
                        // this.ruleForm.zmoney = res.map.mate.zmoney

                        // if (res.map.mate.proexecutor != null) {
                        //     this.ruleForm.proexecutor = JSON.parse(res.map.mate.proexecutor)
                        // }

                        // if (res.map.mate.procurator != null) {
                        //     this.ruleForm.procurator = JSON.parse(res.map.mate.procurator)
                        // }

                        // if (res.map.mate.promaker != null) {
                        //     this.ruleForm.promaker = JSON.parse(res.map.mate.promaker)
                        // }
                        
                        // const timeArray = []

                        // if (res.map.mate.stime != null) {
                        //     timeArray.push(res.map.mate.stime.split("T")[0])
                        //     timeArray.push(res.map.mate.etime.split("T")[0])
                        // }
                        // this.ruleForm.bidTime = timeArray

                        // if (etype == 1) {
                        //     if (res.map.mate.files != null) {
                        //         this.projectDataFile = JSON.parse(res.map.mate.files)
                        //     }
                            
                        // } else if (etype == 2) {
                        //     if (res.map.mate.files != null) {
                        //         this.projectDataEnFile = JSON.parse(res.map.mate.files)
                        //     }
                            
                        // }

                        // this.InfomatdialogVisible = true
                        this.ReceiptEmaildialogVisible = false
                    } else {

                        // this.ReceiptEmaildialogVisible = false
                        // this.codePromptdialogVisible = true
                        this.$message({
                            message: res.message,
                            type: 'error',
                            offset: 80,
                            duration: 2000
                        }) 
                    }
                })
            }
            
        },

        // 项目委托专线数据
        getRelateProjectListFun () {
            const parseInfo = {}
            // parseInfo.emailstr = this.Receiptemail
            // parseInfo.etype = this.etype
            parseInfo.emailstr = sessionStorage.getItem('entrustEmail')
            parseInfo.pwdstr = sessionStorage.getItem('entrustPassword')

            getRelateProjectList(parseInfo).then(res => {
                if (res.code == 0) {
                    // alert('1212')
                    this.projectListData = res.map.relate.projects
                }
            })
        },
        

        // 项目合伙人专线数据
        getParterRelateProjectListFun() {
            const parseInfo = {}
            // parseInfo.emailstr = this.Receiptemail
            // parseInfo.etype = this.etype
            parseInfo.emailstr = sessionStorage.getItem('Receiptemail')
            parseInfo.pwdstr = sessionStorage.getItem('metepassword')

            getParterRelateProjectList(parseInfo).then(res => {
                if (res.code == 0) {
                    
                    this.projectListData = res.map.mate.projects
                }
            })
        },

        handelCodePromptInfo () {
            this.codePromptdialogVisible = false
        },

        handelSureSaveInfo () {
            this.Receiptemail = ''
            this.SaveInfodialogVisible = false
            this.InfomatdialogVisible = false
        },
        

        handelReceiptEmailClose () {
            this.ReceiptEmaildialogVisible = false
        },

        handleDisagreeClose (language) {
            this.language = language
            this.AcceptdialogVisible = true
        },

        handleModifyAgreement () {
            const ModifyContent = {}
            if (this.modify_1.value != '') {
                ModifyContent.modify_1 = this.modify_1.value
            }
            if (this.modify_2.value != '') {
                ModifyContent.modify_2 = this.modify_2.value
            }
            if (this.modify_3.value != '') {
                ModifyContent.modify_3 = this.modify_3.value
            }
            if (this.modify_4.value != '') {
                ModifyContent.modify_4 = this.modify_4.value
            }
            if (this.modify_5.value != '') {
                ModifyContent.modify_5 = this.modify_5.value
            }
            if (this.modify_6.value != '') {
                ModifyContent.modify_6 = this.modify_6.value
            } 
            if (this.modify_7.value != '') {
                ModifyContent.modify_7 = this.modify_7.value
            }
            if (this.modify_8.value != '') {
                ModifyContent.modify_8 = this.modify_8.value
            }
            if (this.modify_9.value != '') {
                ModifyContent.modify_9 = this.modify_9.value
            }
            if (this.modify_10.value != '') {
                ModifyContent.modify_10 = this.modify_10.value
            }
            if (this.modify_11.value != '') {
                ModifyContent.modify_11 = this.modify_11.value
            }
            if (this.modify_12.value != '') {
                ModifyContent.modify_12 = this.modify_12.value
            }
            if (this.modify_13.value != '') {
                ModifyContent.modify_13 = this.modify_13.value
            }
            if (this.modify_14.value != '') {
                ModifyContent.modify_14 = this.modify_14.value
            }
            if (this.modify_15.value != '') {
                ModifyContent.modify_15 = this.modify_15.value
            }
            if (this.modify_16.value != '') {
                ModifyContent.modify_16 = this.modify_16.value
            }
            if (this.modify_17.value != '') {
                ModifyContent.modify_17 = this.modify_17.value
            }
            if (this.modify_18.value != '') {
                ModifyContent.modify_18 = this.modify_18.value
            }
            if (this.modify_19.value != '') {
                ModifyContent.modify_19 = this.modify_19.value
            }

            // alert(this.modify_1.value)

            if (this.modify_1.value == '' && this.modify_2.value == '' && this.modify_3.value == '' && this.modify_4.value == '' && this.modify_5.value == '' && this.modify_6.value == '' && this.modify_7.value == '' && this.modify_8.value == '' && this.modify_9.value == '' && this.modify_10.value == '' && this.modify_11.value == '' && this.modify_12.value == '' && this.modify_13.value == '' && this.modify_14.value == '' && this.modify_15.value == '' && this.modify_16.value == '' && this.modify_17.value == '' && this.modify_18.value == '' && this.modify_19.value == '') {
                if (this.language == 'cn') {
                    this.$message.error('最少填写内容')
                } else if (this.language == 'en') {
                    this.$message.error('Minimum filling content!')
                }
                
                return false
            }

            

            this.setProjectPartnerInfoFun(ModifyContent,2)

            // console.log(ModifyContent)
            // if (this.language == 'cn') {
            //     if (this.disReason == '') {
            //         this.$message.error('请输入理由')
            //         return false
            //     }
            // } else if (this.language == 'en') {
            //     if (this.disReason == '') {
            //         this.$message.error('Please Enter The Reason')
            //         return false
            //     }
            // }

            // const parseInfo = {}
            // parseInfo.mateid = this.mateid
            // parseInfo.ntype = 2
            // parseInfo.ntext = this.disReason
            // setProjectPartnerDisagreeInfo(parseInfo).then(res => {
            //     if (res.code == 0) {
            //         this.disReason = ''
            //         // this.isCooperat = false
            //         this.tispdialogVisible = true
            //         this.AcceptdialogVisible = false
            //     } else {
            //         this.$message({
            //             message: res.message,
            //             type: 'error',
            //             offset: 80,
            //             duration: 2000
            //         }) 
            //     }
            // })
        },

        // handleInput (event) {
        //     alert(event.target.value)
        //     const value = event.target.value
        //     this.ruleForm.projectscale.projectscaleFee = value.replace(/[^0-9]/g, '')
        // },

        // 成果交付阶段
        handelDeliveryPhase (value) {
            if (value == 1) {
                this.isNodePhase = false
                this.ruleForm.projectnode = ''
            } else {
                this.isNodePhase = true
            }
        },

        handleProjectOverview (type,language,state,nextState) {
            this.isExitFullscreen = 1
            this.language = language
            this.categoryType = type
            this.operatStatus = 0

            if (type == 1) {
                if (language == 'cn') {
                    this.title = '项目概括'
                    this.relateid = this.cnrelateid
                } else {
                    this.title = 'Project Overview'
                    this.relateid = this.enrelateid
                }

                this.InfomatdialogVisible = true
                
            } else if (type == 2) {
                if (state == 1) {
                    // 同意协议
                    if (nextState == 3) {
                        this.InfomatdialogVisible = true
                    } else {
                        this.modifyStatus = false
                        this.isCooperat = false
                        const ntext = {}
                        this.setProjectPartnerInfoFun(ntext,1)
                    }
                    
                    
                } else if (state == 2) {
                    // 不同意协议
                    this.disagreeInfodialogVisible = true
                    
                }

                // this.etypeLanguage = etype
                // const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
                



                if (language == 'cn') {
                    this.title = '项目备案'
                    this.mateid = this.cnmateid
                } else {
                    this.title = 'Project Registration'
                    this.mateid = this.enmateid
                }



            }
            this.ruleForm.projectname = ''
            this.ruleForm.projecttype = ''
            this.ruleForm.projectplace = ''
            this.ruleForm.projectstage = ''
            this.ruleForm.projectnode = ''
            this.ruleForm.projectscale.projectscaleFee = ''
            this.ruleForm.projectscale.projectscaleInfo = ''
            this.ruleForm.projectsite = ''
            this.ruleForm.projecthetonOne = ''
            this.ruleForm.companynames.companynameInfo = ''
            this.ruleForm.companynames.companynameProjectInfo = ''
            this.ruleForm.markrival.markrivalName = ''
            this.ruleForm.markrival.markrivalInfo = ''
            this.ruleForm.projectaware = ''
            this.ruleForm.markprocess = ''
            this.ruleForm.reportprocess = ''
            this.ruleForm.projectsource = ''
            this.ruleForm.companytype = ''
            this.ruleForm.projectnote = ''
            this.ruleForm.projectpace = ''
            this.ruleForm.zmoney = ''
            this.ruleForm.bidTime = []

            this.ruleForm.proexecutor[0].name = ''
            this.ruleForm.proexecutor[0].posit = ''
            this.ruleForm.proexecutor[0].iphone = ''

            this.ruleForm.procurator[0].name = ''
            this.ruleForm.procurator[0].posit = ''

            this.ruleForm.promaker[0].name = ''
            this.ruleForm.promaker[0].posit = ''

            // this.ruleForm.proexecutor.name = ''
            // this.ruleForm.proexecutor.posit = ''
            // this.ruleForm.proexecutor.iphone = ''

            // this.ruleForm.procurator.name = ''
            // this.ruleForm.procurator.posit = ''

            // this.ruleForm.promaker.name = ''
            // this.ruleForm.promaker.posit = ''
            // console.log(this.projectDataFile)

            for (let i = 0; i < this.projectDataFile.length; i++) {
                this.projectDataFile[i].fileurl = ''
            }

            for (let i = 0; i < this.projectDataEnFile.length; i++) {
                this.projectDataEnFile[i].fileurl = ''
            }

            this.InfoboxdialogVisible = false
            
        },

        handleEditAgreementInfo () {
            this.modifyStatus = true
            this.disagreeInfodialogVisible = false
        },

        handleDisagreeInfoClose () {
            this.disagreeInfodialogVisible = false
        },

        handelmodifyOpinionInfo () {
            this.disagreeInfodialogVisible = false
            this.modifyStatus = false
            this.isCooperat = false
            this.modifyOpiniondialogVisible = false
            this.modifyOpinionTwodialogVisible = false
        },

        setProjectPartnerInfoFun(ntext,status) {
            const parseInfo = {}
            parseInfo.etype = this.etypeLanguage
            parseInfo.ntype = status
            if (this.etypeLanguage == 2) {
                parseInfo.enfname = this.enfname
                parseInfo.enlname = this.enlname
                parseInfo.enaddress = this.enaddress
                parseInfo.ennumber = this.ennumber
                parseInfo.enlocation = this.enlocation
                parseInfo.ensubject = this.ensubject
                parseInfo.enenquiry = this.enenquiry

            } else if (this.etypeLanguage == 1) {
                
                parseInfo.cnname = this.cnname
                parseInfo.cnaddress = this.cnaddress
                parseInfo.cnemail = this.cnemail
                parseInfo.ennumber = this.ennumber
                parseInfo.cnphone = this.cnphone
                parseInfo.cnsubject = this.cnsubject
                parseInfo.cnenquiry = this.cnenquiry
            }

            parseInfo.ntext = JSON.stringify(ntext)


            // console.log(parseInfo)
            // return false

            setProjectPartnerInfo(parseInfo).then(res => {
                if (res.code == 0) {

                    this.cnmateid = res.map.cnmateid // 中文id
                    this.enmateid = res.map.enmateid // 英文id

                    // this.Receiptemail = this.enaddress
                    if (res.map.cnmateid != '') {
                        this.Receiptemail = this.cnemail
                        this.Receippassword = this.cnphone

                    } else if (res.map.enmateid != '') {
                        this.Receiptemail = this.enaddress
                        this.Receippassword = this.ennumber
                    }

                    if (status == 1) {
                        this.InfoboxdialogVisible = true
                    } else {
                        this.modifyOpiniondialogVisible = true
                    }
                    
                    
                    this.enfname = ''
                    this.enlname = ''
                    this.enaddress = ''
                    this.ennumber = ''
                    this.enlocation = ''
                    this.ensubject = ''
                    this.enenquiry = ''
                    this.cnname = '' //姓名
                    this.cnaddress = '' //所在地
                    this.cnemail = '' //邮箱
                    this.cnphone = '' //电话
                    this.cnsubject = '' //主题
                    this.cnenquiry = '' //内容
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        handleClose () {
            this.isExitFullscreen = 0
            // if (!document.fullscreenElement) {
            //     document.documentElement.requestFullscreen().catch(err => {
            //     alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
            //     });
            // }
            // else {
            //     if (document.exitFullscreen) {
            //         document.exitFullscreen();
            //     }
            // }
            this.AcceptdialogVisible = false
            this.InfomatdialogVisible = false
        },

    //     handleBlur() {
    //   // 处理文件输入框失去焦点事件，例如用户点击了取消按钮
    //   console.log('File input lost focus, possibly due to cancel.');
    // },

        // handleStudio () {
        //    if (!document.fullscreenElement) {
        //         document.documentElement.requestFullscreen().catch(err => {
        //         alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
        //         });
        //     } else {
        //         if (document.exitFullscreen) {
        //         document.exitFullscreen();
        //         }
        //     }
        // },

        // handleFileInput (event) {
        //     if (!event.target.value) {
        //         // 文件未被选择或被取消选择
        //         console.log('文件未被选择或被取消选择');
        //         // 你可以在这里执行其他操作，比如清空文件列表等
        //     } else {
        //        console.log(event.target) 
        //     }
        // },

        handleStudioUploadFile (event,numberType) {


            const formDataObj  = new FormData()
            // alert(event.target.files[0])
            // console.log(event.target.files)
           
            formDataObj.append('file', event.target.files[0])
            SetEditorUploadImage(formDataObj).then(res => {
                if (res.code == 0) {
                    if (this.language == 'cn') {
                        this.projectDataFile[numberType].fileurl = res.map.fileurl
                    } else {
                        this.projectDataEnFile[numberType].fileurl = res.map.fileurl
                    }
                    
                    this.$refs['clearFile_'+numberType].value = ''

                    // if (!document.fullscreenElement) {
                    //     document.documentElement.requestFullscreen().catch(err => {
                    //     alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                    //     });
                    // } else {
                    //     if (document.exitFullscreen) {
                    //     document.exitFullscreen();
                    //     }
                    // }
                    // this.$refs.image.click()
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error',
                        offset: 80,
                        duration: 2000
                    })
                }
            })
        },

        handelSureTips () {
            // if (!document.fullscreenElement) {
            //     document.documentElement.requestFullscreen().catch(err => {
            //     alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
            //     });
            // }
            this.tispdialogVisible = false
            this.isCooperat = false
            this.InfomatdialogVisible = false
        },

        // 添加提交用户信息功能
        submitFormSave (atype) {
            if (atype == 1) {
                if (this.ruleForm.proexecutor[0].iphone != '') {
                    if (this.ruleForm.proexecutor[0].iphone.length < 8) {
                        if (this.language == 'cn') {
                            this.$message.error('手机号码不正确')
                            return false
                        } else {
                            this.$message.error('IPhone number format is incorrect. Please check your input.')
                            return false
                        }
                    }
                }
                

                const parseInfo = {}
                // parseInfo.userid = this.userid
                // parseInfo.token = this.token
                // parseInfo.projectid = this.projectid
                parseInfo.projectname = this.ruleForm.projectname
                
                parseInfo.projectplace = this.ruleForm.projectplace
                parseInfo.projecttype = this.ruleForm.projecttype
                parseInfo.projectstage = this.ruleForm.projectstage // 交付成果阶段

                // 节点阶段
                // let phaseNewArray = []
                // if (this.ruleForm.projectstage == 1) {
                //     phaseNewArray = this.deliveryPhaseList
                // } else {
                //     if (this.ruleForm.projectnode == '建筑优化阶段') {
                //         phaseNewArray.push(this.deliveryPhaseList[0])
                //     } else if (this.ruleForm.projectnode == '概念阶段') {
                //         phaseNewArray.push(this.deliveryPhaseList[1])
                //     } else if (this.ruleForm.projectnode == '方案阶段') {
                //         phaseNewArray.push(this.deliveryPhaseList[2])
                //     } else if (this.ruleForm.projectnode == '扩初阶段') {
                //         phaseNewArray.push(this.deliveryPhaseList[3])
                //     } else if (this.ruleForm.projectnode == '招标图阶段') {
                //         phaseNewArray.push(this.deliveryPhaseList[4])
                //     } else if (this.ruleForm.projectnode == '施工图阶段') {
                //         phaseNewArray.push(this.deliveryPhaseList[5])
                //     }
                // }

                parseInfo.projectnode = this.ruleForm.projectnode
                


                parseInfo.projectscale = JSON.stringify(this.ruleForm.projectscale)

                if (this.language == 'cn') {
                    if (this.ruleForm.projectsite != '') {
                        parseInfo.projectsite = this.ruleForm.projectsite.join(',').replace(/,/g,"/")
                    }
                    
                } else{
                    parseInfo.projectsite = this.ruleForm.projectsite
                }
                

                parseInfo.companyname = JSON.stringify(this.ruleForm.companynames)
                parseInfo.projectaware = this.ruleForm.projectaware
                parseInfo.markprocess = this.ruleForm.markprocess
                parseInfo.markrival = JSON.stringify(this.ruleForm.markrival)
                parseInfo.reportprocess = JSON.stringify(this.ruleForm.reportprocess)
                parseInfo.projectsource = this.ruleForm.projectsource
                parseInfo.proexecutor = JSON.stringify(this.ruleForm.proexecutor)
                parseInfo.procurator = JSON.stringify(this.ruleForm.procurator)
                parseInfo.promaker = JSON.stringify(this.ruleForm.promaker)
                // parseInfo.projectheton = JSON.stringify(this.ruleForm.projectheton)
                parseInfo.projectheton = this.ruleForm.projecthetonOne
                parseInfo.projectnote = this.ruleForm.projectnote
                parseInfo.nodestr = ''
                parseInfo.projectpace = this.ruleForm.projectpace
                parseInfo.companytype = this.ruleForm.companytype
                // parseInfo.projectplan = this.ruleForm.projectplan

                if (this.ruleForm.projectnote == '方案标' || this.ruleForm.projectnote == 'Schematic Design Bid') {
                    parseInfo.zmoney = this.ruleForm.zmoney
                } else {
                    parseInfo.zmoney = ''
                }

                parseInfo.stime = this.ruleForm.bidTime[0]
                parseInfo.etime = this.ruleForm.bidTime[1]

                if (this.language == 'cn') {
                    parseInfo.files = JSON.stringify(this.projectDataFile)
                } else {
                    parseInfo.files = JSON.stringify(this.projectDataEnFile)
                }
                

                if (this.language == 'cn') {
                    parseInfo.etype = 1
                } else {
                    parseInfo.etype = 2
                }

                
                if (this.categoryType == 1) {
                    parseInfo.relateid = this.relateid
                } else if (this.categoryType == 2) {
                    parseInfo.mateid = this.mateid
                }

                parseInfo.atype = atype
                

                // console.log(parseInfo)
                // return false

                // alert(this.categoryType)

                if (this.categoryType == 1) {
                    
                    if (this.operatStatus == 0) {
                        setAddDataInfo(parseInfo).then(res => {
                            if (res.code == 0) {

                                if (atype == 1) {
                                    this.SaveInfodialogVisible = true
                                } else if (atype == 2) {
                                    this.tispdialogVisible = true
                                }

                                this.getRelateProjectListFun()
                                
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'error',
                                    offset: 80,
                                    duration: 2000
                                });
                            }
                        })
                    } else if (this.operatStatus == 1) {
                        // alert(this.projectid)
                        parseInfo.projectid = this.projectid
                        setEntrustEditDataInfo(parseInfo).then(res => {
                            if (res.code == 0) {
                                if (atype == 1) {
                                    this.SaveInfodialogVisible = true
                                } else if (atype == 2) {
                                    this.tispdialogVisible = true
                                }
                                // this.projectListData = []
                                this.Receiptemail = sessionStorage.getItem('entrustEmail')
                                this.Receippassword = sessionStorage.getItem('entrustPassword')
                                this.getRelateProjectListFun()
                            } else {
                                 this.$message({
                                    message: res.message,
                                    type: 'error',
                                    offset: 80,
                                    duration: 2000
                                });
                            }
                        })
                    }
                    

                } else if (this.categoryType == 2) {
                    // alert(this.operatStatus)
                    if (this.operatStatus == 0) {
                        // alert('33333')
                        setPartnerAddDataInfo(parseInfo).then(res => {
                            if (res.code == 0) {
                                if (atype == 1) {
                                    this.SaveInfodialogVisible = true
                                } else if (atype == 2) {
                                    this.tispdialogVisible = true
                                }

                                this.getParterRelateProjectListFun()

                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'error',
                                    offset: 80,
                                    duration: 2000
                                });
                            }
                        })
                    } else if (this.operatStatus == 1) {
                        // alert('22')
                        parseInfo.projectid = this.projectid
                        setEditUpdatePartnerAddDataInfo(parseInfo).then(res => {
                             if (res.code == 0) {
                                if (atype == 1) {
                                    this.SaveInfodialogVisible = true
                                } else if (atype == 2) {
                                    this.tispdialogVisible = true
                                }

                                this.Receiptemail = sessionStorage.getItem('Receiptemail')
                                this.Receippassword = sessionStorage.getItem('metepassword')

                                this.getParterRelateProjectListFun()

                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'error',
                                    offset: 80,
                                    duration: 2000
                                });
                            }
                        })
                    }
                    
                }

            } else if (atype == 2) {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {

                        if (this.ruleForm.proexecutor[0].iphone.length < 8) {
                            if (this.language == 'cn') {
                                this.$message.error('手机号码不正确')
                                return false
                            } else {
                                this.$message.error('IPhone number format is incorrect. Please check your input.')
                                return false
                            }
                        }

                        if (this.language == 'cn') {
                            for (let i = 0; i < this.projectDataFile.length; i++) {
                                if (this.projectDataFile[i].fileurl == '' && this.projectDataFile[i].filename != '其它') {
                                    this.$message.error('请上传'+ this.projectDataFile[i].filename)
                                    return false
                                }
                            }
                        } else if (this.language == 'en') {
                            for (let i = 0; i < this.projectDataEnFile.length; i++) {
                                if (this.projectDataEnFile[i].fileurl == '' && this.projectDataEnFile[i].filename != 'Other') {
                                    this.$message.error('Please Upload ' + this.projectDataEnFile[i].filename)
                                    return false
                                }
                            }
                        }
                        
                        const parseInfo = {}
                        // parseInfo.userid = this.userid
                        // parseInfo.token = this.token
                        // parseInfo.projectid = this.projectid
                        parseInfo.projectname = this.ruleForm.projectname
                        
                        parseInfo.projectplace = this.ruleForm.projectplace
                        parseInfo.projecttype = this.ruleForm.projecttype
                        parseInfo.projectstage = this.ruleForm.projectstage // 交付成果阶段

                        // 节点阶段
                        // let phaseNewArray = []
                        // if (this.ruleForm.projectstage == 1) {
                        //     phaseNewArray = this.deliveryPhaseList
                        // } else {
                        //     if (this.ruleForm.projectnode == '建筑优化阶段') {
                        //         phaseNewArray.push(this.deliveryPhaseList[0])
                        //     } else if (this.ruleForm.projectnode == '概念阶段') {
                        //         phaseNewArray.push(this.deliveryPhaseList[1])
                        //     } else if (this.ruleForm.projectnode == '方案阶段') {
                        //         phaseNewArray.push(this.deliveryPhaseList[2])
                        //     } else if (this.ruleForm.projectnode == '扩初阶段') {
                        //         phaseNewArray.push(this.deliveryPhaseList[3])
                        //     } else if (this.ruleForm.projectnode == '招标图阶段') {
                        //         phaseNewArray.push(this.deliveryPhaseList[4])
                        //     } else if (this.ruleForm.projectnode == '施工图阶段') {
                        //         phaseNewArray.push(this.deliveryPhaseList[5])
                        //     }
                        // }

                        parseInfo.projectnode = this.ruleForm.projectnode
                        


                        parseInfo.projectscale = JSON.stringify(this.ruleForm.projectscale)

                        if (this.language == 'cn') {
                            parseInfo.projectsite = this.ruleForm.projectsite.join(',').replace(/,/g,"/")
                        } else{
                            parseInfo.projectsite = this.ruleForm.projectsite
                        }
                        

                        parseInfo.companyname = JSON.stringify(this.ruleForm.companynames)
                        parseInfo.projectaware = this.ruleForm.projectaware
                        parseInfo.markprocess = this.ruleForm.markprocess
                        parseInfo.markrival = JSON.stringify(this.ruleForm.markrival)
                        parseInfo.reportprocess = JSON.stringify(this.ruleForm.reportprocess)
                        parseInfo.projectsource = this.ruleForm.projectsource
                        parseInfo.proexecutor = JSON.stringify(this.ruleForm.proexecutor)
                        parseInfo.procurator = JSON.stringify(this.ruleForm.procurator)
                        parseInfo.promaker = JSON.stringify(this.ruleForm.promaker)
                        // parseInfo.projectheton = JSON.stringify(this.ruleForm.projectheton)
                        parseInfo.projectheton = this.ruleForm.projecthetonOne
                        parseInfo.projectnote = this.ruleForm.projectnote
                        parseInfo.nodestr = ''
                        parseInfo.projectpace = this.ruleForm.projectpace
                        parseInfo.companytype = this.ruleForm.companytype
                        // parseInfo.projectplan = this.ruleForm.projectplan

                        if (this.ruleForm.projectnote == '方案标' || this.ruleForm.projectnote == 'Schematic Design Bid') {
                            parseInfo.zmoney = this.ruleForm.zmoney
                        } else {
                            parseInfo.zmoney = ''
                        }

                        parseInfo.stime = this.ruleForm.bidTime[0]
                        parseInfo.etime = this.ruleForm.bidTime[1]

                        if (this.language == 'cn') {
                            parseInfo.files = JSON.stringify(this.projectDataFile)
                        } else {
                            parseInfo.files = JSON.stringify(this.projectDataEnFile)
                        }
                        

                        if (this.language == 'cn') {
                            parseInfo.etype = 1
                        } else {
                            parseInfo.etype = 2
                        }

                        if (this.categoryType == 1) {
                            parseInfo.relateid = this.relateid
                        } else if (this.categoryType == 2) {
                            parseInfo.mateid = this.mateid
                        }

                        parseInfo.atype = atype
                        

                        // console.log(parseInfo)
                        // return false

                        if (this.categoryType == 1) {

                            if (this.operatStatus == 0) {
                                 setAddDataInfo(parseInfo).then(res => {
                                    if (res.code == 0) {

                                        if (atype == 1) {
                                            this.SaveInfodialogVisible = true
                                        } else if (atype == 2) {
                                            this.tispdialogVisible = true
                                        }
                                        
                                        
                                    } else {
                                        this.$message({
                                            message: res.message,
                                            type: 'error',
                                            offset: 80,
                                            duration: 2000
                                        });
                                    }
                                })
                            } else if (this.operatStatus == 1) {
                                parseInfo.projectid = this.projectid
                                setEntrustEditDataInfo(parseInfo).then(res => {
                                    if (res.code == 0) {
                                        if (atype == 1) {
                                            this.SaveInfodialogVisible = true
                                        } else if (atype == 2) {
                                            this.tispdialogVisible = true
                                        }
                                        // this.projectListData = []
                                        this.getRelateProjectListFun()
                                    } else {
                                        this.$message({
                                            message: res.message,
                                            type: 'error',
                                            offset: 80,
                                            duration: 2000
                                        });
                                    }
                                })
                            }
                           

                        } else if (this.categoryType == 2) {

                            // if (this.modifyNtype == 5) {
                            //     if (!this.ischecked) {
                            //         if (this.language == 'cn') {
                            //             this.$message.error('请勾选确认合作框架修订版')
                            //         } else if (this.language == 'en') {
                            //             this.$message.error('Check the confirmation box for Revised Version of Cooperation Framework')
                            //         }
                                    
                            //         return false
                            //     }
                            // }
                            // alert(this.operatStatus)
                            // return false

                            if (this.operatStatus == 0) {
                                // alert('111')
                                setPartnerAddDataInfo(parseInfo).then(res => {
                                    if (res.code == 0) {
                                        this.tispdialogVisible = true
                                        this.getParterRelateProjectListFun()
                                    } else {
                                        this.$message({
                                            message: res.message,
                                            type: 'error',
                                            offset: 80,
                                            duration: 2000
                                        });
                                    }
                                })
                            } else if (this.operatStatus == 1) {
                                // alert('222')
                                parseInfo.projectid = this.projectid
                                setEditUpdatePartnerAddDataInfo(parseInfo).then(res => {
                                    if (res.code == 0) {
                                        if (atype == 1) {
                                            this.SaveInfodialogVisible = true
                                        } else if (atype == 2) {
                                            this.tispdialogVisible = true
                                        }

                                        this.getParterRelateProjectListFun()

                                    } else {
                                        this.$message({
                                            message: res.message,
                                            type: 'error',
                                            offset: 80,
                                            duration: 2000
                                        });
                                    }
                                })
                            }
                            
                        }
                        
                    } else {
                        if (this.language == 'cn') {
                            this.$message({
                                message: '信息未完善，请完善资料在提交',
                                type: 'error',
                                offset: 300,
                                duration: 2000
                            });
                        } else {
                            this.$message({
                                message: 'Please complete all required fields before submitting.',
                                type: 'error',
                                offset: 300,
                                duration: 2000
                            });
                        }
                        
                    }
                })
            }
            
        },



        handleFramework (type) {
        //    alert(this.enmateid)
            if (type == 0) {
                this.mateid = this.cnmateid
            } else if (type == 1) {
                this.mateid = this.enmateid
            }
            this.CoopIndex = type
            this.isCooperat = true
            this.InfoboxdialogVisible = false
            // this.$refs.Coopimage.click()
        },
       
        handleSumbitInfo (etype) {
            // alert(this.CoopIndex)
            const parseInfo = {}
            parseInfo.etype = etype
            this.etypeLanguage = etype
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
            if (etype == 2) {
                this.CoopIndex = 0
                if (this.enfname == '' || this.ennumber == '' || this.enlname == '' || this.enaddress == '' || this.ensubject == '' || this.enenquiry == '') {
                    this.$message.error('Information is incomplete. Please complete all required fields and submit again.')
                    return false
                }

                if (this.enaddress != '' && !emailPattern.test(this.enaddress)) {
                    this.$message.error('Invalid email address. Please check and try again.')
                    return false
                }
                
                parseInfo.enfname = this.enfname
                parseInfo.enlname = this.enlname
                parseInfo.enaddress = this.enaddress
                parseInfo.ennumber = this.ennumber
                parseInfo.enlocation = this.enlocation
                parseInfo.ensubject = this.ensubject
                parseInfo.enenquiry = this.enenquiry

              

            } else if (etype == 1) {
                this.CoopIndex = 1
                if (this.cnname == '' || this.cnphone == '' || this.cnemail == '' || this.cnsubject == '' || this.cnenquiry == '') {
                   this.$message.error('信息未完善，请完善信息在提交')
                   return false
                }

                if (this.cnemail != '' && !emailPattern.test(this.cnemail)) {
                    this.$message.error('邮箱不正确，请检查')
                    return false
                }
                parseInfo.cnname = this.cnname
                parseInfo.cnaddress = this.cnaddress
                parseInfo.cnemail = this.cnemail
                parseInfo.ennumber = this.ennumber
                parseInfo.cnphone = this.cnphone
                parseInfo.cnsubject = this.cnsubject
                parseInfo.cnenquiry = this.cnenquiry
            }

            if (this.fullIndex == 1) {
                // 项目委托
                setUserInfomation(parseInfo).then(res => {
                    if (res.code == 0) {

                        this.cnrelateid = res.map.cnrelateid // 中文id
                        this.enrelateid = res.map.enrelateid // 英文id

                        if (res.map.cnrelateid != '') {
                            this.Receiptemail = this.cnemail
                            this.Receippassword = this.cnphone
                            
                        } else if (res.map.enrelateid != '') {
                            this.Receiptemail = this.enaddress
                            this.Receippassword = this.ennumber
                        }
                        

                        


                        this.InfoboxdialogVisible = true
                        // if (etype == 1) {
                        //     this.$confirm('信息提交成功', '', {
                        //         showCancelButton: false,
                        //         center: true
                        //     })
                        // } else {
                        //     this.$confirm('Information submitted successfully. Thank you!', '', {
                        //         showCancelButton: false,
                        //         center: true
                        //     })
                        // }
                       
                        this.enfname = ''
                        this.enlname = ''
                        this.enaddress = ''
                        this.ennumber = ''
                        this.enlocation = ''
                        this.ensubject = ''
                        this.enenquiry = ''
                        this.cnname = '' //姓名
                        this.cnaddress = '' //所在地
                        this.cnemail = '' //邮箱
                        this.cnphone = '' //电话
                        this.cnsubject = '' //主题
                        this.cnenquiry = '' //内容
                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else if (this.fullIndex == 2) {
                // 合伙人专线
                this.isCooperat = true
                // setProjectPartnerInfo(parseInfo).then(res => {
                //     if (res.code == 0) {

                //         this.cnmateid = res.map.cnmateid // 中文id
                //         this.enmateid = res.map.enmateid // 英文id

                //         this.Receiptemail = this.enaddress

                //         this.InfoboxdialogVisible = true
                        
                //         this.enfname = ''
                //         this.enlname = ''
                //         this.enaddress = ''
                //         this.ennumber = ''
                //         this.enlocation = ''
                //         this.ensubject = ''
                //         this.enenquiry = ''
                //         this.cnname = '' //姓名
                //         this.cnaddress = '' //所在地
                //         this.cnemail = '' //邮箱
                //         this.cnphone = '' //电话
                //         this.cnsubject = '' //主题
                //         this.cnenquiry = '' //内容
                //     } else {
                //         this.$message.error(res.message)
                //     }
                // })
            }
            
            
        },

        handelSureInfobox () {
            this.InfoboxdialogVisible = false
        },

        handleCahge (val) {
            this.modify_1.value = ''
            this.modify_1.state = false
            this.modify_2.value = ''
            this.modify_2.state = false
            this.modify_3.value = ''
            this.modify_3.state = false
            this.modify_4.value = ''
            this.modify_4.state = false
            this.modify_5.value = ''
            this.modify_5.state = false
            this.modify_6.value = ''
            this.modify_6.state = false
            this.modify_7.value = ''
            this.modify_7.state = false
            this.modify_8.value = ''
            this.modify_8.state = false
            this.modify_9.value = ''
            this.modify_9.state = false
            this.modify_10.value = ''
            this.modify_10.state = false
            this.modify_11.value = ''
            this.modify_11.state = false
            this.modify_12.value = ''
            this.modify_12.state = false
            this.modify_13.value = ''
            this.modify_13.state = false
            this.modify_14.value = ''
            this.modify_14.state = false
            this.modify_15.value = ''
            this.modify_15.state = false
            this.modify_16.value = ''
            this.modify_16.state = false
            this.modify_17.value = ''
            this.modify_17.state = false
            this.modify_18.value = ''
            this.modify_18.state = false
            this.modify_19.value = ''
            this.modify_19.state = false


            this.infoIndex = val
        },

        handleFullImages (index) {
            this.fullIndex = index
            this.categoryType = index
            // this.isFullImags = true

            if (index == 0) {
                this.isFullImags = true
            } else {
                if (index == 1) {
                    if (sessionStorage.getItem('entrustEmail') != null || sessionStorage.getItem('entrustPassword') != null) {
                        const parseInfo = {}
                        parseInfo.emailstr = sessionStorage.getItem('entrustEmail')
                        parseInfo.pwdstr = sessionStorage.getItem('entrustPassword')
                        getRelateProjectList(parseInfo).then(res => {
                            if (res.code == 0) {
                                this.Receiptemail = this.emailstr
                                this.relateid = res.map.relate.relateid

                                this.userInfo = res.map.relate
                                this.numstr = res.map.relate.numstr
                                this.etype = res.map.relate.etype
                            
                                this.projectListData = res.map.relate.projects
                                this.numstr = res.map.relate.numstr

                                if (res.map.relate.etype == 1) {
                                    this.language = 'cn'
                                    this.userName = res.map.relate.cnname

                                } else if (res.map.relate.etype == 2) {
                                    this.language = 'en'
                                    this.userName = res.map.relate.enfname + ' ' + res.map.relate.enlname
                                }

                                this.projectListInfodialogVisible = true

                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'error',
                                    offset: 80,
                                    duration: 2000
                                }) 
                            }
                        })

                    } else {
                        this.LogindialogVisible = true
                    }
                    
                } else {
                    if (sessionStorage.getItem('Receiptemail') != null || sessionStorage.getItem('metepassword') != null) {
                        const parseInfo = {}
                        parseInfo.emailstr = sessionStorage.getItem('Receiptemail')
                        parseInfo.pwdstr = sessionStorage.getItem('metepassword')
                        // parseInfo.emailstr = this.emailstr
                        // parseInfo.etype = this.etype
                        getParterRelateProjectList(parseInfo).then(res => {
                            if (res.code == 0) {
                                this.userInfo = res.map.mate
                                
                                this.Receiptemail = res.map.mate.cnemail
                                this.etype = res.map.mate.etype
                                this.mateid = res.map.mate.mateid
                                this.projectListData = res.map.mate.projects
                                this.numstr = res.map.mate.numstr

                                if (res.map.mate.etype == 1) {
                                    this.language = 'cn'
                                    this.userName = res.map.mate.cnname

                                } else if (res.map.mate.etype == 2) {
                                    this.language = 'en'
                                    this.userName = res.map.mate.enfname + ' ' + res.map.mate.enlname
                                }
                                // this.isFullImags = true
                                // this.LogindialogVisible = false
                                this.projectListInfodialogVisible = true
                            }
                        })
                        // alert(localStorage.getItem('Receiptemail'))
                    } else {
                        this.LogindialogVisible = true
                    }
                }
                
            }
            
            // alert(localStorage.getItem('Receiptemail'))
            
            // console.log(this.dpi)
            // this.$refs.image.click()
            // this.toggleFullScreen()
        },

        // 退出登录
        handleLogOut () {

            if (this.fullIndex == 1) {
                sessionStorage.removeItem('entrustEmail')
                sessionStorage.removeItem('entrustPassword')

            } else if (this.fullIndex == 2) {
                sessionStorage.removeItem('Receiptemail')
                sessionStorage.removeItem('metepassword')
            }
            
            this.projectListInfodialogVisible = false
        },


        handleRegistApplicat () {
            this.LogindialogVisible = false
            this.isFullImags = true
            
        },

        handleLoginClose () {
            this.LogindialogVisible = false
        },


        handleCloseCooperat () {
            this.modifyStatus = false
            this.isCooperat = false
        },

        handleCloseImges () {
            this.infoIndex = 1
            this.isFullImags = false
            
            this.enfname = ''
            this.enlname = ''
            this.enaddress = ''
            this.ennumber = ''
            this.enlocation = ''
            this.ensubject = ''
            this.enenquiry = ''
            this.cnname = '' //姓名
            this.cnaddress = '' //所在地
            this.cnemail = '' //邮箱
            this.cnphone = '' //电话
            this.cnsubject = '' //主题
            this.cnenquiry = '' //内容
            // document.exitFullscreen()
        },

        // toggleFullScreen() {

        //     if (!document.fullscreenElement) {
        //         document.documentElement.requestFullscreen().catch(err => {
        //             alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`)
        //         })
        //     } else {
        //         if (document.exitFullscreen) {
        //             document.exitFullscreen()
        //         }
        //     }
        // },


        globalKeyDown(event) {
            if (event.key === 'ArrowLeft') {
                // console.log('左键被按下');
                // 处理左键逻辑
                this.prevImageSlide();
            } else if (event.key === 'ArrowRight') {
                // console.log('右键被按下');
                // 处理右键逻辑
                this.nextImageSlide();
                
            } else if (event.key === 'F5') {
                this.$router.push({
                    path: '/recommendList',
                })
            }
            // else if (event.key === 'Escape') {
            //     this.escCount++; // 增加ESC键按下的次数计数
            //     if (this.escCount >= 2) { // 如果按了两次ESC键，则退出全屏并重置计数器
            //         document.exitFullscreen()
            //         window.removeEventListener('wheel', this.addMouseWheelListener)
            //         this.$router.push({
            //             path: '/projectList',
            //         })
            //         this.escCount = 0; // 重置计数器
            //     } else { // 如果未达到两次，则不执行任何操作，等待下一次按键事件来增加计数器
            //         setTimeout(() => this.escCount = 0, 500); // 延迟重置计数器，以防误操作（用户可能只是想关闭菜单等）
            //     }
            //     // 按下esc
            //     // console.log('121')
            //     // $Modal.remove()
                
            // } else {
            //     this.escCount = 0
            // }
        },

        handelImagePreviewClose () {
            this.$router.push({
             path: '/recommendList',
            })
            document.exitFullscreen()
            window.removeEventListener('wheel', this.addMouseWheelListener)
            
        },

        handelImagesExitFullscreen () {
           if ((this.activeIndex + 1) == this.contectList.length) {
                document.exitFullscreen()
                window.removeEventListener('wheel', this.ImageMouseWheelListener)
                this.$router.push({
                    path: '/recommendList',
                })
           }
           
        },

        handleArrowClick (value) {
            this.activeIndex = value
        },


        addMouseWheelListener() {
            this.$nextTick(() => {
                const carouselEl = this.$refs.carousel.$el; // 获取 Carousel 元素的引用
                carouselEl.addEventListener('wheel', (event) => {
                
                    if (this.isRollerSpeed) {
                        if (event.deltaY < 0) {
                        // 向前滚动（向上）
                            this.prevImageSlide();
                        } else {
                        // 向后滚动（向下）
                            this.nextImageSlide();
                        
                        }
                    }
                    this.isRollerSpeed = false
                    setTimeout(() => {
                        this.isRollerSpeed = true
                        event.preventDefault()
                    }, 1500)
                })
            
                
            });
        },

        nextImageSlide() {
            // console.log(this.detailObj.imgs.length)

            if ((this.activeIndex + 1) < this.contectList.length) {
                
                this.activeIndex = (this.activeIndex + 1) % this.contectList.length
                this.$refs.carousel.next(); // 调用 Carousel 的 next 方法
                // console.log('加'+this.activeIndex)
            }
            
            
        },
        prevImageSlide() {

            if (this.activeIndex > 0) {
                this.activeIndex = (this.activeIndex - 1) % this.contectList.length
                this.$refs.carousel.prev(); // 调用 Carousel 的 prev 方法
                // console.log('减'+this.activeIndex)
            }
            
        },
    }
}
</script>

<style scoped lang="scss">

.contect .project-commission-header {
    text-align: center;
    padding-top: 74px;
}
.contect .project-commission-header h1 {
    font-size: 32px;
    line-height: 1;
    font-family: 'ahronbd';
}
.contect .project-commission-header h2 {
    font-size: 28px;
    line-height: 1;
    font-family: 'SourceHanSansBOLD';
}
.contect .project-commission-text {
    font-size: 24px;
    line-height: 1.2;
    text-align: center;
    font-family: 'SourceHanSansBOLD';
    padding-top: 29px;
}
.contect .project-commission-en-text {
    text-align: center;
    padding-top: 20px;
}
.contect .project-commission-en-text p{
    font-size: 20px;
    line-height: 1.3;
    font-family: 'ahronbd';
}
.contect .wechat-modle {
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.contect .wechat-mail-box {
    // width: 40%;
    text-align: right;
    // padding-left: 20%;
    // text-align: center;
    box-sizing: border-box;
}
.contect .wechat-mail-box h1 {
    font-size: 40px;
    line-height: 1;
    font-family: 'ahronbd';
}
.contect .wechat-mail-box h2 {
    font-size: 44px;
    line-height: 1;
    font-family: 'ahronbd';
}
.contect .wechat-box {
    padding-top: 73px;
}
.contect .wechat-box h1 {
    padding-bottom: 0.2vw;
}
.contect .wechat-box h1 strong{
    font-size: 28px;
    line-height: 1;
    font-family: 'ahronbd';
    padding-right: 1%;
}
.contect .wechat-box h1 span {
    font-size: 28px;
    line-height: 1;
    font-family: 'SourceHanSansBOLD';
}
.contect .wechat-box img{
    width: 170px;
    // height: 12vw;
}
.commission-line-info {
    // width: 60%;
    // box-sizing: border-box;
}

.contect .agreement-model {
    width: 790px;
    padding: 20px 30px;
    background: #fff;
    position: relative;
    margin: auto;
}
.contect .agreement-table {
    width: 100%;
    margin-top: 10px;
}
.contect .agreement-table tr td {
    border: 1.5px solid #B4B4B4;
    // box-sizing: border-box;
    font-size: 14px;
    color: #333;
    font-family: '微软雅黑';
    padding: 8px 8px;
}
.contect .agreement-en-model tr td {
    border: 1.5px solid #909090;
}

.contect::v-deep .el-button--primary {
    background-color: #000;
}

.contect .contect-mian {
    width: 100%;
    height: 100vh;
}
.contect .contect-mian img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.contect.Image-Preview-box {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #e8e8e8;
    z-index: 99;
}


.contect .Image-Preview-box {
    width: 100%;
    height: 100vh;
    overflow: hidden;
}
.contect .Image-Preview-box::v-deep .el-carousel__container {
    height: 100vh;
}
.contect .Image-Preview-box::v-deep .el-carousel__button {
   background: #000;
   width: 40px;
   height: 4px;
   opacity: 0.2;
}
.contect .Image-Preview-box::v-deep .is-active .el-carousel__button {
     opacity: 1;
}
.contect .Image-Preview-box::v-deep .el-carousel__indicators--horizontal {
    bottom: 40px;
}
.contect .Image-Preview-box img{
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.contect .silder-box-list {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    
}
.contect .silder-box-list ul {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: calc(100% - 78px);
    margin: auto;
}
.contect .silder-box-list li {
    width: 28%;
    height: 28vh;
    float: left;
    margin-right: 4%;
    margin-top: -9vh;
    cursor: pointer;
 
    position: relative;
}
.contect .silder-box-list li:last-child {
    margin-right: 0;
}
.Image-Preview-full-box {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 999;
}
.Image-Preview-full-box img {
    width: 100%;
    height: 100%;
    // object-fit: cover;
}
.Image-Preview-framework  {
    background: rgba(0,0,0,0.4);
}
// .Image-Preview-framework img {
//     object-fit: fill;
// }
.contect .trigger-model {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
}
.contect .trigger-model .black_circle {
    width: 31px;
    height: 26px;
    position: absolute;
    top: -14px;
    left: -2px;
    animation: zoomEffect 1.5s infinite alternate;
}
.contect .trigger-model .black_hands {
    width: 40px;
}
.contect .trigger-model .black_hands.mvoehands {
    animation: moveUpDown 1.5s infinite alternate; 
}
.project-contact-info {
    // position: absolute;
    // right: 131px;
    // bottom: 4vh;
    width: 886px;
    // width: 80%;
    padding-left: 80px;
    padding-top: 40px;
    // transform: scale();
    position: relative;
}
.project-contact-info-Pixel_one {
    // bottom: 10vh;
}
.projectContactTrac{

    transform: scale(0.75);
    right: 0px;
    bottom: 5vh;
}

.projectContactTracTree{
    transform: scale(0.7);
    right: 0px;
    bottom: 6.2vh;
}
.projectContactTracFoure {
    transform: scale(0.9);
    // margin-top: 2vw;
    margin-left: 2vw;
    // bottom: 17.5vh;
    // right: 17%;
}
.projectContactTracFive {
    transform: scale(0.6);
    bottom: 12vh;
}
.projectContactTracSix {
    transform: scale(0.5);
    bottom: 18.5vh;
}
.projectContactTracSven {
    transform: scale(0.8);
    bottom: 3.5vh;
}



/* 语言切换按钮 */
.language-toggle {
    display: flex;
    gap: 10px;
    margin-bottom: 40px;
}

.language-btn {
    padding: 10px 58px;
    border: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease;
    border-radius: 25px;
    white-space: nowrap;
}
.language-btn:nth-child(1) {
    margin-right: 13px;
}

/* English按钮样式 - 黑底白字 */
.language-btn[data-lang="en"] {
    
    background-color: #e0e0e0;
    color: #333;
}

/* Chinese按钮样式 - 灰底黑字 */
.language-btn[data-lang="zh"] {
    background-color: #e0e0e0;
    color: #333;
}

/* 激活状态 */
.language-btn.active {

    background: rgba(0,0,0,0.2);

    background-color: #1a1a1a;
    color: white;
}

/* 未激活状态的悬停效果 */
.language-btn:not(.active):hover {
    opacity: 0.8;
    transform: scale(1.02);
}

/* 表单容器 */
.project-contact-info .form-container {

    width: 100%;
    border-radius: 10px;
}

.form-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 30px;
    color: #333;
}

/* 姓名输入区域 */
.name-row {
    display: flex;
    // gap: 20px;
    margin-bottom: 18px;
}

.name-field {
    flex: 1;
    margin-right: 20px;
}
.name-field:nth-child(2) {
    margin-right: 0;
}

/* 表单标签 */
.project-contact-info label {
    display: block;
    margin-bottom: 2px;
    height: 21px;
    font-size: 16px;
    font-weight: 700;
    color: #333;
}

.project-contact-info label .required {
    color: #666;
    margin-left: 10px;
    font-size: 14px;
    font-weight: 700;
}

/* 输入框样式 */
.project-contact-info input[type="text"],
.project-contact-info input[type="email"],
.project-contact-info input[type="tel"],
.project-contact-info textarea {
    width: 96%;
    padding: 7px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.3s ease;
    outline: none;
    background-color: #f5f5f5;
}

.project-contact-info input[type="text"]:focus,
.project-contact-info input[type="email"]:focus,
.project-contact-info input[type="tel"]:focus,
.project-contact-info textarea:focus {
    border-color: #0066cc;
}

.project-contact-info input[type="text"]:hover,
.project-contact-info input[type="email"]:hover,
.project-contact-info input[type="tel"]:hover,
.project-contact-info textarea:hover {
    border-color: #999;
}

/* 姓名输入框的占位符 */
.project-contact-info input[type="text"]::placeholder {
    color: #aaa;
}

/* 单独的标签样式 */
.form-label {
    font-size: 13px;
    color: #666;
    margin-bottom: 6px;
    display: block;
}

.form-label .required {
    color: #ff4444;
}

/* Name标签样式 */
.name-label {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 2px;
    height: 20px;
}

/* 提交按钮 */
.submit-btn {
    background-color: #4F81BD;
    color: white;
    border: none;
    height: 40px;
    line-height: 40px;
    // width: 113px;
    padding: 0px 20px;
    border-radius: 4px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.submit-btn:hover {
    background-color: #4F81BD;
}

.submit-btn:active {
    background-color: #4F81BD;
}
.contect::v-deep .customerDialogModel .descript-label {
    width: 150px;
    font-size:18px;
    color: #000;
    text-align: right;
    font-family: 'SourceHanSansMEDIUM';
    background: #f9f9f9;
    // font-weight: 700;
}
.contect::v-deep .InfomatCustomerDialogModel {
    background: #f9f9f9;
}
.contect::v-deep .customerEnDialogModel .descript-label {
    width: 290px;
    font-size:18px;
    color: #000;
    text-align: right;
    font-weight: 700;
    font-family: 'Arial';
}
.contect::v-deep .el-date-editor .el-range-separator {
    width: 15%;
    font-size: 18px;
}
.must-lable i {
    display: inline-block;
    font-size: 20px;
    font-style: normal;
    color: red;
    margin-right: 5px;
}

.contect::v-deep .el-input__inner {
    font-size: 18px;
    font-family: 'Arial';
    font-weight: 500;
}
.contect::v-deep .modifyInput .el-input__inner {
    font-size: 14px;
    font-family: '微软雅黑';
    font-weight: 500;
    border: none
}
.contect::v-deep .modifyInputColor .el-input__inner {
    color: #503d96;
}
.contect::v-deep .el-textarea__inner {
    font-size: 18px;
    font-family: 'Arial';
    font-weight: 500;
}
.contect::v-deep .autosizeText .el-textarea__inner {
    font-size: 14px;
    font-family: '微软雅黑';
    font-weight: 500;
    color: #503d96;
}
.contect::v-deep  .el-radio__inner {
    width: 18px;
    height: 18px;
    font-family: 'Arial';
    font-weight: 500;
}
.contect::v-deep .el-radio__input.is-checked+.el-radio__label {
    font-size: 18px;
    font-family: 'Arial';
    font-weight: 500;
}
.contect::v-deep .el-avatar, .contect::v-deep .el-cascader-panel, .contect::v-deep .el-radio, .contect::v-deep .el-radio--medium.is-bordered .el-radio__label, .contect::v-deep .el-radio__label {
    font-size: 18px;
    font-family: 'Arial';
    font-weight: 500;
}
.contect::v-deep  .el-checkbox__label {
    font-size: 18px;
    font-family: 'Arial';
    font-weight: 500;
}
.contect .upload-project-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.contect .upload-project-file::v-deep .el-upload {
    width: 100%;
    height: 100%;
}
.contect::v-deep .customerDialogModel .el-dialog__footer{
    text-align: center;
}
.contect .customerDialogModel .dialog-header {
    font-size: 20px;
    font-weight: 700;
    font-family: "SourceHanSans";
    margin-left: 14px;
}
.contect .customerDialogModel .dialog-header-en {
    font-size: 20px;
    font-weight: 700;
    font-family: "Arial";
    margin-left: 31px;
}
.contect .uploadCustomer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    font-family: 'Arial';
    font-weight: 500;
}
.contect::v-deep .el-date-editor .el-range-input {
    font-size: 18px;
}
.contect .fullScreenImg {
    text-align: center;
}

.contect::v-deep input[type="number"] {
    /* 移除默认样式 */
    -moz-appearance: textfield; /* Firefox */
    appearance: none; /* 其他浏览器 */
    outline: none; /* 移除轮廓（焦点时的蓝色边框） */
    background: transparent; /* 背景透明 */
    /* 添加自定义样式 */
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;

}

/* 移除上下箭头 */
.contect::v-deep input[type="number"]::-webkit-outer-spin-button,
.contect::v-deep input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
}

.contect::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #000;
    font-size: 25px;
    // margin-right: 13px;
}
.contect::v-deep .el-dialog__headerbtn {
    top: 10px;
    right: 10px;
}

.contect::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
}

.contect::v-deep .el-dialog__footer {
    text-align: center;
}

.contect .dialog-header-login {
    text-align: center;
}
.contect .dialog-header-login h1 {
    font-size: 28px;
    font-family: 'ahronbd';
}
.contect .dialog-header-login h2 {
    font-size: 16px;
}
.contect .loginInput-model {
    margin-bottom: 20px;
}

.contect::v-deep .prefixIcon {
    color: #000;
    font-size: 18px;
}
.contect .login-content {
    width: 80%;
    margin: auto;
    padding: 5px 40px 0px 40px;
    // border-radius: 10px;
    // box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
}
.contect .login-content::v-deep .el-input__inner {
    // border: none;
    border-radius: 3px;
    // border-bottom: 1px solid #DCDFE6;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    font-size: 15px;
    /* font-family: 'SourceHanSans'!important;
    /* !important; */
}
.contect::v-deep .LoginDialogModel .el-dialog__body{
    // border-top: 1px solid #DCDFE6;
    padding: 16px 20px 50px 20px;
}
.contect::v-deep .EditProjectDialogModel .el-dialog__body{
    padding: 2px 20px;
}
.contect::v-deep .customerprojectLisDialogModel .el-dialog__body{
    padding: 2px 33px;
}

.contect::v-deep .customerprojectLisDialogModel .el-dialog__header {
    padding: 20px 20px 0px 10px;
}

.contect::v-deep .tabsCnModel .el-tabs__item {
    font-size: 18px;
    color: #595959;
    font-family: 'SourceHanSansMEDIUM';
}
.contect::v-deep .tabsCnModel .el-tabs__nav-wrap::after {
   margin-left: 10px;
}
.contect::v-deep .tabsCnModel .el-tabs__item.is-active {
    color: #000;
    font-family: 'SourceHanSansBOLD';
}
.contect::v-deep .tabsCnModel .el-tabs__active-bar {
    background-color: #E4E7ED;
    left: 5%;
}
.contect::v-deep .tabsCnModel .el-table .el-table__cell {
    padding: 4px 0;
    font-size: 16px;
}
.contect::v-deep .tabsCnModel .el-table th.el-table__cell>.cell {
    font-size: 16px;
}

.contect::v-deep .tabsmodel .el-tabs__item {
    font-size: 18px;
    font-family: 'Arial';
    color: #595959;
}
.contect::v-deep .tabsmodel .el-tabs__nav-wrap::after {
    margin-left: 10px;
}
.contect::v-deep .tabsmodel .el-table th.el-table__cell>.cell {
    font-size: 16px;
    font-family: 'Arial';
}
.contect::v-deep .tabsmodel .el-table .el-table__cell {
    padding: 4px 0;
    font-size: 16px;
}

.contect::v-deep .tabsmodel .el-tabs__item.is-active {
    color: #000;
    font-family: 'Arial';
    font-weight: 700;
}
.contect::v-deep .tabsmodel .el-tabs__active-bar {
    background-color: #E4E7ED;
    left: 5%;
}
.contect::v-deep .vue-office-pdf-wrapper {
    background: #fff!important;
    padding: 0px 0px!important;
}
.contect::v-deep .el-descriptions .is-bordered .el-descriptions-item__cell {
    background: #f9f9f9;
    border: none;
    border-bottom: 1px solid #EBEEF5;
}

.contect .transformFull {
    transform-origin: center top;
}
.contect::v-deep .promptBox .el-dialog__body {
    padding: 10px 20px 30px 20px;
}
.contect::v-deep .promptBox .el-dialog__footer {
    padding: 10px 20px 35px;
}



.modelHeight {
    // height: 600px;
    width: 1100px;
    // max-width: 1200px;
    margin: auto;
    // min-height: 600px;
}



// .custom-confirm-class .el-message-box__message p {
//     margin: 0;
//     line-height: 24px;
//     font-size: 18px;
//     font-family: 'ahronbd';
// }


@keyframes moveUpDown {
  0% {
    transform: translateY(0); /* 初始位置，即在顶部 */
  }
  50% {
    transform: translateY(5%); /* 移动到容器高度的100%，即底部 */
  }
  100% {
    transform: translateY(0); /* 返回到初始位置，即在顶部 */
  }
}
@keyframes zoomEffect {
  0% {
    transform: scale(1); /* 初始大小，无缩放 */
  }
  50% {
    transform: scale(0.8); /* 在50%时缩小到一半大小 */
  }
}
</style>